"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundingMode = exports.RoleType = exports.Reason = exports.PutRmaItemType = exports.PurchaseOrderItemStatus = exports.ProductType = exports.ProductStock = exports.ProductInvStatus = exports.PhysicalPackagingTypeEnum = exports.PackageTypeType = exports.OrganizationUserPermissionType = exports.OrganizationStatus = exports.OrderUnresolvedStatus = exports.OrderType = exports.OrderStatus = exports.OrderCancelReasonDtoType = exports.NotificationPreferences = exports.Month = exports.LiabilityType = exports.InventoryOptions = exports.InternationalNonDeliveryAction = exports.InsuranceProvider = exports.IncotermShippingRule2Enum = exports.GetCustomFieldDefType = exports.FraudAnalysis = exports.Format = exports.FbaShipmentStatus = exports.EmailPreferences = exports.DiscountType = exports.DeliveryStatus = exports.DeliveryConfirmation = exports.DefaultUnpackMode = exports.DayOfWeek = exports.CustomsDocument = exports.CustomsDeclarationType = exports.CustomShipBillingOption = exports.Currency = exports.CreatePurchaseOrderType = exports.CreatePurchaseOrderStatus = exports.CountryEnum = exports.CostType = exports.CostSourceType = exports.CompanyStatusEnum = exports.CompanySettingType = exports.CompanyContactType = exports.BoxContentsFormat = exports.BatchedOrderStatus = exports.AutoPoRounding = exports.AddressTypeEnum = exports.Action = void 0;
exports.WeightUnitOfMeasure = exports.WeightUnit = exports.WarehouseTypeEnum = exports.TimeDefinition = exports.ThirdPartyLogisticsSettingType = exports.ThirdPartyLogisticsProviderType = exports.SubType = exports.StockTransferOrderItemDtoStatus = exports.StockTransferOrderDtoStatus = exports.StockLocation2 = exports.SpecialService = exports.SortField2 = exports.SortField = exports.SortDirection = exports.ShippingStatusId = exports.ShippingStates = exports.ShippingServiceType = exports.ShippingProviderTypeType = exports.ShippingCarrierType = exports.ShipmentType = exports.SellerFreightClass = exports.SalesChannelTypeEnum = void 0;
var Action;
(function (Action) {
    Action["WRITE_OFF"] = "WRITE_OFF";
    Action["REINSERT"] = "REINSERT";
    Action["REINSERT_WITH_NEW_PACKAGING"] = "REINSERT_WITH_NEW_PACKAGING";
})(Action = exports.Action || (exports.Action = {}));
var AddressTypeEnum;
(function (AddressTypeEnum) {
    AddressTypeEnum["UNKNOWN"] = "UNKNOWN";
    AddressTypeEnum["RESIDENTIAL"] = "RESIDENTIAL";
    AddressTypeEnum["COMMERCIAL"] = "COMMERCIAL";
})(AddressTypeEnum = exports.AddressTypeEnum || (exports.AddressTypeEnum = {}));
var AutoPoRounding;
(function (AutoPoRounding) {
    AutoPoRounding["EXACT"] = "EXACT";
    AutoPoRounding["ROUND_UP"] = "ROUND_UP";
    AutoPoRounding["ROUND_PROPERLY"] = "ROUND_PROPERLY";
})(AutoPoRounding = exports.AutoPoRounding || (exports.AutoPoRounding = {}));
var BatchedOrderStatus;
(function (BatchedOrderStatus) {
    BatchedOrderStatus["PENDING"] = "PENDING";
    BatchedOrderStatus["SHIPPED"] = "SHIPPED";
    BatchedOrderStatus["FAILED"] = "FAILED";
    BatchedOrderStatus["CANCELLED"] = "CANCELLED";
})(BatchedOrderStatus = exports.BatchedOrderStatus || (exports.BatchedOrderStatus = {}));
var BoxContentsFormat;
(function (BoxContentsFormat) {
    BoxContentsFormat["NONE"] = "NONE";
    BoxContentsFormat["FEED"] = "FEED";
    BoxContentsFormat["BARCODE"] = "BARCODE";
})(BoxContentsFormat = exports.BoxContentsFormat || (exports.BoxContentsFormat = {}));
var CompanyContactType;
(function (CompanyContactType) {
    CompanyContactType["ADMIN"] = "ADMIN";
    CompanyContactType["BILLING"] = "BILLING";
    CompanyContactType["OPERATIONS"] = "OPERATIONS";
    CompanyContactType["TECHNICAL"] = "TECHNICAL";
})(CompanyContactType = exports.CompanyContactType || (exports.CompanyContactType = {}));
var CompanySettingType;
(function (CompanySettingType) {
    CompanySettingType["PRODUCT_WEIGHT_AND_DIMS_AUTO_UPDATE"] = "PRODUCT_WEIGHT_AND_DIMS_AUTO_UPDATE";
    CompanySettingType["DEFAULT_BOX_CONTENT_MEASUREMENTS"] = "DEFAULT_BOX_CONTENT_MEASUREMENTS";
    CompanySettingType["BLOCK_PICKED_ORDER_ITEM_EDITS"] = "BLOCK_PICKED_ORDER_ITEM_EDITS";
    CompanySettingType["LOG_AVAILABLE_STOCK_ORDERBOT_RANK_EXECUTION"] = "LOG_AVAILABLE_STOCK_ORDERBOT_RANK_EXECUTION";
    CompanySettingType["UK_VAT_NUMBER"] = "UK_VAT_NUMBER";
    CompanySettingType["AUTOMATED_RETURNS_RECEIVING_WAREHOUSE_ID"] = "AUTOMATED_RETURNS_RECEIVING_WAREHOUSE_ID";
})(CompanySettingType = exports.CompanySettingType || (exports.CompanySettingType = {}));
var CompanyStatusEnum;
(function (CompanyStatusEnum) {
    CompanyStatusEnum["TRIAL_PERIOD"] = "TRIAL_PERIOD";
    CompanyStatusEnum["ACTIVE"] = "ACTIVE";
    CompanyStatusEnum["DEACTIVATED_BY_USER"] = "DEACTIVATED_BY_USER";
    CompanyStatusEnum["SUSPENDED_FOR_BILLING"] = "SUSPENDED_FOR_BILLING";
    CompanyStatusEnum["SUSPENDED_FOR_VIOLATING_TOS"] = "SUSPENDED_FOR_VIOLATING_TOS";
    CompanyStatusEnum["APP_TESTING_PERIOD"] = "APP_TESTING_PERIOD";
})(CompanyStatusEnum = exports.CompanyStatusEnum || (exports.CompanyStatusEnum = {}));
var CostSourceType;
(function (CostSourceType) {
    CostSourceType["UNDEFINED"] = "UNDEFINED";
    CostSourceType["COGS_FIFO_QUEUE"] = "COGS_FIFO_QUEUE";
    CostSourceType["VENDOR_PRODUCT"] = "VENDOR_PRODUCT";
    CostSourceType["DEFAULT_PRODUCT_COST"] = "DEFAULT_PRODUCT_COST";
    CostSourceType["INVENTORY_ADDITION"] = "INVENTORY_ADDITION";
    CostSourceType["ROLL_UP_FROM_BREAKDOWN"] = "ROLL_UP_FROM_BREAKDOWN";
    CostSourceType["REINSERTED_INVENTORY"] = "REINSERTED_INVENTORY";
})(CostSourceType = exports.CostSourceType || (exports.CostSourceType = {}));
var CostType;
(function (CostType) {
    CostType["PO_FIFO_QUEUE"] = "PO_FIFO_QUEUE";
    CostType["VENDOR_PRODUCT"] = "VENDOR_PRODUCT";
    CostType["DEFAULT_VENDOR_COST"] = "DEFAULT_VENDOR_COST";
    CostType["UNDEFINED"] = "UNDEFINED";
})(CostType = exports.CostType || (exports.CostType = {}));
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["ABW"] = "ABW";
    CountryEnum["AFG"] = "AFG";
    CountryEnum["AGO"] = "AGO";
    CountryEnum["AIA"] = "AIA";
    CountryEnum["ALA"] = "ALA";
    CountryEnum["ALB"] = "ALB";
    CountryEnum["AND"] = "AND";
    CountryEnum["ARE"] = "ARE";
    CountryEnum["ARG"] = "ARG";
    CountryEnum["ARM"] = "ARM";
    CountryEnum["ASM"] = "ASM";
    CountryEnum["ATA"] = "ATA";
    CountryEnum["ATF"] = "ATF";
    CountryEnum["ATG"] = "ATG";
    CountryEnum["AUS"] = "AUS";
    CountryEnum["AUT"] = "AUT";
    CountryEnum["AZE"] = "AZE";
    CountryEnum["BDI"] = "BDI";
    CountryEnum["BEL"] = "BEL";
    CountryEnum["BEN"] = "BEN";
    CountryEnum["BES"] = "BES";
    CountryEnum["BFA"] = "BFA";
    CountryEnum["BGD"] = "BGD";
    CountryEnum["BGR"] = "BGR";
    CountryEnum["BHR"] = "BHR";
    CountryEnum["BHS"] = "BHS";
    CountryEnum["BIH"] = "BIH";
    CountryEnum["BLM"] = "BLM";
    CountryEnum["BLR"] = "BLR";
    CountryEnum["BLZ"] = "BLZ";
    CountryEnum["BMU"] = "BMU";
    CountryEnum["BOL"] = "BOL";
    CountryEnum["BRA"] = "BRA";
    CountryEnum["BRB"] = "BRB";
    CountryEnum["BRN"] = "BRN";
    CountryEnum["BTN"] = "BTN";
    CountryEnum["BVT"] = "BVT";
    CountryEnum["BWA"] = "BWA";
    CountryEnum["CAF"] = "CAF";
    CountryEnum["CAN"] = "CAN";
    CountryEnum["CCK"] = "CCK";
    CountryEnum["CHE"] = "CHE";
    CountryEnum["CHL"] = "CHL";
    CountryEnum["CHN"] = "CHN";
    CountryEnum["CIV"] = "CIV";
    CountryEnum["CMR"] = "CMR";
    CountryEnum["COD"] = "COD";
    CountryEnum["COG"] = "COG";
    CountryEnum["COK"] = "COK";
    CountryEnum["COL"] = "COL";
    CountryEnum["COM"] = "COM";
    CountryEnum["CPV"] = "CPV";
    CountryEnum["CRI"] = "CRI";
    CountryEnum["CUB"] = "CUB";
    CountryEnum["CUW"] = "CUW";
    CountryEnum["CXR"] = "CXR";
    CountryEnum["CYM"] = "CYM";
    CountryEnum["CYP"] = "CYP";
    CountryEnum["CZE"] = "CZE";
    CountryEnum["DEU"] = "DEU";
    CountryEnum["DJI"] = "DJI";
    CountryEnum["DMA"] = "DMA";
    CountryEnum["DNK"] = "DNK";
    CountryEnum["DOM"] = "DOM";
    CountryEnum["DZA"] = "DZA";
    CountryEnum["ECU"] = "ECU";
    CountryEnum["EGY"] = "EGY";
    CountryEnum["ERI"] = "ERI";
    CountryEnum["ESH"] = "ESH";
    CountryEnum["ESP"] = "ESP";
    CountryEnum["EST"] = "EST";
    CountryEnum["ETH"] = "ETH";
    CountryEnum["FIN"] = "FIN";
    CountryEnum["FJI"] = "FJI";
    CountryEnum["FLK"] = "FLK";
    CountryEnum["FRA"] = "FRA";
    CountryEnum["FRO"] = "FRO";
    CountryEnum["FSM"] = "FSM";
    CountryEnum["GAB"] = "GAB";
    CountryEnum["GBR"] = "GBR";
    CountryEnum["GEO"] = "GEO";
    CountryEnum["GGY"] = "GGY";
    CountryEnum["GHA"] = "GHA";
    CountryEnum["GIB"] = "GIB";
    CountryEnum["GIN"] = "GIN";
    CountryEnum["GLP"] = "GLP";
    CountryEnum["GMB"] = "GMB";
    CountryEnum["GNB"] = "GNB";
    CountryEnum["GNQ"] = "GNQ";
    CountryEnum["GRC"] = "GRC";
    CountryEnum["GRD"] = "GRD";
    CountryEnum["GRL"] = "GRL";
    CountryEnum["GTM"] = "GTM";
    CountryEnum["GUF"] = "GUF";
    CountryEnum["GUM"] = "GUM";
    CountryEnum["GUY"] = "GUY";
    CountryEnum["HKG"] = "HKG";
    CountryEnum["HMD"] = "HMD";
    CountryEnum["HND"] = "HND";
    CountryEnum["HRV"] = "HRV";
    CountryEnum["HTI"] = "HTI";
    CountryEnum["HUN"] = "HUN";
    CountryEnum["IDN"] = "IDN";
    CountryEnum["IMN"] = "IMN";
    CountryEnum["IND"] = "IND";
    CountryEnum["IOT"] = "IOT";
    CountryEnum["IRL"] = "IRL";
    CountryEnum["IRN"] = "IRN";
    CountryEnum["IRQ"] = "IRQ";
    CountryEnum["ISL"] = "ISL";
    CountryEnum["ISR"] = "ISR";
    CountryEnum["ITA"] = "ITA";
    CountryEnum["JAM"] = "JAM";
    CountryEnum["JEY"] = "JEY";
    CountryEnum["JOR"] = "JOR";
    CountryEnum["JPN"] = "JPN";
    CountryEnum["KAZ"] = "KAZ";
    CountryEnum["KEN"] = "KEN";
    CountryEnum["KGZ"] = "KGZ";
    CountryEnum["KHM"] = "KHM";
    CountryEnum["KIR"] = "KIR";
    CountryEnum["KNA"] = "KNA";
    CountryEnum["KOR"] = "KOR";
    CountryEnum["KWT"] = "KWT";
    CountryEnum["LAO"] = "LAO";
    CountryEnum["LBN"] = "LBN";
    CountryEnum["LBR"] = "LBR";
    CountryEnum["LBY"] = "LBY";
    CountryEnum["LCA"] = "LCA";
    CountryEnum["LIE"] = "LIE";
    CountryEnum["LKA"] = "LKA";
    CountryEnum["LSO"] = "LSO";
    CountryEnum["LTU"] = "LTU";
    CountryEnum["LUX"] = "LUX";
    CountryEnum["LVA"] = "LVA";
    CountryEnum["MAC"] = "MAC";
    CountryEnum["MAF"] = "MAF";
    CountryEnum["MAR"] = "MAR";
    CountryEnum["MCO"] = "MCO";
    CountryEnum["MDA"] = "MDA";
    CountryEnum["MDG"] = "MDG";
    CountryEnum["MDV"] = "MDV";
    CountryEnum["MEX"] = "MEX";
    CountryEnum["MHL"] = "MHL";
    CountryEnum["MKD"] = "MKD";
    CountryEnum["MLI"] = "MLI";
    CountryEnum["MLT"] = "MLT";
    CountryEnum["MMR"] = "MMR";
    CountryEnum["MNE"] = "MNE";
    CountryEnum["MNG"] = "MNG";
    CountryEnum["MNP"] = "MNP";
    CountryEnum["MOZ"] = "MOZ";
    CountryEnum["MRT"] = "MRT";
    CountryEnum["MSR"] = "MSR";
    CountryEnum["MTQ"] = "MTQ";
    CountryEnum["MUS"] = "MUS";
    CountryEnum["MWI"] = "MWI";
    CountryEnum["MYS"] = "MYS";
    CountryEnum["MYT"] = "MYT";
    CountryEnum["NAM"] = "NAM";
    CountryEnum["NCL"] = "NCL";
    CountryEnum["NER"] = "NER";
    CountryEnum["NFK"] = "NFK";
    CountryEnum["NGA"] = "NGA";
    CountryEnum["NIC"] = "NIC";
    CountryEnum["NIU"] = "NIU";
    CountryEnum["NLD"] = "NLD";
    CountryEnum["NOR"] = "NOR";
    CountryEnum["NPL"] = "NPL";
    CountryEnum["NRU"] = "NRU";
    CountryEnum["NZL"] = "NZL";
    CountryEnum["OMN"] = "OMN";
    CountryEnum["PAK"] = "PAK";
    CountryEnum["PAN"] = "PAN";
    CountryEnum["PCN"] = "PCN";
    CountryEnum["PER"] = "PER";
    CountryEnum["PHL"] = "PHL";
    CountryEnum["PLW"] = "PLW";
    CountryEnum["PNG"] = "PNG";
    CountryEnum["POL"] = "POL";
    CountryEnum["PRI"] = "PRI";
    CountryEnum["PRK"] = "PRK";
    CountryEnum["PRT"] = "PRT";
    CountryEnum["PRY"] = "PRY";
    CountryEnum["PSE"] = "PSE";
    CountryEnum["PYF"] = "PYF";
    CountryEnum["QAT"] = "QAT";
    CountryEnum["REU"] = "REU";
    CountryEnum["ROU"] = "ROU";
    CountryEnum["RUS"] = "RUS";
    CountryEnum["RWA"] = "RWA";
    CountryEnum["SAU"] = "SAU";
    CountryEnum["SDN"] = "SDN";
    CountryEnum["SEN"] = "SEN";
    CountryEnum["SGP"] = "SGP";
    CountryEnum["SGS"] = "SGS";
    CountryEnum["SHN"] = "SHN";
    CountryEnum["SJM"] = "SJM";
    CountryEnum["SLB"] = "SLB";
    CountryEnum["SLE"] = "SLE";
    CountryEnum["SLV"] = "SLV";
    CountryEnum["SMR"] = "SMR";
    CountryEnum["SOM"] = "SOM";
    CountryEnum["SPM"] = "SPM";
    CountryEnum["SRB"] = "SRB";
    CountryEnum["SSD"] = "SSD";
    CountryEnum["STP"] = "STP";
    CountryEnum["SUR"] = "SUR";
    CountryEnum["SVK"] = "SVK";
    CountryEnum["SVN"] = "SVN";
    CountryEnum["SWE"] = "SWE";
    CountryEnum["SWZ"] = "SWZ";
    CountryEnum["SXM"] = "SXM";
    CountryEnum["SYC"] = "SYC";
    CountryEnum["SYR"] = "SYR";
    CountryEnum["TCA"] = "TCA";
    CountryEnum["TCD"] = "TCD";
    CountryEnum["TGO"] = "TGO";
    CountryEnum["THA"] = "THA";
    CountryEnum["TJK"] = "TJK";
    CountryEnum["TKL"] = "TKL";
    CountryEnum["TKM"] = "TKM";
    CountryEnum["TLS"] = "TLS";
    CountryEnum["TON"] = "TON";
    CountryEnum["TTO"] = "TTO";
    CountryEnum["TUN"] = "TUN";
    CountryEnum["TUR"] = "TUR";
    CountryEnum["TUV"] = "TUV";
    CountryEnum["TWN"] = "TWN";
    CountryEnum["TZA"] = "TZA";
    CountryEnum["UGA"] = "UGA";
    CountryEnum["UKR"] = "UKR";
    CountryEnum["UMI"] = "UMI";
    CountryEnum["URY"] = "URY";
    CountryEnum["USA"] = "USA";
    CountryEnum["UZB"] = "UZB";
    CountryEnum["VAT"] = "VAT";
    CountryEnum["VCT"] = "VCT";
    CountryEnum["VEN"] = "VEN";
    CountryEnum["VGB"] = "VGB";
    CountryEnum["VIR"] = "VIR";
    CountryEnum["VNM"] = "VNM";
    CountryEnum["VUT"] = "VUT";
    CountryEnum["WLF"] = "WLF";
    CountryEnum["WSM"] = "WSM";
    CountryEnum["YEM"] = "YEM";
    CountryEnum["ZAF"] = "ZAF";
    CountryEnum["ZMB"] = "ZMB";
    CountryEnum["ZWE"] = "ZWE";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var CreatePurchaseOrderStatus;
(function (CreatePurchaseOrderStatus) {
    CreatePurchaseOrderStatus["AWAITING_AUTHORIZATION"] = "AWAITING_AUTHORIZATION";
    CreatePurchaseOrderStatus["AWAITING_VENDOR_CONFIRMATION"] = "AWAITING_VENDOR_CONFIRMATION";
    CreatePurchaseOrderStatus["AWAITING_MODIFICATION_ACCEPTANCE"] = "AWAITING_MODIFICATION_ACCEPTANCE";
    CreatePurchaseOrderStatus["PENDING_DELIVERY"] = "PENDING_DELIVERY";
    CreatePurchaseOrderStatus["PARTIALLY_DELIVERED"] = "PARTIALLY_DELIVERED";
    CreatePurchaseOrderStatus["FULFILLED"] = "FULFILLED";
    CreatePurchaseOrderStatus["CLOSED_SHORT"] = "CLOSED_SHORT";
    CreatePurchaseOrderStatus["VOIDED"] = "VOIDED";
    CreatePurchaseOrderStatus["CANCELLED"] = "CANCELLED";
})(CreatePurchaseOrderStatus = exports.CreatePurchaseOrderStatus || (exports.CreatePurchaseOrderStatus = {}));
var CreatePurchaseOrderType;
(function (CreatePurchaseOrderType) {
    CreatePurchaseOrderType["INBOUND"] = "INBOUND";
    CreatePurchaseOrderType["OUTBOUND"] = "OUTBOUND";
    CreatePurchaseOrderType["AMAZON_OUTBOUND"] = "AMAZON_OUTBOUND";
    CreatePurchaseOrderType["DROPSHIP_ORDER"] = "DROPSHIP_ORDER";
})(CreatePurchaseOrderType = exports.CreatePurchaseOrderType || (exports.CreatePurchaseOrderType = {}));
var Currency;
(function (Currency) {
    Currency["AFN"] = "AFN";
    Currency["AED"] = "AED";
    Currency["ALL"] = "ALL";
    Currency["AMD"] = "AMD";
    Currency["ANG"] = "ANG";
    Currency["AOA"] = "AOA";
    Currency["ARS"] = "ARS";
    Currency["AUD"] = "AUD";
    Currency["AWG"] = "AWG";
    Currency["AZN"] = "AZN";
    Currency["BAM"] = "BAM";
    Currency["BBD"] = "BBD";
    Currency["BDT"] = "BDT";
    Currency["BGN"] = "BGN";
    Currency["BHD"] = "BHD";
    Currency["BIF"] = "BIF";
    Currency["BMD"] = "BMD";
    Currency["BND"] = "BND";
    Currency["BOB"] = "BOB";
    Currency["BOV"] = "BOV";
    Currency["BRL"] = "BRL";
    Currency["BSD"] = "BSD";
    Currency["BTN"] = "BTN";
    Currency["BWP"] = "BWP";
    Currency["BZD"] = "BZD";
    Currency["CAD"] = "CAD";
    Currency["CDF"] = "CDF";
    Currency["CHE"] = "CHE";
    Currency["CHF"] = "CHF";
    Currency["CHW"] = "CHW";
    Currency["CLF"] = "CLF";
    Currency["CLP"] = "CLP";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["COU"] = "COU";
    Currency["CRC"] = "CRC";
    Currency["CUC"] = "CUC";
    Currency["CUP"] = "CUP";
    Currency["CVE"] = "CVE";
    Currency["CZK"] = "CZK";
    Currency["DJF"] = "DJF";
    Currency["DKK"] = "DKK";
    Currency["DOP"] = "DOP";
    Currency["DZD"] = "DZD";
    Currency["EGP"] = "EGP";
    Currency["ERN"] = "ERN";
    Currency["ETB"] = "ETB";
    Currency["EUR"] = "EUR";
    Currency["FJD"] = "FJD";
    Currency["FKP"] = "FKP";
    Currency["GBP"] = "GBP";
    Currency["GEL"] = "GEL";
    Currency["GHS"] = "GHS";
    Currency["GIP"] = "GIP";
    Currency["GMD"] = "GMD";
    Currency["GNF"] = "GNF";
    Currency["GTQ"] = "GTQ";
    Currency["GYD"] = "GYD";
    Currency["HKD"] = "HKD";
    Currency["HNL"] = "HNL";
    Currency["HRK"] = "HRK";
    Currency["HTG"] = "HTG";
    Currency["HUF"] = "HUF";
    Currency["IDR"] = "IDR";
    Currency["ILS"] = "ILS";
    Currency["INR"] = "INR";
    Currency["IQD"] = "IQD";
    Currency["IRR"] = "IRR";
    Currency["ISK"] = "ISK";
    Currency["JMD"] = "JMD";
    Currency["JOD"] = "JOD";
    Currency["JPY"] = "JPY";
    Currency["KES"] = "KES";
    Currency["KGS"] = "KGS";
    Currency["KHR"] = "KHR";
    Currency["KMF"] = "KMF";
    Currency["KPW"] = "KPW";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["KYD"] = "KYD";
    Currency["KZT"] = "KZT";
    Currency["LAK"] = "LAK";
    Currency["LBP"] = "LBP";
    Currency["LKR"] = "LKR";
    Currency["LRD"] = "LRD";
    Currency["LSL"] = "LSL";
    Currency["LYD"] = "LYD";
    Currency["MAD"] = "MAD";
    Currency["MDL"] = "MDL";
    Currency["MGA"] = "MGA";
    Currency["MKD"] = "MKD";
    Currency["MMK"] = "MMK";
    Currency["MNT"] = "MNT";
    Currency["MOP"] = "MOP";
    Currency["MUR"] = "MUR";
    Currency["MVR"] = "MVR";
    Currency["MWK"] = "MWK";
    Currency["MXN"] = "MXN";
    Currency["MXV"] = "MXV";
    Currency["MYR"] = "MYR";
    Currency["MZN"] = "MZN";
    Currency["NAD"] = "NAD";
    Currency["NGN"] = "NGN";
    Currency["NIO"] = "NIO";
    Currency["NOK"] = "NOK";
    Currency["NPR"] = "NPR";
    Currency["NZD"] = "NZD";
    Currency["OMR"] = "OMR";
    Currency["PAB"] = "PAB";
    Currency["PEN"] = "PEN";
    Currency["PGK"] = "PGK";
    Currency["PHP"] = "PHP";
    Currency["PKR"] = "PKR";
    Currency["PLN"] = "PLN";
    Currency["PYG"] = "PYG";
    Currency["QAR"] = "QAR";
    Currency["RON"] = "RON";
    Currency["RSD"] = "RSD";
    Currency["RUB"] = "RUB";
    Currency["RWF"] = "RWF";
    Currency["SAR"] = "SAR";
    Currency["SBD"] = "SBD";
    Currency["SCR"] = "SCR";
    Currency["SDG"] = "SDG";
    Currency["SEK"] = "SEK";
    Currency["SGD"] = "SGD";
    Currency["SHP"] = "SHP";
    Currency["SLL"] = "SLL";
    Currency["SOS"] = "SOS";
    Currency["SRD"] = "SRD";
    Currency["SSP"] = "SSP";
    Currency["SVC"] = "SVC";
    Currency["SYP"] = "SYP";
    Currency["SZL"] = "SZL";
    Currency["THB"] = "THB";
    Currency["TJS"] = "TJS";
    Currency["TMT"] = "TMT";
    Currency["TND"] = "TND";
    Currency["TOP"] = "TOP";
    Currency["TRY"] = "TRY";
    Currency["TTD"] = "TTD";
    Currency["TWD"] = "TWD";
    Currency["TZS"] = "TZS";
    Currency["UAH"] = "UAH";
    Currency["UGX"] = "UGX";
    Currency["USD"] = "USD";
    Currency["USN"] = "USN";
    Currency["UYI"] = "UYI";
    Currency["UYU"] = "UYU";
    Currency["UZS"] = "UZS";
    Currency["VND"] = "VND";
    Currency["VUV"] = "VUV";
    Currency["WST"] = "WST";
    Currency["XAF"] = "XAF";
    Currency["XAG"] = "XAG";
    Currency["XAU"] = "XAU";
    Currency["XBA"] = "XBA";
    Currency["XBB"] = "XBB";
    Currency["XBC"] = "XBC";
    Currency["XBD"] = "XBD";
    Currency["XCD"] = "XCD";
    Currency["XDR"] = "XDR";
    Currency["XOF"] = "XOF";
    Currency["XPD"] = "XPD";
    Currency["XPF"] = "XPF";
    Currency["XPT"] = "XPT";
    Currency["XSU"] = "XSU";
    Currency["XTS"] = "XTS";
    Currency["XUA"] = "XUA";
    Currency["XXX"] = "XXX";
    Currency["YER"] = "YER";
    Currency["ZAR"] = "ZAR";
    Currency["ZMW"] = "ZMW";
    Currency["ZWL"] = "ZWL";
})(Currency = exports.Currency || (exports.Currency = {}));
var CustomShipBillingOption;
(function (CustomShipBillingOption) {
    CustomShipBillingOption["BILL_SHIPPING_TO_MY_ACCOUNT"] = "BILL_SHIPPING_TO_MY_ACCOUNT";
    CustomShipBillingOption["BILL_SHIPPING_TO_RECIPIENT"] = "BILL_SHIPPING_TO_RECIPIENT";
    CustomShipBillingOption["BILL_SHIPPING_TO_THIRD_PARTY"] = "BILL_SHIPPING_TO_THIRD_PARTY";
    CustomShipBillingOption["BILL_SHIPPING_UPON_COLLECT"] = "BILL_SHIPPING_UPON_COLLECT";
})(CustomShipBillingOption = exports.CustomShipBillingOption || (exports.CustomShipBillingOption = {}));
var CustomsDeclarationType;
(function (CustomsDeclarationType) {
    CustomsDeclarationType["NO_CUSTOMS_DECLARATION"] = "NO_CUSTOMS_DECLARATION";
    CustomsDeclarationType["DOCUMENTS_CUSTOMS_DECLARATION"] = "DOCUMENTS_CUSTOMS_DECLARATION";
    CustomsDeclarationType["GIFT_CUSTOMS_DECLARATION"] = "GIFT_CUSTOMS_DECLARATION";
    CustomsDeclarationType["MERCHANDISE_CUSTOMS_DECLARATION"] = "MERCHANDISE_CUSTOMS_DECLARATION";
    CustomsDeclarationType["RETURNED_GOODS_CUSTOMS_DECLARATION"] = "RETURNED_GOODS_CUSTOMS_DECLARATION";
    CustomsDeclarationType["SAMPLE_CUSTOMS_DECLARATION"] = "SAMPLE_CUSTOMS_DECLARATION";
})(CustomsDeclarationType = exports.CustomsDeclarationType || (exports.CustomsDeclarationType = {}));
var CustomsDocument;
(function (CustomsDocument) {
    CustomsDocument["CERTIFICATE_OF_ORIGIN"] = "CERTIFICATE_OF_ORIGIN";
    CustomsDocument["COMMERCIAL_INVOICE"] = "COMMERCIAL_INVOICE";
    CustomsDocument["CUSTOM_PACKAGE_DOCUMENT"] = "CUSTOM_PACKAGE_DOCUMENT";
    CustomsDocument["CUSTOM_SHIPMENT_DOCUMENT"] = "CUSTOM_SHIPMENT_DOCUMENT";
    CustomsDocument["CUSTOMER_SPECIFIED_LABELS"] = "CUSTOMER_SPECIFIED_LABELS";
    CustomsDocument["DANGEROUS_GOODS_SHIPPERS_DECLARATION"] = "DANGEROUS_GOODS_SHIPPERS_DECLARATION";
    CustomsDocument["EXPORT_DECLARATION"] = "EXPORT_DECLARATION";
    CustomsDocument["GENERAL_AGENCY_AGREEMENT"] = "GENERAL_AGENCY_AGREEMENT";
    CustomsDocument["LABEL"] = "LABEL";
    CustomsDocument["NAFTA_CERTIFICATE_OF_ORIGIN"] = "NAFTA_CERTIFICATE_OF_ORIGIN";
    CustomsDocument["OP_900"] = "OP_900";
    CustomsDocument["PENDING_SHIPMENT_EMAIL_NOTIFICATION"] = "PENDING_SHIPMENT_EMAIL_NOTIFICATION";
    CustomsDocument["PRO_FORMA_INVOICE"] = "PRO_FORMA_INVOICE";
    CustomsDocument["RETURN_INSTRUCTIONS"] = "RETURN_INSTRUCTIONS";
    CustomsDocument["FEDEX_FREIGHT_STRAIGHT_BILL_OF_LADING"] = "FEDEX_FREIGHT_STRAIGHT_BILL_OF_LADING";
    CustomsDocument["FREIGHT_ADDRESS_LABEL"] = "FREIGHT_ADDRESS_LABEL";
    CustomsDocument["AIR_WAYBILL"] = "AIR_WAYBILL";
    CustomsDocument["INVOICE"] = "INVOICE";
    CustomsDocument["CUSTOMS_DECLARATION"] = "CUSTOMS_DECLARATION";
    CustomsDocument["ELECTRONIC_EXPORT_INFORMATION"] = "ELECTRONIC_EXPORT_INFORMATION";
    CustomsDocument["CN22"] = "CN22";
    CustomsDocument["CN23"] = "CN23";
    CustomsDocument["OTHER"] = "OTHER";
})(CustomsDocument = exports.CustomsDocument || (exports.CustomsDocument = {}));
var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek = exports.DayOfWeek || (exports.DayOfWeek = {}));
var DefaultUnpackMode;
(function (DefaultUnpackMode) {
    DefaultUnpackMode["UNPACKABLE"] = "UNPACKABLE";
    DefaultUnpackMode["NON_UNPACKABLE"] = "NON_UNPACKABLE";
})(DefaultUnpackMode = exports.DefaultUnpackMode || (exports.DefaultUnpackMode = {}));
var DeliveryConfirmation;
(function (DeliveryConfirmation) {
    DeliveryConfirmation["NO_CONFIRMATION"] = "NO_CONFIRMATION";
    DeliveryConfirmation["DELIVERY_CONFIRMATION"] = "DELIVERY_CONFIRMATION";
    DeliveryConfirmation["SIGNATURE_CONFIRMATION"] = "SIGNATURE_CONFIRMATION";
    DeliveryConfirmation["ADULT_SIGNATURE_CONFIRMATION"] = "ADULT_SIGNATURE_CONFIRMATION";
    DeliveryConfirmation["DIRECT_SIGNATURE_CONFIRMATION"] = "DIRECT_SIGNATURE_CONFIRMATION";
})(DeliveryConfirmation = exports.DeliveryConfirmation || (exports.DeliveryConfirmation = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["UNKNOWN"] = "UNKNOWN";
    DeliveryStatus["IN_TRANSIT"] = "IN_TRANSIT";
    DeliveryStatus["DELIVERED"] = "DELIVERED";
    DeliveryStatus["LOST_IN_TRANSIT"] = "LOST_IN_TRANSIT";
    DeliveryStatus["RETURN_TO_SENDER"] = "RETURN_TO_SENDER";
    DeliveryStatus["UNDELIVERABLE"] = "UNDELIVERABLE";
    DeliveryStatus["FORWARDED"] = "FORWARDED";
    DeliveryStatus["VOIDED"] = "VOIDED";
})(DeliveryStatus = exports.DeliveryStatus || (exports.DeliveryStatus = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["MONETARY"] = "MONETARY";
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var EmailPreferences;
(function (EmailPreferences) {
    EmailPreferences["DEFAULT"] = "DEFAULT";
    EmailPreferences["RECEIVE_SHIPMENT_IMPORT_EMAIL"] = "RECEIVE_SHIPMENT_IMPORT_EMAIL";
    EmailPreferences["ORDER_EXPORT_EMAIL"] = "ORDER_EXPORT_EMAIL";
    EmailPreferences["FBA_WORKFLOW_CREATED"] = "FBA_WORKFLOW_CREATED";
    EmailPreferences["ORDERS_SKIPPED"] = "ORDERS_SKIPPED";
    EmailPreferences["RECEIVE_INVENTORY_IMPORT_EMAIL"] = "RECEIVE_INVENTORY_IMPORT_EMAIL";
    EmailPreferences["PRODUCT_BELOW_MIN_EMAIL"] = "PRODUCT_BELOW_MIN_EMAIL";
})(EmailPreferences = exports.EmailPreferences || (exports.EmailPreferences = {}));
var FbaShipmentStatus;
(function (FbaShipmentStatus) {
    FbaShipmentStatus["WORKING"] = "WORKING";
    FbaShipmentStatus["SHIPPED"] = "SHIPPED";
    FbaShipmentStatus["IN_TRANSIT"] = "IN_TRANSIT";
    FbaShipmentStatus["DELIVERED"] = "DELIVERED";
    FbaShipmentStatus["CHECKED_IN"] = "CHECKED_IN";
    FbaShipmentStatus["RECEIVING"] = "RECEIVING";
    FbaShipmentStatus["CLOSED"] = "CLOSED";
    FbaShipmentStatus["CANCELLED"] = "CANCELLED";
    FbaShipmentStatus["DELETED"] = "DELETED";
    FbaShipmentStatus["ERROR"] = "ERROR";
})(FbaShipmentStatus = exports.FbaShipmentStatus || (exports.FbaShipmentStatus = {}));
var Format;
(function (Format) {
    Format["PO_PDF_ATTACHMENT"] = "PO_PDF_ATTACHMENT";
    Format["PO_EMAIL"] = "PO_EMAIL";
    Format["PO_HTML_ATTACHMENT"] = "PO_HTML_ATTACHMENT";
})(Format = exports.Format || (exports.Format = {}));
var FraudAnalysis;
(function (FraudAnalysis) {
    FraudAnalysis["SHOPIFY_LOW"] = "SHOPIFY_LOW";
    FraudAnalysis["SHOPIFY_MEDIUM"] = "SHOPIFY_MEDIUM";
    FraudAnalysis["SHOPIFY_HIGH"] = "SHOPIFY_HIGH";
})(FraudAnalysis = exports.FraudAnalysis || (exports.FraudAnalysis = {}));
var GetCustomFieldDefType;
(function (GetCustomFieldDefType) {
    GetCustomFieldDefType["BOOLEAN"] = "BOOLEAN";
    GetCustomFieldDefType["DATE"] = "DATE";
    GetCustomFieldDefType["DATE_FUTURE"] = "DATE_FUTURE";
    GetCustomFieldDefType["DATE_PAST"] = "DATE_PAST";
    GetCustomFieldDefType["DOUBLE"] = "DOUBLE";
    GetCustomFieldDefType["DOUBLE_POSITIVE"] = "DOUBLE_POSITIVE";
    GetCustomFieldDefType["FILE"] = "FILE";
    GetCustomFieldDefType["HTML"] = "HTML";
    GetCustomFieldDefType["LONG"] = "LONG";
    GetCustomFieldDefType["LONG_POSITIVE"] = "LONG_POSITIVE";
    GetCustomFieldDefType["TEXTLONG"] = "TEXTLONG";
    GetCustomFieldDefType["MONEY"] = "MONEY";
    GetCustomFieldDefType["MONEY_POSITIVE"] = "MONEY_POSITIVE";
    GetCustomFieldDefType["TEXTSHORT"] = "TEXTSHORT";
    GetCustomFieldDefType["URL"] = "URL";
})(GetCustomFieldDefType = exports.GetCustomFieldDefType || (exports.GetCustomFieldDefType = {}));
var IncotermShippingRule2Enum;
(function (IncotermShippingRule2Enum) {
    IncotermShippingRule2Enum["COST_AND_FREIGHT"] = "COST_AND_FREIGHT";
    IncotermShippingRule2Enum["COST_INSURANCE_AND_FREIGHT"] = "COST_INSURANCE_AND_FREIGHT";
    IncotermShippingRule2Enum["CARRIAGE_AND_INSURANCE_PAID"] = "CARRIAGE_AND_INSURANCE_PAID";
    IncotermShippingRule2Enum["CARRIAGE_PAID_TO"] = "CARRIAGE_PAID_TO";
    IncotermShippingRule2Enum["DELIVERED_AT_PLACE"] = "DELIVERED_AT_PLACE";
    IncotermShippingRule2Enum["DELIVERED_AT_TERMINAL"] = "DELIVERED_AT_TERMINAL";
    IncotermShippingRule2Enum["DELIVERED_DUTY_PAID"] = "DELIVERED_DUTY_PAID";
    IncotermShippingRule2Enum["EX_WORKS"] = "EX_WORKS";
    IncotermShippingRule2Enum["FREE_ALONGSIDE_SHIP"] = "FREE_ALONGSIDE_SHIP";
    IncotermShippingRule2Enum["FREE_CARRIER"] = "FREE_CARRIER";
    IncotermShippingRule2Enum["FREE_ON_BOARD"] = "FREE_ON_BOARD";
})(IncotermShippingRule2Enum = exports.IncotermShippingRule2Enum || (exports.IncotermShippingRule2Enum = {}));
var InsuranceProvider;
(function (InsuranceProvider) {
    InsuranceProvider["NO_INSURANCE_PROVIDER"] = "NO_INSURANCE_PROVIDER";
    InsuranceProvider["CARRIER_INSURANCE"] = "CARRIER_INSURANCE";
    InsuranceProvider["OTHER_EXTERNAL_INSURANCE"] = "OTHER_EXTERNAL_INSURANCE";
})(InsuranceProvider = exports.InsuranceProvider || (exports.InsuranceProvider = {}));
var InternationalNonDeliveryAction;
(function (InternationalNonDeliveryAction) {
    InternationalNonDeliveryAction["ABANDON_NON_DELIVERABLE_INTERNATIONAL"] = "ABANDON_NON_DELIVERABLE_INTERNATIONAL";
    InternationalNonDeliveryAction["RETURN_NON_DELIVERABLE_INTERNATIONAL"] = "RETURN_NON_DELIVERABLE_INTERNATIONAL";
})(InternationalNonDeliveryAction = exports.InternationalNonDeliveryAction || (exports.InternationalNonDeliveryAction = {}));
var InventoryOptions;
(function (InventoryOptions) {
    InventoryOptions["COMPONENT_INVENTORY_ACROSS_WAREHOUSES"] = "COMPONENT_INVENTORY_ACROSS_WAREHOUSES";
    InventoryOptions["COMPONENT_INVENTORY"] = "COMPONENT_INVENTORY";
})(InventoryOptions = exports.InventoryOptions || (exports.InventoryOptions = {}));
var LiabilityType;
(function (LiabilityType) {
    LiabilityType["NONE"] = "NONE";
    LiabilityType["NEW"] = "NEW";
    LiabilityType["USED_OR_RECONDITIONED"] = "USED_OR_RECONDITIONED";
})(LiabilityType = exports.LiabilityType || (exports.LiabilityType = {}));
var Month;
(function (Month) {
    Month["JANUARY"] = "JANUARY";
    Month["FEBRUARY"] = "FEBRUARY";
    Month["MARCH"] = "MARCH";
    Month["APRIL"] = "APRIL";
    Month["MAY"] = "MAY";
    Month["JUNE"] = "JUNE";
    Month["JULY"] = "JULY";
    Month["AUGUST"] = "AUGUST";
    Month["SEPTEMBER"] = "SEPTEMBER";
    Month["OCTOBER"] = "OCTOBER";
    Month["NOVEMBER"] = "NOVEMBER";
    Month["DECEMBER"] = "DECEMBER";
})(Month = exports.Month || (exports.Month = {}));
var NotificationPreferences;
(function (NotificationPreferences) {
    NotificationPreferences["DEFAULT"] = "DEFAULT";
    NotificationPreferences["ORDER_DOWNLOAD_NOTIFICATION"] = "ORDER_DOWNLOAD_NOTIFICATION";
})(NotificationPreferences = exports.NotificationPreferences || (exports.NotificationPreferences = {}));
var OrderCancelReasonDtoType;
(function (OrderCancelReasonDtoType) {
    OrderCancelReasonDtoType["NO_INVENTORY"] = "NO_INVENTORY";
    OrderCancelReasonDtoType["SHIPPING_ADDRESS_UNDELIVERABLE"] = "SHIPPING_ADDRESS_UNDELIVERABLE";
    OrderCancelReasonDtoType["CUSTOMER_EXCHANGE"] = "CUSTOMER_EXCHANGE";
    OrderCancelReasonDtoType["BUYER_CANCELLED"] = "BUYER_CANCELLED";
    OrderCancelReasonDtoType["BUYER_HAS_NOT_PAID"] = "BUYER_HAS_NOT_PAID";
    OrderCancelReasonDtoType["GENERAL_ADJUSTMENT"] = "GENERAL_ADJUSTMENT";
    OrderCancelReasonDtoType["CARRIER_CREDIT_DECISION"] = "CARRIER_CREDIT_DECISION";
    OrderCancelReasonDtoType["RISK_ASSESSMENT_INFORMATION_NOT_VALID"] = "RISK_ASSESSMENT_INFORMATION_NOT_VALID";
    OrderCancelReasonDtoType["CUSTOMER_RETURN"] = "CUSTOMER_RETURN";
    OrderCancelReasonDtoType["MERCHANDISE_NOT_RECEIVED"] = "MERCHANDISE_NOT_RECEIVED";
    OrderCancelReasonDtoType["OTHER"] = "OTHER";
})(OrderCancelReasonDtoType = exports.OrderCancelReasonDtoType || (exports.OrderCancelReasonDtoType = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["UNRESOLVED"] = "UNRESOLVED";
    OrderStatus["AWAITING_PAYMENT"] = "AWAITING_PAYMENT";
    OrderStatus["AWAITING_SHIPMENT"] = "AWAITING_SHIPMENT";
    OrderStatus["AWAITING_MC_FULFILLMENT"] = "AWAITING_MC_FULFILLMENT";
    OrderStatus["AWAITING_3PL_EXPORT"] = "AWAITING_3PL_EXPORT";
    OrderStatus["AWAITING_DROPSHIP"] = "AWAITING_DROPSHIP";
    OrderStatus["PENDING_FULFILLMENT"] = "PENDING_FULFILLMENT";
    OrderStatus["SHIPPED"] = "SHIPPED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["ON_HOLD"] = "ON_HOLD";
    OrderStatus["SKU_UNPROCESSED"] = "SKU_UNPROCESSED";
    OrderStatus["PROCESSED_OUTSIDE_OF_SKUBANA"] = "PROCESSED_OUTSIDE_OF_SKUBANA";
    OrderStatus["INBOUND_SHIPMENT_PLAN"] = "INBOUND_SHIPMENT_PLAN";
})(OrderStatus = exports.OrderStatus || (exports.OrderStatus = {}));
var OrderType;
(function (OrderType) {
    OrderType["STANDARD"] = "STANDARD";
    OrderType["PRIME"] = "PRIME";
    OrderType["POS"] = "POS";
    OrderType["FBA_WORKFLOW"] = "FBA_WORKFLOW";
    OrderType["FBA"] = "FBA";
    OrderType["STOCK_TRANSFER"] = "STOCK_TRANSFER";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var OrderUnresolvedStatus;
(function (OrderUnresolvedStatus) {
    OrderUnresolvedStatus["RESOLVED"] = "RESOLVED";
    OrderUnresolvedStatus["MISSING_ORDER_INFO"] = "MISSING_ORDER_INFO";
    OrderUnresolvedStatus["MISSING_PRODUCT_INFO"] = "MISSING_PRODUCT_INFO";
    OrderUnresolvedStatus["MISSING_FULFILLMENT_SOURCE"] = "MISSING_FULFILLMENT_SOURCE";
    OrderUnresolvedStatus["MISSING_PICKING_LOCATION"] = "MISSING_PICKING_LOCATION";
    OrderUnresolvedStatus["ORDERBOT_CONFLICT"] = "ORDERBOT_CONFLICT";
    OrderUnresolvedStatus["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    OrderUnresolvedStatus["MULTIPLE_WAREHOUSES"] = "MULTIPLE_WAREHOUSES";
    OrderUnresolvedStatus["FBA_UNRESOLVED"] = "FBA_UNRESOLVED";
    OrderUnresolvedStatus["MISSING_VENDOR_PRODUCT"] = "MISSING_VENDOR_PRODUCT";
})(OrderUnresolvedStatus = exports.OrderUnresolvedStatus || (exports.OrderUnresolvedStatus = {}));
var OrganizationStatus;
(function (OrganizationStatus) {
    OrganizationStatus["ACTIVE"] = "ACTIVE";
    OrganizationStatus["DEACTIVATED"] = "DEACTIVATED";
    OrganizationStatus["SUSPENDED"] = "SUSPENDED";
})(OrganizationStatus = exports.OrganizationStatus || (exports.OrganizationStatus = {}));
var OrganizationUserPermissionType;
(function (OrganizationUserPermissionType) {
    OrganizationUserPermissionType["ACCOUNT_MANAGEMENT_PERMITTED"] = "ACCOUNT_MANAGEMENT_PERMITTED";
    OrganizationUserPermissionType["USERS_ADMIN_PERMITTED"] = "USERS_ADMIN_PERMITTED";
    OrganizationUserPermissionType["MARKETPLACES_PERMITTED"] = "MARKETPLACES_PERMITTED";
    OrganizationUserPermissionType["WAREHOUSES_PERMITTED"] = "WAREHOUSES_PERMITTED";
    OrganizationUserPermissionType["SUPPLIER_PERMITTED"] = "SUPPLIER_PERMITTED";
    OrganizationUserPermissionType["PRODUCTS_PERMITTED"] = "PRODUCTS_PERMITTED";
    OrganizationUserPermissionType["INVENTORY_PERMITTED"] = "INVENTORY_PERMITTED";
    OrganizationUserPermissionType["PURCHASE_ORDERS_PERMITTED"] = "PURCHASE_ORDERS_PERMITTED";
    OrganizationUserPermissionType["ORDERBOTS_PERMITTED"] = "ORDERBOTS_PERMITTED";
    OrganizationUserPermissionType["CUSTOMER_ORDERS_PERMITTED"] = "CUSTOMER_ORDERS_PERMITTED";
    OrganizationUserPermissionType["TEMPLATES_PERMITTED"] = "TEMPLATES_PERMITTED";
    OrganizationUserPermissionType["SHIPPING_PERMITTED"] = "SHIPPING_PERMITTED";
    OrganizationUserPermissionType["REPORTING_PERMITTED"] = "REPORTING_PERMITTED";
    OrganizationUserPermissionType["LISTING_PERMITTED"] = "LISTING_PERMITTED";
    OrganizationUserPermissionType["REPRICING_PERMITTED"] = "REPRICING_PERMITTED";
    OrganizationUserPermissionType["API_ACCESS_PERMITTED"] = "API_ACCESS_PERMITTED";
    OrganizationUserPermissionType["CUSTOMERS_PERMITTED"] = "CUSTOMERS_PERMITTED";
    OrganizationUserPermissionType["SHIPPING_PROVIDERS_PERMITTED"] = "SHIPPING_PROVIDERS_PERMITTED";
    OrganizationUserPermissionType["ACCOUNTING_PERMITTED"] = "ACCOUNTING_PERMITTED";
    OrganizationUserPermissionType["PURCHASE_ORDER_AUTHORIZATION_PERMITTED"] = "PURCHASE_ORDER_AUTHORIZATION_PERMITTED";
    OrganizationUserPermissionType["API_ADMIN_PERMITTED"] = "API_ADMIN_PERMITTED";
    OrganizationUserPermissionType["INVENTORY_RECONCILIATION_PERMITTED"] = "INVENTORY_RECONCILIATION_PERMITTED";
    OrganizationUserPermissionType["BULK_INVENTORY_RECONCILIATION_PERMITTED"] = "BULK_INVENTORY_RECONCILIATION_PERMITTED";
    OrganizationUserPermissionType["FULL_ACCESS"] = "FULL_ACCESS";
})(OrganizationUserPermissionType = exports.OrganizationUserPermissionType || (exports.OrganizationUserPermissionType = {}));
var PackageTypeType;
(function (PackageTypeType) {
    PackageTypeType["MY_PACKAGING"] = "MY_PACKAGING";
    PackageTypeType["UPS_LETTER"] = "UPS_LETTER";
    PackageTypeType["UPS_TUBE"] = "UPS_TUBE";
    PackageTypeType["UPS_EXPRESS_PAK"] = "UPS_EXPRESS_PAK";
    PackageTypeType["UPS_EXPRESS_BOX_SMALL"] = "UPS_EXPRESS_BOX_SMALL";
    PackageTypeType["UPS_EXPRESS_BOX_MEDIUM"] = "UPS_EXPRESS_BOX_MEDIUM";
    PackageTypeType["UPS__EXPRESS_BOX_LARGE"] = "UPS__EXPRESS_BOX_LARGE";
    PackageTypeType["UPS_10_KG_BOX"] = "UPS_10_KG_BOX";
    PackageTypeType["UPS_25_KG_BOX"] = "UPS_25_KG_BOX";
    PackageTypeType["USPS_MY_PACKAGING"] = "USPS_MY_PACKAGING";
    PackageTypeType["MEDIUM_FLAT_RATE_BOX"] = "MEDIUM_FLAT_RATE_BOX";
    PackageTypeType["SMALL_FLAT_RATE_BOX"] = "SMALL_FLAT_RATE_BOX";
    PackageTypeType["LARGE_FLAT_RATE_BOX"] = "LARGE_FLAT_RATE_BOX";
    PackageTypeType["FLAT_RATE_ENVELOPE"] = "FLAT_RATE_ENVELOPE";
    PackageTypeType["FLAT_RATE_PADDED_ENVELOPE"] = "FLAT_RATE_PADDED_ENVELOPE";
    PackageTypeType["FLAT_RATE_LEGAL_ENVELOPE"] = "FLAT_RATE_LEGAL_ENVELOPE";
    PackageTypeType["REGIONAL_RATE_BOX_A"] = "REGIONAL_RATE_BOX_A";
    PackageTypeType["REGIONAL_RATE_BOX_B"] = "REGIONAL_RATE_BOX_B";
    PackageTypeType["LETTER"] = "LETTER";
    PackageTypeType["CUBIC"] = "CUBIC";
    PackageTypeType["REGIONAL_RATE_BOX_C"] = "REGIONAL_RATE_BOX_C";
    PackageTypeType["DVD_FLAT_RATE_BOX"] = "DVD_FLAT_RATE_BOX";
    PackageTypeType["LARGE_VIDEO_FLAT_RATE_BOX"] = "LARGE_VIDEO_FLAT_RATE_BOX";
    PackageTypeType["FEDEX_MY_PACKAGING"] = "FEDEX_MY_PACKAGING";
    PackageTypeType["FEDEX_BOX"] = "FEDEX_BOX";
    PackageTypeType["FEDEX_ENVELOPE"] = "FEDEX_ENVELOPE";
    PackageTypeType["FEDEX_PAK"] = "FEDEX_PAK";
    PackageTypeType["FEDEX_TUBE"] = "FEDEX_TUBE";
    PackageTypeType["FEDEX_10KG_BOX"] = "FEDEX_10KG_BOX";
    PackageTypeType["FEDEX_25KG_BOX"] = "FEDEX_25KG_BOX";
    PackageTypeType["OTHER"] = "OTHER";
    PackageTypeType["FLAT"] = "FLAT";
    PackageTypeType["ONE_RATE_ENVELOPE"] = "ONE_RATE_ENVELOPE";
    PackageTypeType["ONE_RATE_EXTRA_LARGE_BOX"] = "ONE_RATE_EXTRA_LARGE_BOX";
    PackageTypeType["ONE_RATE_LARGE_BOX"] = "ONE_RATE_LARGE_BOX";
    PackageTypeType["ONE_RATE_MEDIUM_BOX"] = "ONE_RATE_MEDIUM_BOX";
    PackageTypeType["ONE_RATE_PAK"] = "ONE_RATE_PAK";
    PackageTypeType["ONE_RATE_SMALL_BOX"] = "ONE_RATE_SMALL_BOX";
    PackageTypeType["ONE_RATE_TUBE"] = "ONE_RATE_TUBE";
    PackageTypeType["AMZ_MY_PACKAGING"] = "AMZ_MY_PACKAGING";
    PackageTypeType["GLOBEGISTICS_MY_PACKAGING"] = "GLOBEGISTICS_MY_PACKAGING";
    PackageTypeType["JUMBO_PARCEL"] = "JUMBO_PARCEL";
    PackageTypeType["CUSTOMER_PROVIDED"] = "CUSTOMER_PROVIDED";
    PackageTypeType["DOCUMENT"] = "DOCUMENT";
    PackageTypeType["DHL_FLYER"] = "DHL_FLYER";
    PackageTypeType["DOMESTIC"] = "DOMESTIC";
    PackageTypeType["EXPRESS_DOCUMENT"] = "EXPRESS_DOCUMENT";
    PackageTypeType["D_H_L_EXPRESS_ENVELOPE"] = "D_H_L_EXPRESS_ENVELOPE";
    PackageTypeType["FREIGHT"] = "FREIGHT";
    PackageTypeType["JUMBO_BOX"] = "JUMBO_BOX";
    PackageTypeType["JUMBO_JUNIOR_DOCUMENT"] = "JUMBO_JUNIOR_DOCUMENT";
    PackageTypeType["JUNIOR_JUMBO_BOX"] = "JUNIOR_JUMBO_BOX";
    PackageTypeType["JUMBO_JUNIOR_PARCEL"] = "JUMBO_JUNIOR_PARCEL";
    PackageTypeType["OTHER_D_H_L_PACKAGING"] = "OTHER_D_H_L_PACKAGING";
    PackageTypeType["PARCEL"] = "PARCEL";
    PackageTypeType["DHL_MY_PACKAGING"] = "DHL_MY_PACKAGING";
    PackageTypeType["JUMBO_DOCUMENT"] = "JUMBO_DOCUMENT";
    PackageTypeType["UPS_MAIL_INNOVATIONS_FLATS"] = "UPS_MAIL_INNOVATIONS_FLATS";
    PackageTypeType["UPS_MAIL_INNOVATIONS_PARCELS"] = "UPS_MAIL_INNOVATIONS_PARCELS";
    PackageTypeType["UPS_MAIL_INNOVATIONS_BPM"] = "UPS_MAIL_INNOVATIONS_BPM";
    PackageTypeType["UPS_MAIL_INNOVATIONS_FIRST_CLASS"] = "UPS_MAIL_INNOVATIONS_FIRST_CLASS";
    PackageTypeType["UPS_MAIL_INNOVATIONS_PRIORITY"] = "UPS_MAIL_INNOVATIONS_PRIORITY";
    PackageTypeType["UPS_MAIL_INNOVATIONS_MACHINEABLES"] = "UPS_MAIL_INNOVATIONS_MACHINEABLES";
    PackageTypeType["UPS_MAIL_INNOVATIONS_IRREGULARS"] = "UPS_MAIL_INNOVATIONS_IRREGULARS";
    PackageTypeType["UPS_MAIL_INNOVATIONS_PARCEL_POST"] = "UPS_MAIL_INNOVATIONS_PARCEL_POST";
    PackageTypeType["UPS_MAIL_INNOVATIONS_BPM_PARCEL"] = "UPS_MAIL_INNOVATIONS_BPM_PARCEL";
    PackageTypeType["UPS_MAIL_INNOVATIONS_MEDIA_MAIL"] = "UPS_MAIL_INNOVATIONS_MEDIA_MAIL";
    PackageTypeType["UPS_MAIL_INNOVATIONS_BPM_FLAT"] = "UPS_MAIL_INNOVATIONS_BPM_FLAT";
    PackageTypeType["UPS_MAIL_INNOVATIONS_STANDARD_FLAT"] = "UPS_MAIL_INNOVATIONS_STANDARD_FLAT";
    PackageTypeType["DHL_ECOMMERCE_MY_PACKAGING"] = "DHL_ECOMMERCE_MY_PACKAGING";
    PackageTypeType["CDL_MY_PACKAGING"] = "CDL_MY_PACKAGING";
    PackageTypeType["FEDEX_PARCEL_SOLUTION_WALMART_PARTNERED_MY_PACKAGE"] = "FEDEX_PARCEL_SOLUTION_WALMART_PARTNERED_MY_PACKAGE";
})(PackageTypeType = exports.PackageTypeType || (exports.PackageTypeType = {}));
var PhysicalPackagingTypeEnum;
(function (PhysicalPackagingTypeEnum) {
    PhysicalPackagingTypeEnum["BAG"] = "BAG";
    PhysicalPackagingTypeEnum["BARREL"] = "BARREL";
    PhysicalPackagingTypeEnum["BASKET"] = "BASKET";
    PhysicalPackagingTypeEnum["BOX"] = "BOX";
    PhysicalPackagingTypeEnum["BUCKET"] = "BUCKET";
    PhysicalPackagingTypeEnum["BUNDLE"] = "BUNDLE";
    PhysicalPackagingTypeEnum["CARTON"] = "CARTON";
    PhysicalPackagingTypeEnum["CASE"] = "CASE";
    PhysicalPackagingTypeEnum["CONTAINER"] = "CONTAINER";
    PhysicalPackagingTypeEnum["CRATE"] = "CRATE";
    PhysicalPackagingTypeEnum["CYLINDER"] = "CYLINDER";
    PhysicalPackagingTypeEnum["DRUM"] = "DRUM";
    PhysicalPackagingTypeEnum["ENVELOPE"] = "ENVELOPE";
    PhysicalPackagingTypeEnum["HAMPER"] = "HAMPER";
    PhysicalPackagingTypeEnum["OTHER"] = "OTHER";
    PhysicalPackagingTypeEnum["PAIL"] = "PAIL";
    PhysicalPackagingTypeEnum["PALLET"] = "PALLET";
    PhysicalPackagingTypeEnum["PIECE"] = "PIECE";
    PhysicalPackagingTypeEnum["REEL"] = "REEL";
    PhysicalPackagingTypeEnum["ROLL"] = "ROLL";
    PhysicalPackagingTypeEnum["SKID"] = "SKID";
    PhysicalPackagingTypeEnum["TANK"] = "TANK";
    PhysicalPackagingTypeEnum["TUBE"] = "TUBE";
})(PhysicalPackagingTypeEnum = exports.PhysicalPackagingTypeEnum || (exports.PhysicalPackagingTypeEnum = {}));
var ProductInvStatus;
(function (ProductInvStatus) {
    ProductInvStatus["UNCONFIGURED_STOCK"] = "UNCONFIGURED_STOCK";
})(ProductInvStatus = exports.ProductInvStatus || (exports.ProductInvStatus = {}));
class ProductStock {
    active;
    allocatedQuantity;
    availableQuantity;
    drawRank;
    minStock;
    pickable;
    product;
    productStockId;
    quantity;
    quantityLocked;
    receivable;
    stockLocation;
    warehouseStockTotals;
}
exports.ProductStock = ProductStock;
var ProductType;
(function (ProductType) {
    ProductType["CORE_PRODUCT"] = "CORE_PRODUCT";
    ProductType["VIRTUAL_PRODUCT"] = "VIRTUAL_PRODUCT";
    ProductType["BUNDLE_KIT"] = "BUNDLE_KIT";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var PurchaseOrderItemStatus;
(function (PurchaseOrderItemStatus) {
    PurchaseOrderItemStatus["PENDING"] = "PENDING";
    PurchaseOrderItemStatus["RECEIVED"] = "RECEIVED";
    PurchaseOrderItemStatus["REJECTED"] = "REJECTED";
    PurchaseOrderItemStatus["VOIDED"] = "VOIDED";
    PurchaseOrderItemStatus["CANCELED"] = "CANCELED";
})(PurchaseOrderItemStatus = exports.PurchaseOrderItemStatus || (exports.PurchaseOrderItemStatus = {}));
var PutRmaItemType;
(function (PutRmaItemType) {
    PutRmaItemType["REFUND"] = "REFUND";
    PutRmaItemType["EXCHANGE"] = "EXCHANGE";
})(PutRmaItemType = exports.PutRmaItemType || (exports.PutRmaItemType = {}));
var Reason;
(function (Reason) {
    Reason["NOT_RECEIVED"] = "NOT_RECEIVED";
    Reason["DAMAGED"] = "DAMAGED";
    Reason["DEFECTIVE"] = "DEFECTIVE";
    Reason["INCORRECT_PRODUCT"] = "INCORRECT_PRODUCT";
    Reason["BETTER_PRICE_AVAILABLE"] = "BETTER_PRICE_AVAILABLE";
    Reason["CUSTOMER_SATISFACTION"] = "CUSTOMER_SATISFACTION";
    Reason["OTHER"] = "OTHER";
})(Reason = exports.Reason || (exports.Reason = {}));
var RoleType;
(function (RoleType) {
    RoleType["CONSIGNEE"] = "CONSIGNEE";
    RoleType["SHIPPER"] = "SHIPPER";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
var RoundingMode;
(function (RoundingMode) {
    RoundingMode["UP"] = "UP";
    RoundingMode["DOWN"] = "DOWN";
    RoundingMode["CEILING"] = "CEILING";
    RoundingMode["FLOOR"] = "FLOOR";
    RoundingMode["HALF_UP"] = "HALF_UP";
    RoundingMode["HALF_DOWN"] = "HALF_DOWN";
    RoundingMode["HALF_EVEN"] = "HALF_EVEN";
    RoundingMode["UNNECESSARY"] = "UNNECESSARY";
})(RoundingMode = exports.RoundingMode || (exports.RoundingMode = {}));
var SalesChannelTypeEnum;
(function (SalesChannelTypeEnum) {
    SalesChannelTypeEnum["AMAZON"] = "AMAZON";
    SalesChannelTypeEnum["EBAY"] = "EBAY";
    SalesChannelTypeEnum["MAGENTO"] = "MAGENTO";
    SalesChannelTypeEnum["SHOPIFY"] = "SHOPIFY";
    SalesChannelTypeEnum["AMAZON_CA"] = "AMAZON_CA";
    SalesChannelTypeEnum["AMAZON_UK"] = "AMAZON_UK";
    SalesChannelTypeEnum["SEARS"] = "SEARS";
    SalesChannelTypeEnum["NEWEGG"] = "NEWEGG";
    SalesChannelTypeEnum["RAKUTEN"] = "RAKUTEN";
    SalesChannelTypeEnum["SKUBANA"] = "SKUBANA";
    SalesChannelTypeEnum["BIG_COMMERCE"] = "BIG_COMMERCE";
    SalesChannelTypeEnum["AMAZON_DE"] = "AMAZON_DE";
    SalesChannelTypeEnum["AMAZON_FR"] = "AMAZON_FR";
    SalesChannelTypeEnum["AMAZON_ES"] = "AMAZON_ES";
    SalesChannelTypeEnum["AMAZON_IT"] = "AMAZON_IT";
    SalesChannelTypeEnum["AMAZON_MX"] = "AMAZON_MX";
    SalesChannelTypeEnum["JET"] = "JET";
    SalesChannelTypeEnum["WALMART"] = "WALMART";
    SalesChannelTypeEnum["STOCK_TRANSFER"] = "STOCK_TRANSFER";
    SalesChannelTypeEnum["AMAZON_CN"] = "AMAZON_CN";
    SalesChannelTypeEnum["AMAZON_AU"] = "AMAZON_AU";
    SalesChannelTypeEnum["CUSTOM"] = "CUSTOM";
})(SalesChannelTypeEnum = exports.SalesChannelTypeEnum || (exports.SalesChannelTypeEnum = {}));
var SellerFreightClass;
(function (SellerFreightClass) {
    SellerFreightClass["CLASS_050"] = "CLASS_050";
    SellerFreightClass["CLASS_055"] = "CLASS_055";
    SellerFreightClass["CLASS_060"] = "CLASS_060";
    SellerFreightClass["CLASS_065"] = "CLASS_065";
    SellerFreightClass["CLASS_070"] = "CLASS_070";
    SellerFreightClass["CLASS_077_5"] = "CLASS_077_5";
    SellerFreightClass["CLASS_085"] = "CLASS_085";
    SellerFreightClass["CLASS_092_5"] = "CLASS_092_5";
    SellerFreightClass["CLASS_100"] = "CLASS_100";
    SellerFreightClass["CLASS_110"] = "CLASS_110";
    SellerFreightClass["CLASS_125"] = "CLASS_125";
    SellerFreightClass["CLASS_150"] = "CLASS_150";
    SellerFreightClass["CLASS_175"] = "CLASS_175";
    SellerFreightClass["CLASS_200"] = "CLASS_200";
    SellerFreightClass["CLASS_250"] = "CLASS_250";
    SellerFreightClass["CLASS_300"] = "CLASS_300";
    SellerFreightClass["CLASS_400"] = "CLASS_400";
    SellerFreightClass["CLASS_500"] = "CLASS_500";
})(SellerFreightClass = exports.SellerFreightClass || (exports.SellerFreightClass = {}));
var ShipmentType;
(function (ShipmentType) {
    ShipmentType["FULFILLMENT"] = "FULFILLMENT";
    ShipmentType["RETURN"] = "RETURN";
})(ShipmentType = exports.ShipmentType || (exports.ShipmentType = {}));
var ShippingCarrierType;
(function (ShippingCarrierType) {
    ShippingCarrierType["UPS"] = "UPS";
    ShippingCarrierType["FEDEX"] = "FEDEX";
    ShippingCarrierType["USPS"] = "USPS";
    ShippingCarrierType["DHL"] = "DHL";
    ShippingCarrierType["UPS_MAIL_INNOVATIONS"] = "UPS_MAIL_INNOVATIONS";
    ShippingCarrierType["ON_TRAC"] = "ON_TRAC";
    ShippingCarrierType["NEWGISTICS"] = "NEWGISTICS";
    ShippingCarrierType["LONE_STAR_OVERNIGHT"] = "LONE_STAR_OVERNIGHT";
    ShippingCarrierType["GLOBEGISTICS"] = "GLOBEGISTICS";
    ShippingCarrierType["FIRST_MILE"] = "FIRST_MILE";
    ShippingCarrierType["FEDEX_INTERNATIONAL_MAIL_SERVICE"] = "FEDEX_INTERNATIONAL_MAIL_SERVICE";
    ShippingCarrierType["FEDEX_CANADA"] = "FEDEX_CANADA";
    ShippingCarrierType["DHL_GLOBAL_MAIL"] = "DHL_GLOBAL_MAIL";
    ShippingCarrierType["DHL_EXPRESS"] = "DHL_EXPRESS";
    ShippingCarrierType["CANADA_POST"] = "CANADA_POST";
    ShippingCarrierType["BROKERS_WORLDWIDE"] = "BROKERS_WORLDWIDE";
    ShippingCarrierType["ASENDIA"] = "ASENDIA";
    ShippingCarrierType["UPS_AZ"] = "UPS_AZ";
    ShippingCarrierType["FED_EX_AZ"] = "FED_EX_AZ";
    ShippingCarrierType["USPS_AZ"] = "USPS_AZ";
    ShippingCarrierType["DYNAMEX_AZ"] = "DYNAMEX_AZ";
    ShippingCarrierType["AMZL"] = "AMZL";
    ShippingCarrierType["AMZN_US"] = "AMZN_US";
    ShippingCarrierType["STAMPS_DOT_COM_AZ"] = "STAMPS_DOT_COM_AZ";
    ShippingCarrierType["AMZN_UK"] = "AMZN_UK";
    ShippingCarrierType["OTHER_CARRIER"] = "OTHER_CARRIER";
    ShippingCarrierType["ACCESS_WORLDWIDE"] = "ACCESS_WORLDWIDE";
    ShippingCarrierType["APC"] = "APC";
    ShippingCarrierType["AUSTRALIA_POST"] = "AUSTRALIA_POST";
    ShippingCarrierType["DHL_CANADA"] = "DHL_CANADA";
    ShippingCarrierType["IMEX"] = "IMEX";
    ShippingCarrierType["LONE_STAR"] = "LONE_STAR";
    ShippingCarrierType["ROYAL_MAIL"] = "ROYAL_MAIL";
    ShippingCarrierType["ROADRUNNER"] = "ROADRUNNER";
    ShippingCarrierType["BEST_OVERNITE"] = "BEST_OVERNITE";
    ShippingCarrierType["CEVA_LOGISTICS"] = "CEVA_LOGISTICS";
    ShippingCarrierType["SOFATRAK"] = "SOFATRAK";
    ShippingCarrierType["UPS_AMZ_PARTNERED_DEFAULT"] = "UPS_AMZ_PARTNERED_DEFAULT";
    ShippingCarrierType["AMZ_PARTNERED_LTL_FTL"] = "AMZ_PARTNERED_LTL_FTL";
    ShippingCarrierType["AMZ_LTL_FTL_BUSINESS_POST_UK"] = "AMZ_LTL_FTL_BUSINESS_POST_UK";
    ShippingCarrierType["AMZ_LTL_FTL_DHL_AIRWAYS_INC_UK"] = "AMZ_LTL_FTL_DHL_AIRWAYS_INC_UK";
    ShippingCarrierType["AMZ_LTL_FTL_DHL_UK"] = "AMZ_LTL_FTL_DHL_UK";
    ShippingCarrierType["AMZ_LTL_FTL_PARCELFORCE_UK"] = "AMZ_LTL_FTL_PARCELFORCE_UK";
    ShippingCarrierType["AMZ_LTL_FTL_DPD"] = "AMZ_LTL_FTL_DPD";
    ShippingCarrierType["AMZ_LTL_FTL_TNT_LOGISTICS_CORPORATION_UK"] = "AMZ_LTL_FTL_TNT_LOGISTICS_CORPORATION_UK";
    ShippingCarrierType["AMZ_LTL_FTL_TNT_UK"] = "AMZ_LTL_FTL_TNT_UK";
    ShippingCarrierType["AMZ_LTL_FTL_YODEL_UK"] = "AMZ_LTL_FTL_YODEL_UK";
    ShippingCarrierType["AMZ_LTL_FTL_UNITED_PARCEL_SERVICE_INC_UK"] = "AMZ_LTL_FTL_UNITED_PARCEL_SERVICE_INC_UK";
    ShippingCarrierType["AMZ_LTL_FTL_OTHER_UK"] = "AMZ_LTL_FTL_OTHER_UK";
    ShippingCarrierType["AMZ_LTL_FTL_DHL_EXPRESS_USA_INC"] = "AMZ_LTL_FTL_DHL_EXPRESS_USA_INC";
    ShippingCarrierType["AMZ_LTL_FTL_FEDERAL_EXPRESS_CORP_US"] = "AMZ_LTL_FTL_FEDERAL_EXPRESS_CORP_US";
    ShippingCarrierType["AMZ_LTL_FTL_UNITED_STATES_POSTAL_SERVICE_US"] = "AMZ_LTL_FTL_UNITED_STATES_POSTAL_SERVICE_US";
    ShippingCarrierType["AMZ_LTL_FTL_UNITED_PARCEL_SERVICE_INC_US"] = "AMZ_LTL_FTL_UNITED_PARCEL_SERVICE_INC_US";
    ShippingCarrierType["AMZ_LTL_FTL_OTHER_US"] = "AMZ_LTL_FTL_OTHER_US";
    ShippingCarrierType["UPS_CA"] = "UPS_CA";
    ShippingCarrierType["L5"] = "L5";
    ShippingCarrierType["HOME_DELIVERY"] = "HOME_DELIVERY";
    ShippingCarrierType["TNT"] = "TNT";
    ShippingCarrierType["PUROLATOR"] = "PUROLATOR";
    ShippingCarrierType["NHHF"] = "NHHF";
    ShippingCarrierType["FORWARD_AIR_CORP"] = "FORWARD_AIR_CORP";
    ShippingCarrierType["ALLIANCE_AIR_FREIGHT"] = "ALLIANCE_AIR_FREIGHT";
    ShippingCarrierType["CUSTOM_COMPANIES"] = "CUSTOM_COMPANIES";
    ShippingCarrierType["TOTAL_TRANSPORTATION"] = "TOTAL_TRANSPORTATION";
    ShippingCarrierType["WATKINS_SHEPARD"] = "WATKINS_SHEPARD";
    ShippingCarrierType["DEPENDABLE_HIGHWAY_EXPRESS"] = "DEPENDABLE_HIGHWAY_EXPRESS";
    ShippingCarrierType["PARCELFORCE"] = "PARCELFORCE";
    ShippingCarrierType["DPD_UK"] = "DPD_UK";
    ShippingCarrierType["HERMES"] = "HERMES";
    ShippingCarrierType["DHL_PARCELS_UK"] = "DHL_PARCELS_UK";
    ShippingCarrierType["AMAZON_SHIPPING"] = "AMAZON_SHIPPING";
    ShippingCarrierType["TNT_UK"] = "TNT_UK";
    ShippingCarrierType["TNT_DE"] = "TNT_DE";
    ShippingCarrierType["K_AND_N"] = "K_AND_N";
    ShippingCarrierType["TOF"] = "TOF";
    ShippingCarrierType["PASSPORT"] = "PASSPORT";
    ShippingCarrierType["SF_EXPRESS"] = "SF_EXPRESS";
    ShippingCarrierType["DPEX"] = "DPEX";
    ShippingCarrierType["ARAMEX"] = "ARAMEX";
    ShippingCarrierType["BEST_RATE"] = "BEST_RATE";
    ShippingCarrierType["ABF"] = "ABF";
    ShippingCarrierType["GLS_NL"] = "GLS_NL";
    ShippingCarrierType["GLS_DE"] = "GLS_DE";
    ShippingCarrierType["DHL_DE"] = "DHL_DE";
    ShippingCarrierType["DHL_NL"] = "DHL_NL";
    ShippingCarrierType["GLOBAL_E"] = "GLOBAL_E";
    ShippingCarrierType["CENTRAL_TRANSPORT_INTERNATIONAL"] = "CENTRAL_TRANSPORT_INTERNATIONAL";
    ShippingCarrierType["CENTRAL_FREIGHT_LINES"] = "CENTRAL_FREIGHT_LINES";
    ShippingCarrierType["ESTES_EXPRESS_LINES"] = "ESTES_EXPRESS_LINES";
    ShippingCarrierType["YELLOW_YRC"] = "YELLOW_YRC";
    ShippingCarrierType["RL_CARRIERS"] = "RL_CARRIERS";
    ShippingCarrierType["NEW_PENN_MOTOR_EXPRESS"] = "NEW_PENN_MOTOR_EXPRESS";
    ShippingCarrierType["CONWAY"] = "CONWAY";
    ShippingCarrierType["USF_REDDAWAY"] = "USF_REDDAWAY";
    ShippingCarrierType["SAIA_MOTOR_FREIGHT"] = "SAIA_MOTOR_FREIGHT";
    ShippingCarrierType["AVERITT_EXPRESS"] = "AVERITT_EXPRESS";
    ShippingCarrierType["AAA_COOPER_TRANSPORTATION"] = "AAA_COOPER_TRANSPORTATION";
    ShippingCarrierType["SOUTHEASTERN_FREIGHT_LINES"] = "SOUTHEASTERN_FREIGHT_LINES";
    ShippingCarrierType["UPS_FREIGHT"] = "UPS_FREIGHT";
    ShippingCarrierType["YRC"] = "YRC";
    ShippingCarrierType["RR_DONNELLEY"] = "RR_DONNELLEY";
    ShippingCarrierType["DELIVERR"] = "DELIVERR";
    ShippingCarrierType["HONG_KONG_POST"] = "HONG_KONG_POST";
    ShippingCarrierType["HONG_KONG_POST_EN"] = "HONG_KONG_POST_EN";
    ShippingCarrierType["SINGAPORE_POST"] = "SINGAPORE_POST";
    ShippingCarrierType["CHINA_POST"] = "CHINA_POST";
    ShippingCarrierType["STO"] = "STO";
    ShippingCarrierType["POSTNL"] = "POSTNL";
    ShippingCarrierType["SWISSPOST"] = "SWISSPOST";
    ShippingCarrierType["NEW_ZEALAND_POST"] = "NEW_ZEALAND_POST";
    ShippingCarrierType["POSTE_ITALIANE"] = "POSTE_ITALIANE";
    ShippingCarrierType["SCM"] = "SCM";
    ShippingCarrierType["LA_POSTE"] = "LA_POSTE";
    ShippingCarrierType["BOXC"] = "BOXC";
    ShippingCarrierType["OLD_DOMINION"] = "OLD_DOMINION";
    ShippingCarrierType["DAYTON_FREIGHT"] = "DAYTON_FREIGHT";
    ShippingCarrierType["FLOSHIP_AFTERSHIP"] = "FLOSHIP_AFTERSHIP";
    ShippingCarrierType["GLS"] = "GLS";
    ShippingCarrierType["SWI_SHIP"] = "SWI_SHIP";
    ShippingCarrierType["DHL_ECOMMERCE"] = "DHL_ECOMMERCE";
    ShippingCarrierType["FRONTLINE_FREIGHT"] = "FRONTLINE_FREIGHT";
    ShippingCarrierType["UPSN_CG"] = "UPSN_CG";
    ShippingCarrierType["SHIPMONK_FEAT"] = "SHIPMONK_FEAT";
    ShippingCarrierType["BABOON_PASSPORT"] = "BABOON_PASSPORT";
    ShippingCarrierType["DHL_ECOMMERCE_DIRECT"] = "DHL_ECOMMERCE_DIRECT";
    ShippingCarrierType["DEUTSCHE_POST"] = "DEUTSCHE_POST";
    ShippingCarrierType["MANUALLY_FULFILLED"] = "MANUALLY_FULFILLED";
    ShippingCarrierType["WHISTLE"] = "WHISTLE";
    ShippingCarrierType["LINKLOGISTICS"] = "LINKLOGISTICS";
    ShippingCarrierType["USPS_ONE_BALANCE"] = "USPS_ONE_BALANCE";
    ShippingCarrierType["WILL_CALL"] = "WILL_CALL";
    ShippingCarrierType["SEKO_LOGISTICS"] = "SEKO_LOGISTICS";
    ShippingCarrierType["STAMPS_COM"] = "STAMPS_COM";
    ShippingCarrierType["AN_POST"] = "AN_POST";
    ShippingCarrierType["_10CC"] = "_10CC";
    ShippingCarrierType["_11DP"] = "_11DP";
    ShippingCarrierType["_18AC"] = "_18AC";
    ShippingCarrierType["_36ID"] = "_36ID";
    ShippingCarrierType["_44BR"] = "_44BR";
    ShippingCarrierType["_44CH"] = "_44CH";
    ShippingCarrierType["_44SB"] = "_44SB";
    ShippingCarrierType["AAA"] = "AAA";
    ShippingCarrierType["AACT"] = "AACT";
    ShippingCarrierType["ADP"] = "ADP";
    ShippingCarrierType["ADYW"] = "ADYW";
    ShippingCarrierType["AEIB"] = "AEIB";
    ShippingCarrierType["AGXP"] = "AGXP";
    ShippingCarrierType["AMPM"] = "AMPM";
    ShippingCarrierType["ANDO"] = "ANDO";
    ShippingCarrierType["AVFE"] = "AVFE";
    ShippingCarrierType["BTRC"] = "BTRC";
    ShippingCarrierType["BUKC"] = "BUKC";
    ShippingCarrierType["C23L"] = "C23L";
    ShippingCarrierType["CARD"] = "CARD";
    ShippingCarrierType["CCSJ"] = "CCSJ";
    ShippingCarrierType["CCYQ"] = "CCYQ";
    ShippingCarrierType["CENF"] = "CENF";
    ShippingCarrierType["COMM"] = "COMM";
    ShippingCarrierType["CTII"] = "CTII";
    ShippingCarrierType["CUXG"] = "CUXG";
    ShippingCarrierType["DCHA"] = "DCHA";
    ShippingCarrierType["DEEX"] = "DEEX";
    ShippingCarrierType["DHRN"] = "DHRN";
    ShippingCarrierType["EDYS"] = "EDYS";
    ShippingCarrierType["EMSY"] = "EMSY";
    ShippingCarrierType["EXLA"] = "EXLA";
    ShippingCarrierType["EXPN"] = "EXPN";
    ShippingCarrierType["EXPS"] = "EXPS";
    ShippingCarrierType["FCCD"] = "FCCD";
    ShippingCarrierType["GEXO"] = "GEXO";
    ShippingCarrierType["HMES"] = "HMES";
    ShippingCarrierType["JSMA"] = "JSMA";
    ShippingCarrierType["LAEA"] = "LAEA";
    ShippingCarrierType["LAXU"] = "LAXU";
    ShippingCarrierType["MENT"] = "MENT";
    ShippingCarrierType["MINN"] = "MINN";
    ShippingCarrierType["NDER"] = "NDER";
    ShippingCarrierType["NDSN"] = "NDSN";
    ShippingCarrierType["NOPK"] = "NOPK";
    ShippingCarrierType["NPME"] = "NPME";
    ShippingCarrierType["OAKH"] = "OAKH";
    ShippingCarrierType["OKXL"] = "OKXL";
    ShippingCarrierType["PDRQ"] = "PDRQ";
    ShippingCarrierType["PITD"] = "PITD";
    ShippingCarrierType["PITT"] = "PITT";
    ShippingCarrierType["PXPK"] = "PXPK";
    ShippingCarrierType["PYLE"] = "PYLE";
    ShippingCarrierType["RDWY"] = "RDWY";
    ShippingCarrierType["RETL"] = "RETL";
    ShippingCarrierType["RLNO"] = "RLNO";
    ShippingCarrierType["RNLO"] = "RNLO";
    ShippingCarrierType["RRDS"] = "RRDS";
    ShippingCarrierType["SAIA"] = "SAIA";
    ShippingCarrierType["SAPL"] = "SAPL";
    ShippingCarrierType["SEFL"] = "SEFL";
    ShippingCarrierType["SUON"] = "SUON";
    ShippingCarrierType["SVXL"] = "SVXL";
    ShippingCarrierType["SWDS"] = "SWDS";
    ShippingCarrierType["TFNM"] = "TFNM";
    ShippingCarrierType["UCFN"] = "UCFN";
    ShippingCarrierType["UCFS"] = "UCFS";
    ShippingCarrierType["UFCS"] = "UFCS";
    ShippingCarrierType["UPGF"] = "UPGF";
    ShippingCarrierType["UPSF"] = "UPSF";
    ShippingCarrierType["USCA"] = "USCA";
    ShippingCarrierType["VCCO"] = "VCCO";
    ShippingCarrierType["WARD"] = "WARD";
    ShippingCarrierType["XSLS"] = "XSLS";
    ShippingCarrierType["RYDER"] = "RYDER";
    ShippingCarrierType["DAI_POST"] = "DAI_POST";
    ShippingCarrierType["BPOST_INTERNATIONAL"] = "BPOST_INTERNATIONAL";
    ShippingCarrierType["FDM"] = "FDM";
    ShippingCarrierType["INTERPOST"] = "INTERPOST";
    ShippingCarrierType["CAN_PAR"] = "CAN_PAR";
    ShippingCarrierType["NZ_POST"] = "NZ_POST";
    ShippingCarrierType["COLIS_PRIVE"] = "COLIS_PRIVE";
    ShippingCarrierType["BRING"] = "BRING";
    ShippingCarrierType["GFS"] = "GFS";
    ShippingCarrierType["INTELCOM_EXPRESS"] = "INTELCOM_EXPRESS";
    ShippingCarrierType["LANDMARK_ROUTED"] = "LANDMARK_ROUTED";
    ShippingCarrierType["FDEG"] = "FDEG";
    ShippingCarrierType["FDG"] = "FDG";
    ShippingCarrierType["FDX"] = "FDX";
    ShippingCarrierType["UPSG"] = "UPSG";
    ShippingCarrierType["UPS2"] = "UPS2";
    ShippingCarrierType["UPSEG"] = "UPSEG";
    ShippingCarrierType["UPSN"] = "UPSN";
    ShippingCarrierType["US10"] = "US10";
    ShippingCarrierType["BESY"] = "BESY";
    ShippingCarrierType["COUJ"] = "COUJ";
    ShippingCarrierType["EPCI"] = "EPCI";
    ShippingCarrierType["SDGD"] = "SDGD";
    ShippingCarrierType["DYUS"] = "DYUS";
    ShippingCarrierType["MONC"] = "MONC";
    ShippingCarrierType["TAXA"] = "TAXA";
    ShippingCarrierType["YRCF"] = "YRCF";
    ShippingCarrierType["AXLE_HIRE"] = "AXLE_HIRE";
    ShippingCarrierType["USPS_GLOBAL"] = "USPS_GLOBAL";
    ShippingCarrierType["JB_HUNT"] = "JB_HUNT";
    ShippingCarrierType["UD_3PL"] = "UD_3PL";
    ShippingCarrierType["RATE_SHOP"] = "RATE_SHOP";
    ShippingCarrierType["SWISHIP_AMZ_LOGISTICS"] = "SWISHIP_AMZ_LOGISTICS";
    ShippingCarrierType["LTL"] = "LTL";
    ShippingCarrierType["CDL"] = "CDL";
    ShippingCarrierType["CAIE"] = "CAIE";
    ShippingCarrierType["GADQ"] = "GADQ";
    ShippingCarrierType["CFRT"] = "CFRT";
    ShippingCarrierType["NART"] = "NART";
    ShippingCarrierType["HRCF"] = "HRCF";
    ShippingCarrierType["DHLC"] = "DHLC";
    ShippingCarrierType["RGUS"] = "RGUS";
    ShippingCarrierType["LINW"] = "LINW";
    ShippingCarrierType["DYXI"] = "DYXI";
    ShippingCarrierType["XPOL"] = "XPOL";
    ShippingCarrierType["KNIG"] = "KNIG";
    ShippingCarrierType["YLAT"] = "YLAT";
    ShippingCarrierType["CLLQ"] = "CLLQ";
    ShippingCarrierType["BPOST"] = "BPOST";
    ShippingCarrierType["CORREIOS"] = "CORREIOS";
    ShippingCarrierType["POSTNORD"] = "POSTNORD";
    ShippingCarrierType["OMNIVA"] = "OMNIVA";
    ShippingCarrierType["POSTI"] = "POSTI";
    ShippingCarrierType["POSTA"] = "POSTA";
    ShippingCarrierType["ELTA"] = "ELTA";
    ShippingCarrierType["TELEPOST"] = "TELEPOST";
    ShippingCarrierType["POSTUR"] = "POSTUR";
    ShippingCarrierType["ISRAELPOST"] = "ISRAELPOST";
    ShippingCarrierType["JPPOST"] = "JPPOST";
    ShippingCarrierType["HR_POSTA"] = "HR_POSTA";
    ShippingCarrierType["PASTS"] = "PASTS";
    ShippingCarrierType["POST_IT"] = "POST_IT";
    ShippingCarrierType["POST_LU"] = "POST_LU";
    ShippingCarrierType["POS_MI"] = "POS_MI";
    ShippingCarrierType["CORREOS"] = "CORREOS";
    ShippingCarrierType["POSTEN"] = "POSTEN";
    ShippingCarrierType["POCZTA"] = "POCZTA";
    ShippingCarrierType["CTT"] = "CTT";
    ShippingCarrierType["POCHTA"] = "POCHTA";
    ShippingCarrierType["POSTA_SK"] = "POSTA_SK";
    ShippingCarrierType["POSTA_SI"] = "POSTA_SI";
    ShippingCarrierType["CORREOS_ES"] = "CORREOS_ES";
    ShippingCarrierType["POSTNORD_SE"] = "POSTNORD_SE";
    ShippingCarrierType["KOREAPOST"] = "KOREAPOST";
    ShippingCarrierType["POSTA_CZ"] = "POSTA_CZ";
    ShippingCarrierType["PTT"] = "PTT";
    ShippingCarrierType["MAGYARPOSTA"] = "MAGYARPOSTA";
    ShippingCarrierType["POSTAT"] = "POSTAT";
    ShippingCarrierType["OSM_WORLDWIDE"] = "OSM_WORLDWIDE";
    ShippingCarrierType["FEDH"] = "FEDH";
    ShippingCarrierType["BEST_ALL"] = "BEST_ALL";
    ShippingCarrierType["FEDEXHOM"] = "FEDEXHOM";
    ShippingCarrierType["FEDEX2D"] = "FEDEX2D";
    ShippingCarrierType["COLISSIMO"] = "COLISSIMO";
    ShippingCarrierType["PARCEL_ONE"] = "PARCEL_ONE";
    ShippingCarrierType["BRT_IT"] = "BRT_IT";
    ShippingCarrierType["CELERITAS"] = "CELERITAS";
    ShippingCarrierType["INTELCOM"] = "INTELCOM";
    ShippingCarrierType["AMZN"] = "AMZN";
    ShippingCarrierType["STANDARD_FORWARDING"] = "STANDARD_FORWARDING";
    ShippingCarrierType["PERFORMANCE_FREIGHT_SYSTEMS"] = "PERFORMANCE_FREIGHT_SYSTEMS";
    ShippingCarrierType["FORWARDS_AIR"] = "FORWARDS_AIR";
    ShippingCarrierType["XPO_LOGISTICS"] = "XPO_LOGISTICS";
    ShippingCarrierType["TFORCE_FREIGHT"] = "TFORCE_FREIGHT";
    ShippingCarrierType["PICK"] = "PICK";
    ShippingCarrierType["AIR"] = "AIR";
    ShippingCarrierType["FEDEX_PARCEL_SOLUTION_WALMART_PARTNERED_DEFAULT"] = "FEDEX_PARCEL_SOLUTION_WALMART_PARTNERED_DEFAULT";
    ShippingCarrierType["ALERO"] = "ALERO";
    ShippingCarrierType["ALLEGRO"] = "ALLEGRO";
    ShippingCarrierType["BCUBED"] = "BCUBED";
    ShippingCarrierType["DISPATCH"] = "DISPATCH";
    ShippingCarrierType["DOLLY"] = "DOLLY";
    ShippingCarrierType["FREIGHT_CLUB_GROUND"] = "FREIGHT_CLUB_GROUND";
    ShippingCarrierType["FRAGILEPAK_COMMERCIAL"] = "FRAGILEPAK_COMMERCIAL";
    ShippingCarrierType["FREIGHTQUOTE"] = "FREIGHTQUOTE";
    ShippingCarrierType["METROPOLITAN"] = "METROPOLITAN";
    ShippingCarrierType["FRAGILEPAK"] = "FRAGILEPAK";
    ShippingCarrierType["CUSTOMER_PICK_UP"] = "CUSTOMER_PICK_UP";
    ShippingCarrierType["ROSS_LOGISTICS"] = "ROSS_LOGISTICS";
    ShippingCarrierType["SCHNEIDER"] = "SCHNEIDER";
    ShippingCarrierType["STERLING"] = "STERLING";
    ShippingCarrierType["FLOCK_FREIGHT"] = "FLOCK_FREIGHT";
    ShippingCarrierType["GENERIC_CDL_MISC_20026"] = "GENERIC_CDL_MISC_20026";
    ShippingCarrierType["CHRONOPOST"] = "CHRONOPOST";
    ShippingCarrierType["MESSAGERIE"] = "MESSAGERIE";
    ShippingCarrierType["RETRAIT_SUPPLYWEB"] = "RETRAIT_SUPPLYWEB";
    ShippingCarrierType["SO_COLISSIMO"] = "SO_COLISSIMO";
    ShippingCarrierType["DHL_FRANCE"] = "DHL_FRANCE";
    ShippingCarrierType["OVERRIDE_FEDEX_OVERNIGHT_SAVER_MISC_20006"] = "OVERRIDE_FEDEX_OVERNIGHT_SAVER_MISC_20006";
    ShippingCarrierType["SHIP_MONK"] = "SHIP_MONK";
    ShippingCarrierType["EVRI"] = "EVRI";
})(ShippingCarrierType = exports.ShippingCarrierType || (exports.ShippingCarrierType = {}));
var ShippingProviderTypeType;
(function (ShippingProviderTypeType) {
    ShippingProviderTypeType["UPS"] = "UPS";
    ShippingProviderTypeType["FEDEX"] = "FEDEX";
    ShippingProviderTypeType["USPS"] = "USPS";
    ShippingProviderTypeType["DHL"] = "DHL";
    ShippingProviderTypeType["ENDICIA"] = "ENDICIA";
    ShippingProviderTypeType["STAMPS_COM"] = "STAMPS_COM";
    ShippingProviderTypeType["AMAZON"] = "AMAZON";
    ShippingProviderTypeType["AMAZON_PARTNERED"] = "AMAZON_PARTNERED";
    ShippingProviderTypeType["UPS_CA"] = "UPS_CA";
    ShippingProviderTypeType["GLOBEGISTICS"] = "GLOBEGISTICS";
    ShippingProviderTypeType["DHL_EXPRESS"] = "DHL_EXPRESS";
    ShippingProviderTypeType["DHL_ECOMMERCE"] = "DHL_ECOMMERCE";
    ShippingProviderTypeType["WALMART_PARTNERED"] = "WALMART_PARTNERED";
})(ShippingProviderTypeType = exports.ShippingProviderTypeType || (exports.ShippingProviderTypeType = {}));
var ShippingServiceType;
(function (ShippingServiceType) {
    ShippingServiceType["UPS_GROUND"] = "UPS_GROUND";
    ShippingServiceType["UPS_3_DAY_SELECT"] = "UPS_3_DAY_SELECT";
    ShippingServiceType["UPS_2ND_DAY_AIR"] = "UPS_2ND_DAY_AIR";
    ShippingServiceType["UPS_2ND_DAY_AIR_AM"] = "UPS_2ND_DAY_AIR_AM";
    ShippingServiceType["UPS_NEXT_DAY_AIR_SAVER"] = "UPS_NEXT_DAY_AIR_SAVER";
    ShippingServiceType["UPS_NEXT_DAY_AIR"] = "UPS_NEXT_DAY_AIR";
    ShippingServiceType["UPS_NEXT_DAY_AIR_EARLY_AM"] = "UPS_NEXT_DAY_AIR_EARLY_AM";
    ShippingServiceType["UPS_STANDARD"] = "UPS_STANDARD";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS"] = "UPS_WORLDWIDE_EXPRESS";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS_PLUS"] = "UPS_WORLDWIDE_EXPRESS_PLUS";
    ShippingServiceType["UPS_WORLDWIDE_EXPEDITED"] = "UPS_WORLDWIDE_EXPEDITED";
    ShippingServiceType["UPS_WORLDWIDE_SAVER"] = "UPS_WORLDWIDE_SAVER";
    ShippingServiceType["UPS_SUREPOST_LESS_THAN_1_LB"] = "UPS_SUREPOST_LESS_THAN_1_LB";
    ShippingServiceType["UPS_SUREPOST_1_LB_OR_GREATER"] = "UPS_SUREPOST_1_LB_OR_GREATER";
    ShippingServiceType["UPS_SUREPOST_BPM"] = "UPS_SUREPOST_BPM";
    ShippingServiceType["UPS_SUREPOST_MEDIA"] = "UPS_SUREPOST_MEDIA";
    ShippingServiceType["USPS_PRIORITY_MAIL_EXPRESS"] = "USPS_PRIORITY_MAIL_EXPRESS";
    ShippingServiceType["USPS_PRIORITY_MAIL"] = "USPS_PRIORITY_MAIL";
    ShippingServiceType["USPS_FIRST_CLASS_MAIL"] = "USPS_FIRST_CLASS_MAIL";
    ShippingServiceType["USPS_RETAIL_GROUND"] = "USPS_RETAIL_GROUND";
    ShippingServiceType["USPS_MEDIA_MAIL"] = "USPS_MEDIA_MAIL";
    ShippingServiceType["USPS_GLOBAL_EXPRESS_GUARANTEED"] = "USPS_GLOBAL_EXPRESS_GUARANTEED";
    ShippingServiceType["USPS_PRIORITY_MAIL_EXPRESS_INTERNATIONAL"] = "USPS_PRIORITY_MAIL_EXPRESS_INTERNATIONAL";
    ShippingServiceType["USPS_PRIORITY_MAIL_INTERNATIONAL"] = "USPS_PRIORITY_MAIL_INTERNATIONAL";
    ShippingServiceType["USPS_FIRST_CLASS_MAIL_INTERNATIONAL"] = "USPS_FIRST_CLASS_MAIL_INTERNATIONAL";
    ShippingServiceType["USPS_FIRST_CLASS_PACKAGE_INTERNATIONAL_SERVICE"] = "USPS_FIRST_CLASS_PACKAGE_INTERNATIONAL_SERVICE";
    ShippingServiceType["DHL_ECOMMERCE_BUSINESS_PRIORITY"] = "DHL_ECOMMERCE_BUSINESS_PRIORITY";
    ShippingServiceType["DHL_ECOMMERCE_BUSINESS_STANDARD"] = "DHL_ECOMMERCE_BUSINESS_STANDARD";
    ShippingServiceType["DHL_ECOMMERCE_PACKET_PRIORITY"] = "DHL_ECOMMERCE_PACKET_PRIORITY";
    ShippingServiceType["DHL_ECOMMERCE_PACKET_STANDARD"] = "DHL_ECOMMERCE_PACKET_STANDARD";
    ShippingServiceType["DHL_ECOMMERCE_PACKET_IPA"] = "DHL_ECOMMERCE_PACKET_IPA";
    ShippingServiceType["DHL_ECOMMERCE_PACKET_ISAL"] = "DHL_ECOMMERCE_PACKET_ISAL";
    ShippingServiceType["DHL_ECOMMERCE_PACKET_PLUS"] = "DHL_ECOMMERCE_PACKET_PLUS";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_PRIORITY"] = "DHL_ECOMMERCE_PARCEL_PRIORITY";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_STANDARD"] = "DHL_ECOMMERCE_PARCEL_STANDARD";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_DIRECT_EXPRESS_DDU"] = "DHL_ECOMMERCE_PARCEL_DIRECT_EXPRESS_DDU";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_DIRECT_EXPRESS_DDP"] = "DHL_ECOMMERCE_PARCEL_DIRECT_EXPRESS_DDP";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_DIRECT_PRIORITY_DDU"] = "DHL_ECOMMERCE_PARCEL_DIRECT_PRIORITY_DDU";
    ShippingServiceType["DHL_ECOMMERCE_PARCEL_DIRECT_PRIORITY_DDP"] = "DHL_ECOMMERCE_PARCEL_DIRECT_PRIORITY_DDP";
    ShippingServiceType["UPS_MI_BOUND_PRINTED_MATTER"] = "UPS_MI_BOUND_PRINTED_MATTER";
    ShippingServiceType["UPS_MI_PARCEL_SELECT"] = "UPS_MI_PARCEL_SELECT";
    ShippingServiceType["UPS_MI_INTERNATIONAL_PRIORITY_AIRMAIL"] = "UPS_MI_INTERNATIONAL_PRIORITY_AIRMAIL";
    ShippingServiceType["UPS_MI_INTERNATIONAL_SURFACE_AIR_LIFT"] = "UPS_MI_INTERNATIONAL_SURFACE_AIR_LIFT";
    ShippingServiceType["UPS_MI_CONSOLIDATOR_INTERNATIONAL"] = "UPS_MI_CONSOLIDATOR_INTERNATIONAL";
    ShippingServiceType["FEDEX_GROUND"] = "FEDEX_GROUND";
    ShippingServiceType["FEDEX_HOME_DELIVERY"] = "FEDEX_HOME_DELIVERY";
    ShippingServiceType["FEDEX_2DAY"] = "FEDEX_2DAY";
    ShippingServiceType["FEDEX_2DAY_AM"] = "FEDEX_2DAY_AM";
    ShippingServiceType["FEDEX_EXPRESS_SAVER"] = "FEDEX_EXPRESS_SAVER";
    ShippingServiceType["FEDEX_STANDARD_OVERNIGHT"] = "FEDEX_STANDARD_OVERNIGHT";
    ShippingServiceType["FEDEX_PRIORITY_OVERNIGHT"] = "FEDEX_PRIORITY_OVERNIGHT";
    ShippingServiceType["FEDEX_FIRST_OVERNIGHT"] = "FEDEX_FIRST_OVERNIGHT";
    ShippingServiceType["FEDEX_SMART_POST_PRESORTED_STANDARD"] = "FEDEX_SMART_POST_PRESORTED_STANDARD";
    ShippingServiceType["FEDEX_INTERNATIONAL_ECONOMY"] = "FEDEX_INTERNATIONAL_ECONOMY";
    ShippingServiceType["FEDEX_INTERNATIONAL_PRIORITY"] = "FEDEX_INTERNATIONAL_PRIORITY";
    ShippingServiceType["FEDEX_INTERNATIONAL_FIRST"] = "FEDEX_INTERNATIONAL_FIRST";
    ShippingServiceType["FEDEX_EUROPE_FIRST"] = "FEDEX_EUROPE_FIRST";
    ShippingServiceType["FEDEX_SMART_POST_BOUND_PRINTED_MATTER"] = "FEDEX_SMART_POST_BOUND_PRINTED_MATTER";
    ShippingServiceType["FEDEX_SMART_POST_MEDIA"] = "FEDEX_SMART_POST_MEDIA";
    ShippingServiceType["FEDEX_SMART_POST_PARCEL_SELECT"] = "FEDEX_SMART_POST_PARCEL_SELECT";
    ShippingServiceType["FEDEX_1_DAY_FREIGHT"] = "FEDEX_1_DAY_FREIGHT";
    ShippingServiceType["FEDEX_2_DAY_FREIGHT"] = "FEDEX_2_DAY_FREIGHT";
    ShippingServiceType["FEDEX_3_DAY_FREIGHT"] = "FEDEX_3_DAY_FREIGHT";
    ShippingServiceType["INTERNATIONAL_ECONOMY_FREIGHT"] = "INTERNATIONAL_ECONOMY_FREIGHT";
    ShippingServiceType["INTERNATIONAL_PRIORITY_FREIGHT"] = "INTERNATIONAL_PRIORITY_FREIGHT";
    ShippingServiceType["FEDEX_FIRST_FREIGHT"] = "FEDEX_FIRST_FREIGHT";
    ShippingServiceType["FEDEX_GROUND_2"] = "FEDEX_GROUND_2";
    ShippingServiceType["OTHER"] = "OTHER";
    ShippingServiceType["DHL_GMSM_BPM_EXPEDITED"] = "DHL_GMSM_BPM_EXPEDITED";
    ShippingServiceType["DHL_GMSM_BPM_GROUND"] = "DHL_GMSM_BPM_GROUND";
    ShippingServiceType["DHL_GMSM_CATALOG_BPM_EXPEDITED"] = "DHL_GMSM_CATALOG_BPM_EXPEDITED";
    ShippingServiceType["DHL_GMSM_CATALOG_BPM_GROUND"] = "DHL_GMSM_CATALOG_BPM_GROUND";
    ShippingServiceType["DHL_GMSM_FIRST_CLASS_PARCELS"] = "DHL_GMSM_FIRST_CLASS_PARCELS";
    ShippingServiceType["DHL_GMSM_FIRST_CLASS_PRODUCT"] = "DHL_GMSM_FIRST_CLASS_PRODUCT";
    ShippingServiceType["DHL_GMSM_MEDIA_MAIL_GROUND"] = "DHL_GMSM_MEDIA_MAIL_GROUND";
    ShippingServiceType["DHL_GMSM_PARCEL_PLUS_EXPEDITED"] = "DHL_GMSM_PARCEL_PLUS_EXPEDITED";
    ShippingServiceType["DHL_GMSM_PARCEL_PLUS_GROUND"] = "DHL_GMSM_PARCEL_PLUS_GROUND";
    ShippingServiceType["DHL_GMSM_PARCELS_EXPEDITED"] = "DHL_GMSM_PARCELS_EXPEDITED";
    ShippingServiceType["DHL_GMSM_PARCELS_GROUND"] = "DHL_GMSM_PARCELS_GROUND";
    ShippingServiceType["DHL_GMSM_MARKETING_PARCEL_EXPEDITED"] = "DHL_GMSM_MARKETING_PARCEL_EXPEDITED";
    ShippingServiceType["DHL_GMSM_MARKETING_PARCEL_GROUND"] = "DHL_GMSM_MARKETING_PARCEL_GROUND";
    ShippingServiceType["DHL_GMSM_PRIORITY_MAIL"] = "DHL_GMSM_PRIORITY_MAIL";
    ShippingServiceType["DHL_GM_PRIORITY"] = "DHL_GM_PRIORITY";
    ShippingServiceType["DHL_GM_PARCEL_STANDARD"] = "DHL_GM_PARCEL_STANDARD";
    ShippingServiceType["FEDEX_PTP_HOME_DELIVERY"] = "FEDEX_PTP_HOME_DELIVERY";
    ShippingServiceType["UPS_PTP_GND"] = "UPS_PTP_GND";
    ShippingServiceType["USPS_PTP_FC"] = "USPS_PTP_FC";
    ShippingServiceType["FEDEX_PTP_PRIORITY_OVERNIGHT"] = "FEDEX_PTP_PRIORITY_OVERNIGHT";
    ShippingServiceType["FEDEX_PTP_STANDARD_OVERNIGHT"] = "FEDEX_PTP_STANDARD_OVERNIGHT";
    ShippingServiceType["FEDEX_PTP_SECOND_DAY_AM"] = "FEDEX_PTP_SECOND_DAY_AM";
    ShippingServiceType["FEDEX_PTP_SECOND_DAY"] = "FEDEX_PTP_SECOND_DAY";
    ShippingServiceType["FEDEX_PTP_EXPRESS_SAVER"] = "FEDEX_PTP_EXPRESS_SAVER";
    ShippingServiceType["USPS_PTP_EXP"] = "USPS_PTP_EXP";
    ShippingServiceType["USPS_PTP_EXP_FRE"] = "USPS_PTP_EXP_FRE";
    ShippingServiceType["USPS_PTP_PRI"] = "USPS_PTP_PRI";
    ShippingServiceType["USPS_PTP_PRI_FRE"] = "USPS_PTP_PRI_FRE";
    ShippingServiceType["USPS_PTP_PRI_LFRB"] = "USPS_PTP_PRI_LFRB";
    ShippingServiceType["USPS_PTP_PRI_MFRB"] = "USPS_PTP_PRI_MFRB";
    ShippingServiceType["USPS_PTP_PRI_SFRB"] = "USPS_PTP_PRI_SFRB";
    ShippingServiceType["USPS_PTP_PSBN"] = "USPS_PTP_PSBN";
    ShippingServiceType["UPS_PTP_NEXT_DAY_AIR"] = "UPS_PTP_NEXT_DAY_AIR";
    ShippingServiceType["UPS_PTP_NEXT_DAY_AIR_SAVER"] = "UPS_PTP_NEXT_DAY_AIR_SAVER";
    ShippingServiceType["UPS_PTP_3DAY_SELECT"] = "UPS_PTP_3DAY_SELECT";
    ShippingServiceType["UPS_PTP_2ND_DAY_AIR"] = "UPS_PTP_2ND_DAY_AIR";
    ShippingServiceType["FEDEX_PTP_GROUND"] = "FEDEX_PTP_GROUND";
    ShippingServiceType["STAMPS_US_PM_PACKAGE"] = "STAMPS_US_PM_PACKAGE";
    ShippingServiceType["STAMPS_US_FC_PACKAGE"] = "STAMPS_US_FC_PACKAGE";
    ShippingServiceType["STAMPS_US_PM_FRB"] = "STAMPS_US_PM_FRB";
    ShippingServiceType["STAMPS_US_PM_SFRB"] = "STAMPS_US_PM_SFRB";
    ShippingServiceType["STAMPS_US_PM_LFRB"] = "STAMPS_US_PM_LFRB";
    ShippingServiceType["STAMPS_US_PM_FRE"] = "STAMPS_US_PM_FRE";
    ShippingServiceType["STAMPS_US_XM_PACKAGE"] = "STAMPS_US_XM_PACKAGE";
    ShippingServiceType["STAMPS_US_XM_FRE"] = "STAMPS_US_XM_FRE";
    ShippingServiceType["STAMPS_US_PS_PACKAGE"] = "STAMPS_US_PS_PACKAGE";
    ShippingServiceType["DHL_ECSM_PARCEL_EXPEDITED"] = "DHL_ECSM_PARCEL_EXPEDITED";
    ShippingServiceType["DHL_ECSM_PARCEL_GROUND"] = "DHL_ECSM_PARCEL_GROUND";
    ShippingServiceType["DHL_EC_PARCEL_PREMIUM"] = "DHL_EC_PARCEL_PREMIUM";
    ShippingServiceType["DHL_EC_PRIORITY_MAIL"] = "DHL_EC_PRIORITY_MAIL";
    ShippingServiceType["DHL_ECSM_PARCEL_PLUS_EXPEDITED_MAX"] = "DHL_ECSM_PARCEL_PLUS_EXPEDITED_MAX";
    ShippingServiceType["USPS_PTP_EXP_LFRE"] = "USPS_PTP_EXP_LFRE";
    ShippingServiceType["USPS_PTP_PRI_PFRE"] = "USPS_PTP_PRI_PFRE";
    ShippingServiceType["USPS_PTP_PRI_RB"] = "USPS_PTP_PRI_RB";
    ShippingServiceType["USPS_PTP_PRI_RA"] = "USPS_PTP_PRI_RA";
    ShippingServiceType["USPS_PTP_PRI_LFRE"] = "USPS_PTP_PRI_LFRE";
    ShippingServiceType["USPS_PTP_EXP_PFRE"] = "USPS_PTP_EXP_PFRE";
    ShippingServiceType["DYNAMEX_PTP_SAME"] = "DYNAMEX_PTP_SAME";
    ShippingServiceType["STAMPS_US_PMI_PACKAGE"] = "STAMPS_US_PMI_PACKAGE";
    ShippingServiceType["USPS_PTP_EXP_CUSTOMS"] = "USPS_PTP_EXP_CUSTOMS";
    ShippingServiceType["USPS_PTP_PRI_CUSTOMS"] = "USPS_PTP_PRI_CUSTOMS";
    ShippingServiceType["USPS_PTP_PRI_LFRB_CUSTOMS"] = "USPS_PTP_PRI_LFRB_CUSTOMS";
    ShippingServiceType["UNITED_PARCEL_SERVICE_INC"] = "UNITED_PARCEL_SERVICE_INC";
    ShippingServiceType["AMAZON_PARTNERED_LTL_FTL"] = "AMAZON_PARTNERED_LTL_FTL";
    ShippingServiceType["AMAZON_LTL_FTL_BUSINESS_POST_UK"] = "AMAZON_LTL_FTL_BUSINESS_POST_UK";
    ShippingServiceType["AMAZON_LTL_FTL_DHL_AIRWAYS_UK"] = "AMAZON_LTL_FTL_DHL_AIRWAYS_UK";
    ShippingServiceType["AMAZON_LTL_FTL_DHL_UK"] = "AMAZON_LTL_FTL_DHL_UK";
    ShippingServiceType["AMAZON_LTL_FTL_PARCELFORCE_UK"] = "AMAZON_LTL_FTL_PARCELFORCE_UK";
    ShippingServiceType["AMAZON_LTL_FTL_DPD_UK"] = "AMAZON_LTL_FTL_DPD_UK";
    ShippingServiceType["AMAZON_LTL_FTL_TNT_LOGISTICS_UK"] = "AMAZON_LTL_FTL_TNT_LOGISTICS_UK";
    ShippingServiceType["AMAZON_LTL_FTL_TNT_UK"] = "AMAZON_LTL_FTL_TNT_UK";
    ShippingServiceType["AMAZON_LTL_FTL_YODEL_UK"] = "AMAZON_LTL_FTL_YODEL_UK";
    ShippingServiceType["AMAZON_LTL_FTL_UPS_UK"] = "AMAZON_LTL_FTL_UPS_UK";
    ShippingServiceType["AMAZON_LTL_FTL_UK_OTHER"] = "AMAZON_LTL_FTL_UK_OTHER";
    ShippingServiceType["AMAZON_LTL_FTL_DHL_EXPRESS_US"] = "AMAZON_LTL_FTL_DHL_EXPRESS_US";
    ShippingServiceType["AMAZON_LTL_FTL_FEDEX_US"] = "AMAZON_LTL_FTL_FEDEX_US";
    ShippingServiceType["AMAZON_LTL_FTL_USPS_US"] = "AMAZON_LTL_FTL_USPS_US";
    ShippingServiceType["AMAZON_LTL_FTL_UPS_US"] = "AMAZON_LTL_FTL_UPS_US";
    ShippingServiceType["AMAZON_LTL_FTL_US_OTHER"] = "AMAZON_LTL_FTL_US_OTHER";
    ShippingServiceType["USPS_FIRST_CLASS"] = "USPS_FIRST_CLASS";
    ShippingServiceType["UPS_EXPEDITED_CANADIAN_DOMESTIC_SHIPMENTS"] = "UPS_EXPEDITED_CANADIAN_DOMESTIC_SHIPMENTS";
    ShippingServiceType["UPS_EXPRESS_SAVER_CANADIAN_DOMESTIC_SHIPMENTS"] = "UPS_EXPRESS_SAVER_CANADIAN_DOMESTIC_SHIPMENTS";
    ShippingServiceType["UPS_3_DAY_SELECT_SHIPMENTS_ORIGINATING"] = "UPS_3_DAY_SELECT_SHIPMENTS_ORIGINATING";
    ShippingServiceType["UPS_ACCESS_POINT_ECONOMY_CANADIAN_DOMESTIC"] = "UPS_ACCESS_POINT_ECONOMY_CANADIAN_DOMESTIC";
    ShippingServiceType["UPS_EXPRESS_CANADIAN_DOMESTIC_SHIPMENTS"] = "UPS_EXPRESS_CANADIAN_DOMESTIC_SHIPMENTS";
    ShippingServiceType["UPS_EXPRESS_EARLY_CANADIAN_DOMESTIC_SHIPMENTS"] = "UPS_EXPRESS_EARLY_CANADIAN_DOMESTIC_SHIPMENTS";
    ShippingServiceType["UPS_EXPRESS_SAVER_INTERNATIONAL_SHIPMENTS_ORIGINATING"] = "UPS_EXPRESS_SAVER_INTERNATIONAL_SHIPMENTS_ORIGINATING";
    ShippingServiceType["UPS_STANDARD_SHIPMENTS_ORIGINATING_IN_CANADA"] = "UPS_STANDARD_SHIPMENTS_ORIGINATING_IN_CANADA";
    ShippingServiceType["UPS_WORLDWIDE_EXPEDITED_INTERNATIONAL_SHIPMENTS_ORIGINATING"] = "UPS_WORLDWIDE_EXPEDITED_INTERNATIONAL_SHIPMENTS_ORIGINATING";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS_INTERNATIONAL_SHIPMENTS_ORIGINATING"] = "UPS_WORLDWIDE_EXPRESS_INTERNATIONAL_SHIPMENTS_ORIGINATING";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS_PLUS_INTERNATIONAL_SHIPMENTS"] = "UPS_WORLDWIDE_EXPRESS_PLUS_INTERNATIONAL_SHIPMENTS";
    ShippingServiceType["UPS_EXPRESS_EARLY_SHIPMENTS_ORIGINATING_IN"] = "UPS_EXPRESS_EARLY_SHIPMENTS_ORIGINATING_IN";
    ShippingServiceType["L5"] = "L5";
    ShippingServiceType["HOME_DELIVERY"] = "HOME_DELIVERY";
    ShippingServiceType["TNT_EXPRESS"] = "TNT_EXPRESS";
    ShippingServiceType["TNT_10_A_M_EXPRESS"] = "TNT_10_A_M_EXPRESS";
    ShippingServiceType["TNT_12_A_M_EXPRESS"] = "TNT_12_A_M_EXPRESS";
    ShippingServiceType["PUROLATOR_REGULAR"] = "PUROLATOR_REGULAR";
    ShippingServiceType["PUROLATOR_EXPRESS"] = "PUROLATOR_EXPRESS";
    ShippingServiceType["NHHF_FREIGHT_REGULAR"] = "NHHF_FREIGHT_REGULAR";
    ShippingServiceType["NHHF_FREIGHT_LTL"] = "NHHF_FREIGHT_LTL";
    ShippingServiceType["FORWARD_AIR_CORP_LTL"] = "FORWARD_AIR_CORP_LTL";
    ShippingServiceType["ALLIANCE_AIR_FREIGHT_LTL"] = "ALLIANCE_AIR_FREIGHT_LTL";
    ShippingServiceType["CUSTOM_COMPANIES_LTL"] = "CUSTOM_COMPANIES_LTL";
    ShippingServiceType["TOTAL_TRANSPORTATION_DISTRIBUTION_LTL"] = "TOTAL_TRANSPORTATION_DISTRIBUTION_LTL";
    ShippingServiceType["WATKINS_SHEPARD_LTL"] = "WATKINS_SHEPARD_LTL";
    ShippingServiceType["DEPENDABLE_HIGHWAY_EXPRESS_INC"] = "DEPENDABLE_HIGHWAY_EXPRESS_INC";
    ShippingServiceType["AMZ_USPS_PRIORITY_MAIL_CUBIC"] = "AMZ_USPS_PRIORITY_MAIL_CUBIC";
    ShippingServiceType["FEDEX_PRIORITY_OVERNIGHT_ONE_RATE"] = "FEDEX_PRIORITY_OVERNIGHT_ONE_RATE";
    ShippingServiceType["FEDEX_STANDARD_OVERNIGHT_ONE_RATE"] = "FEDEX_STANDARD_OVERNIGHT_ONE_RATE";
    ShippingServiceType["FEDEX_2_DAY_AM_ONE_RATE"] = "FEDEX_2_DAY_AM_ONE_RATE";
    ShippingServiceType["FEDEX_2_DAY_ONE_RATE"] = "FEDEX_2_DAY_ONE_RATE";
    ShippingServiceType["FEDEX_EXPRESS_SAVER_ONE_RATE"] = "FEDEX_EXPRESS_SAVER_ONE_RATE";
    ShippingServiceType["AMZ_USPS_BOUND_PRINTED_MATTER"] = "AMZ_USPS_BOUND_PRINTED_MATTER";
    ShippingServiceType["AMZ_USPS_MEDIA_MAIL"] = "AMZ_USPS_MEDIA_MAIL";
    ShippingServiceType["ECOM_EXTRA"] = "ECOM_EXTRA";
    ShippingServiceType["ECOM_IPA"] = "ECOM_IPA";
    ShippingServiceType["ECOM_ISAL"] = "ECOM_ISAL";
    ShippingServiceType["ECOM_PACKET"] = "ECOM_PACKET";
    ShippingServiceType["ECOM_PACKET_DUTY_PAID"] = "ECOM_PACKET_DUTY_PAID";
    ShippingServiceType["ECOM_PMEI_DUTY_PAID"] = "ECOM_PMEI_DUTY_PAID";
    ShippingServiceType["ECOM_PMI_DUTY_PAID"] = "ECOM_PMI_DUTY_PAID";
    ShippingServiceType["ECOM_PRIORITY"] = "ECOM_PRIORITY";
    ShippingServiceType["ECOM_STANDARD"] = "ECOM_STANDARD";
    ShippingServiceType["ECOM_TRACKED_DDP"] = "ECOM_TRACKED_DDP";
    ShippingServiceType["ECOM_TRACKED_DDU"] = "ECOM_TRACKED_DDU";
    ShippingServiceType["PSDS_PMEI"] = "PSDS_PMEI";
    ShippingServiceType["PSDS_PMI"] = "PSDS_PMI";
    ShippingServiceType["ECOM_PRIORITY_PLUS"] = "ECOM_PRIORITY_PLUS";
    ShippingServiceType["USPS_PARCEL_SELECT"] = "USPS_PARCEL_SELECT";
    ShippingServiceType["USPS_PRIORITY_MAIL_REGIONAL_RATE_BOX_C"] = "USPS_PRIORITY_MAIL_REGIONAL_RATE_BOX_C";
    ShippingServiceType["FEDEX_FREIGHT_PRIORITY"] = "FEDEX_FREIGHT_PRIORITY";
    ShippingServiceType["FEDEX_FREIGHT_ECONOMY"] = "FEDEX_FREIGHT_ECONOMY";
    ShippingServiceType["PASDDU"] = "PASDDU";
    ShippingServiceType["PASDDP"] = "PASDDP";
    ShippingServiceType["PASIPA"] = "PASIPA";
    ShippingServiceType["PASEXP"] = "PASEXP";
    ShippingServiceType["BEST_RATE_DOMESTIC_STANDARD"] = "BEST_RATE_DOMESTIC_STANDARD";
    ShippingServiceType["BEST_RATE_DOMESTIC_EXPEDITED"] = "BEST_RATE_DOMESTIC_EXPEDITED";
    ShippingServiceType["BEST_RATE_INTERNATIONAL_STANDARD"] = "BEST_RATE_INTERNATIONAL_STANDARD";
    ShippingServiceType["BEST_RATE_INTERNATIONAL_EXPEDITED"] = "BEST_RATE_INTERNATIONAL_EXPEDITED";
    ShippingServiceType["DHL_PARCEL_INTERNATIONAL_STANDARD"] = "DHL_PARCEL_INTERNATIONAL_STANDARD";
    ShippingServiceType["DHL_PARCEL_INTERNATIONAL_DIRECT"] = "DHL_PARCEL_INTERNATIONAL_DIRECT";
    ShippingServiceType["DHL_SMARTMAIL_PARCEL_PLUS_GROUND"] = "DHL_SMARTMAIL_PARCEL_PLUS_GROUND";
    ShippingServiceType["DHL_SMARTMAIL_PARCEL_EXPEDITED"] = "DHL_SMARTMAIL_PARCEL_EXPEDITED";
    ShippingServiceType["DHL_SMARTMAIL_PARCEL_EXPEDITED_MAX"] = "DHL_SMARTMAIL_PARCEL_EXPEDITED_MAX";
    ShippingServiceType["BEST_RATE_DOMESTIC_OVERNIGHT"] = "BEST_RATE_DOMESTIC_OVERNIGHT";
    ShippingServiceType["BEST_RATE_INTERNATIONAL_OVERNIGHT"] = "BEST_RATE_INTERNATIONAL_OVERNIGHT";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_EPACKET"] = "UPS_MAIL_INNOVATIONS_EPACKET";
    ShippingServiceType["ONTRAC_MFN_GROUND"] = "ONTRAC_MFN_GROUND";
    ShippingServiceType["LOGISTICS_SERVICES_LOG"] = "LOGISTICS_SERVICES_LOG";
    ShippingServiceType["DOMESTIC_EXPRESS_12_00_DOT"] = "DOMESTIC_EXPRESS_12_00_DOT";
    ShippingServiceType["B2C_BTC"] = "B2C_BTC";
    ShippingServiceType["B2C_B2C"] = "B2C_B2C";
    ShippingServiceType["JETLINE_NFO"] = "JETLINE_NFO";
    ShippingServiceType["SPRINTLINE_SPL"] = "SPRINTLINE_SPL";
    ShippingServiceType["EXPRESS_EASY_XED"] = "EXPRESS_EASY_XED";
    ShippingServiceType["EXPRESS_EASY_XEP"] = "EXPRESS_EASY_XEP";
    ShippingServiceType["EUROPACK_EPA"] = "EUROPACK_EPA";
    ShippingServiceType["AUTO_REVERSALS_NA"] = "AUTO_REVERSALS_NA";
    ShippingServiceType["BREAKBULK_EXPRESS_BBX"] = "BREAKBULK_EXPRESS_BBX";
    ShippingServiceType["MEDICAL_EXPRESS_CMX"] = "MEDICAL_EXPRESS_CMX";
    ShippingServiceType["EXPRESS_WORLDWIDE_DOX"] = "EXPRESS_WORLDWIDE_DOX";
    ShippingServiceType["EXPRESS_9_00_TDE"] = "EXPRESS_9_00_TDE";
    ShippingServiceType["FREIGHT_WORLDWIDE_FRT"] = "FREIGHT_WORLDWIDE_FRT";
    ShippingServiceType["DOMESTIC_ECONOMY_SELECT_DES"] = "DOMESTIC_ECONOMY_SELECT_DES";
    ShippingServiceType["ECONOMY_SELECT_ESI"] = "ECONOMY_SELECT_ESI";
    ShippingServiceType["DOMESTIC_EXPRESS_9_00_DOK"] = "DOMESTIC_EXPRESS_9_00_DOK";
    ShippingServiceType["JUMBO_BOX_JBX"] = "JUMBO_BOX_JBX";
    ShippingServiceType["EXPRESS_9_00_TDK"] = "EXPRESS_9_00_TDK";
    ShippingServiceType["EXPRESS_10_30_TDL"] = "EXPRESS_10_30_TDL";
    ShippingServiceType["EXPRESS_10_30_TDM"] = "EXPRESS_10_30_TDM";
    ShippingServiceType["DOMESTIC_EXPRESS_DOM"] = "DOMESTIC_EXPRESS_DOM";
    ShippingServiceType["DOMESTIC_EXPRESS_10_30_DOL"] = "DOMESTIC_EXPRESS_10_30_DOL";
    ShippingServiceType["EXPRESS_WORLDWIDE_WPX"] = "EXPRESS_WORLDWIDE_WPX";
    ShippingServiceType["MEDICAL_EXPRESS_WMX"] = "MEDICAL_EXPRESS_WMX";
    ShippingServiceType["GLOBALMAIL_BUSINESS_GMB"] = "GLOBALMAIL_BUSINESS_GMB";
    ShippingServiceType["SAME_DAY_SDX"] = "SAME_DAY_SDX";
    ShippingServiceType["EXPRESS_12_00_TDT"] = "EXPRESS_12_00_TDT";
    ShippingServiceType["EXPRESS_WORLDWIDE_ECX"] = "EXPRESS_WORLDWIDE_ECX";
    ShippingServiceType["EUROPACK_EPP"] = "EUROPACK_EPP";
    ShippingServiceType["ECONOMY_SELECT_ESU"] = "ECONOMY_SELECT_ESU";
    ShippingServiceType["EXPRESS_ENVELOPE_XPD"] = "EXPRESS_ENVELOPE_XPD";
    ShippingServiceType["EXPRESS_12_00_TDY"] = "EXPRESS_12_00_TDY";
    ShippingServiceType["DESTINATION_NA"] = "DESTINATION_NA";
    ShippingServiceType["CANADA_POST_EXPEDITED"] = "CANADA_POST_EXPEDITED";
    ShippingServiceType["ROYAL_MAIL_TRACKED_48"] = "ROYAL_MAIL_TRACKED_48";
    ShippingServiceType["ROYAL_MAIL_TRACKED_24"] = "ROYAL_MAIL_TRACKED_24";
    ShippingServiceType["DPD_PARCEL_NEXT_DAY"] = "DPD_PARCEL_NEXT_DAY";
    ShippingServiceType["NEWGISTICS_PARCEL_SELECT_LIGHTWEIGHT"] = "NEWGISTICS_PARCEL_SELECT_LIGHTWEIGHT";
    ShippingServiceType["NEWGISTICS_PARCEL_SELECT"] = "NEWGISTICS_PARCEL_SELECT";
    ShippingServiceType["RRD_PRIORITY_PARCEL_DC_DOMESTIC"] = "RRD_PRIORITY_PARCEL_DC_DOMESTIC";
    ShippingServiceType["RRD_PRIORITY_PARCEL_DC"] = "RRD_PRIORITY_PARCEL_DC";
    ShippingServiceType["CANADA_POST_REGULAR_PARCEL"] = "CANADA_POST_REGULAR_PARCEL";
    ShippingServiceType["CANADA_POST_XPRESSPOST"] = "CANADA_POST_XPRESSPOST";
    ShippingServiceType["USPS_LIBRARY_MAIL"] = "USPS_LIBRARY_MAIL";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_FIRST_CLASS_MAIL"] = "UPS_MAIL_INNOVATIONS_FIRST_CLASS_MAIL";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_PRIORITY_MAIL"] = "UPS_MAIL_INNOVATIONS_PRIORITY_MAIL";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_EXPEDITED_MAIL_INNOVATIONS"] = "UPS_MAIL_INNOVATIONS_EXPEDITED_MAIL_INNOVATIONS";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_PRIORITY_MAIL_INNOVATIONS"] = "UPS_MAIL_INNOVATIONS_PRIORITY_MAIL_INNOVATIONS";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_ECONOMY_MAIL_INNOVATIONS"] = "UPS_MAIL_INNOVATIONS_ECONOMY_MAIL_INNOVATIONS";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_RETURNS"] = "UPS_MAIL_INNOVATIONS_RETURNS";
    ShippingServiceType["UPS_MAIL_INNOVATIONS_RETURNS_INTERNATIONAL"] = "UPS_MAIL_INNOVATIONS_RETURNS_INTERNATIONAL";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_PARCEL_EXPEDITED"] = "DHL_ECOM_SMART_MAIL_PARCEL_EXPEDITED";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_PARCEL_GROUND"] = "DHL_ECOM_SMART_MAIL_PARCEL_GROUND";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_PARCEL_EXPEDITED_MAX"] = "DHL_ECOM_SMART_MAIL_PARCEL_EXPEDITED_MAX";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_BOUND_PRINTED_MATTER_EXPEDITED"] = "DHL_ECOM_SMART_MAIL_BOUND_PRINTED_MATTER_EXPEDITED";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_BOUND_PRINTED_MATTER_GROUND"] = "DHL_ECOM_SMART_MAIL_BOUND_PRINTED_MATTER_GROUND";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_MARKETING_PARCEL_GROUND"] = "DHL_ECOM_SMART_MAIL_MARKETING_PARCEL_GROUND";
    ShippingServiceType["DHL_ECOM_SMART_MAIL_MARKETING_PARCEL_EXPEDITED"] = "DHL_ECOM_SMART_MAIL_MARKETING_PARCEL_EXPEDITED";
    ShippingServiceType["DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT"] = "DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT";
    ShippingServiceType["DHL_ECOM_PARCEL_INTERNATIONAL_STANDARD"] = "DHL_ECOM_PARCEL_INTERNATIONAL_STANDARD";
    ShippingServiceType["DHL_ECOM_PACKET_INTERNATIONAL"] = "DHL_ECOM_PACKET_INTERNATIONAL";
    ShippingServiceType["DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT_PRIORITY_CANADA_ORIGIN"] = "DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT_PRIORITY_CANADA_ORIGIN";
    ShippingServiceType["DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT_STANDARD_CANADA_ORIGIN"] = "DHL_ECOM_PARCEL_INTERNATIONAL_DIRECT_STANDARD_CANADA_ORIGIN";
    ShippingServiceType["DHL_ECOM_PACKET_PLUS_INTERNATIONAL"] = "DHL_ECOM_PACKET_PLUS_INTERNATIONAL";
    ShippingServiceType["DHL_ECOM_GLOBAL_MAIL_PACKET_IPA"] = "DHL_ECOM_GLOBAL_MAIL_PACKET_IPA";
    ShippingServiceType["WILL_CALL_STANDARD"] = "WILL_CALL_STANDARD";
    ShippingServiceType["PRI_DDP_DC"] = "PRI_DDP_DC";
    ShippingServiceType["AN_POST_EXPRESS_INTERNATIONAL_TRACKED"] = "AN_POST_EXPRESS_INTERNATIONAL_TRACKED";
    ShippingServiceType["HERMESINT"] = "HERMESINT";
    ShippingServiceType["HERMESPACK"] = "HERMESPACK";
    ShippingServiceType["INTERNATIONAL_PARCEL"] = "INTERNATIONAL_PARCEL";
    ShippingServiceType["PARCEL_OVER_1_POUND_EXP_W_DELCON"] = "PARCEL_OVER_1_POUND_EXP_W_DELCON";
    ShippingServiceType["PARCEL_OVER_1_POUND_GRD_W_DELCON"] = "PARCEL_OVER_1_POUND_GRD_W_DELCON";
    ShippingServiceType["BPM_W_DELCON"] = "BPM_W_DELCON";
    ShippingServiceType["BPM_NO_DELCON"] = "BPM_NO_DELCON";
    ShippingServiceType["OVER_WEIGHT_OVER_SIZED_EXP"] = "OVER_WEIGHT_OVER_SIZED_EXP";
    ShippingServiceType["OVER_WEIGHT_OVER_SIZED_GRD"] = "OVER_WEIGHT_OVER_SIZED_GRD";
    ShippingServiceType["PARCEL_CONNECT_EXP_DDU"] = "PARCEL_CONNECT_EXP_DDU";
    ShippingServiceType["PARCEL_CONNECT_EXP_DDP"] = "PARCEL_CONNECT_EXP_DDP";
    ShippingServiceType["PARCEL_CONNECT_PRIORITY_DDU"] = "PARCEL_CONNECT_PRIORITY_DDU";
    ShippingServiceType["PARCEL_CONNECT_PRIORITY_DDU_W_DELCON"] = "PARCEL_CONNECT_PRIORITY_DDU_W_DELCON";
    ShippingServiceType["PARCEL_CONNECT_PRIORITY_USPS_PQWDDU"] = "PARCEL_CONNECT_PRIORITY_USPS_PQWDDU";
    ShippingServiceType["PARCEL_CONNECT_PRIORITY_DDP"] = "PARCEL_CONNECT_PRIORITY_DDP";
    ShippingServiceType["PARCEL_CONNECT_PRIORITY_DDP_W_DELCON"] = "PARCEL_CONNECT_PRIORITY_DDP_W_DELCON";
    ShippingServiceType["PARCEL_CONNECT_STANDARD_DDU"] = "PARCEL_CONNECT_STANDARD_DDU";
    ShippingServiceType["PARCEL_CONNECT_STANDARD_USPS_PQWDDU"] = "PARCEL_CONNECT_STANDARD_USPS_PQWDDU";
    ShippingServiceType["PARCEL_CONNECT_USPS_E_PACKET_DDU"] = "PARCEL_CONNECT_USPS_E_PACKET_DDU";
    ShippingServiceType["PARCEL_CONNECT_BOOK_SERVICE_DDU"] = "PARCEL_CONNECT_BOOK_SERVICE_DDU";
    ShippingServiceType["PARCEL_CONNECT_OVER_WEIGHT_OVER_SIZED_INT_DDU"] = "PARCEL_CONNECT_OVER_WEIGHT_OVER_SIZED_INT_DDU";
    ShippingServiceType["PARCEL_CONNECT_OVER_WEIGHT_OVER_SIZED_INT_DDP"] = "PARCEL_CONNECT_OVER_WEIGHT_OVER_SIZED_INT_DDP";
    ShippingServiceType["ASENDIA_PMI"] = "ASENDIA_PMI";
    ShippingServiceType["ASENDIA_IPA"] = "ASENDIA_IPA";
    ShippingServiceType["ASENDIA_E_PACKET"] = "ASENDIA_E_PACKET";
    ShippingServiceType["ASENDIA_ISAL"] = "ASENDIA_ISAL";
    ShippingServiceType["ASENDIA_OTHER"] = "ASENDIA_OTHER";
    ShippingServiceType["ASENDIA_PRIORITY_TRACKED"] = "ASENDIA_PRIORITY_TRACKED";
    ShippingServiceType["ASENDIA_P_M_E_I"] = "ASENDIA_P_M_E_I";
    ShippingServiceType["ASENDIA_INTERNATIONAL_EXPRESS"] = "ASENDIA_INTERNATIONAL_EXPRESS";
    ShippingServiceType["EXPRESS_E_PARCEL_POST_RETURNS"] = "EXPRESS_E_PARCEL_POST_RETURNS";
    ShippingServiceType["EXPRESS_E_PARCEL_POST_RETURNS_ZONAL_1"] = "EXPRESS_E_PARCEL_POST_RETURNS_ZONAL_1";
    ShippingServiceType["EXPRESS_E_PARCEL_POST_RETURNS_ZONAL_2"] = "EXPRESS_E_PARCEL_POST_RETURNS_ZONAL_2";
    ShippingServiceType["E_PARCEL_POST_RETURNS"] = "E_PARCEL_POST_RETURNS";
    ShippingServiceType["E_PARCEL_POST_RETURNS_ZONAL_1"] = "E_PARCEL_POST_RETURNS_ZONAL_1";
    ShippingServiceType["E_PARCEL_POST_RETURNS_ZONAL_2"] = "E_PARCEL_POST_RETURNS_ZONAL_2";
    ShippingServiceType["INTERNATIONAL_EXPRESSMERCHANDISE"] = "INTERNATIONAL_EXPRESSMERCHANDISE";
    ShippingServiceType["EXPRESS_POST_CODE_3_I83"] = "EXPRESS_POST_CODE_3_I83";
    ShippingServiceType["EXPRESS_POST_CODE_3_J03"] = "EXPRESS_POST_CODE_3_J03";
    ShippingServiceType["EXPRESS_POST_CODE_3_J33"] = "EXPRESS_POST_CODE_3_J33";
    ShippingServiceType["EXPRESS_POST_CODE_7_I33"] = "EXPRESS_POST_CODE_7_I33";
    ShippingServiceType["EXPRESS_POST_CODE_7_I53"] = "EXPRESS_POST_CODE_7_I53";
    ShippingServiceType["EXPRESS_POST_CODE_7_I83"] = "EXPRESS_POST_CODE_7_I83";
    ShippingServiceType["EXPRESS_POST_CODE_7_J53"] = "EXPRESS_POST_CODE_7_J53";
    ShippingServiceType["EXPRESS_POST_CODE_7_J83"] = "EXPRESS_POST_CODE_7_J83";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_I05"] = "EXPRESS_POST_SIGNATURE_CODE_3_I05";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_I35"] = "EXPRESS_POST_SIGNATURE_CODE_3_I35";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_I55"] = "EXPRESS_POST_SIGNATURE_CODE_3_I55";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_I85"] = "EXPRESS_POST_SIGNATURE_CODE_3_I85";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_J05"] = "EXPRESS_POST_SIGNATURE_CODE_3_J05";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_J35"] = "EXPRESS_POST_SIGNATURE_CODE_3_J35";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_J55"] = "EXPRESS_POST_SIGNATURE_CODE_3_J55";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_J85"] = "EXPRESS_POST_SIGNATURE_CODE_3_J85";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_3_K55"] = "EXPRESS_POST_SIGNATURE_CODE_3_K55";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_7_I55"] = "EXPRESS_POST_SIGNATURE_CODE_7_I55";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_7_I85"] = "EXPRESS_POST_SIGNATURE_CODE_7_I85";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_7_J05"] = "EXPRESS_POST_SIGNATURE_CODE_7_J05";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_7_J55"] = "EXPRESS_POST_SIGNATURE_CODE_7_J55";
    ShippingServiceType["EXPRESS_POST_SIGNATURE_CODE_7_J85"] = "EXPRESS_POST_SIGNATURE_CODE_7_J85";
    ShippingServiceType["EXPRESS_POST_WINE_SIGNATURE_CODE_3_V85"] = "EXPRESS_POST_WINE_SIGNATURE_CODE_3_V85";
    ShippingServiceType["EXPRESS_POST_WINE_SIGNATURE_CODE_7_U85"] = "EXPRESS_POST_WINE_SIGNATURE_CODE_7_U85";
    ShippingServiceType["INTERNATIONAL_ECONOMY"] = "INTERNATIONAL_ECONOMY";
    ShippingServiceType["INTERNATIONAL_STANDARD_SIGNATURE"] = "INTERNATIONAL_STANDARD_SIGNATURE";
    ShippingServiceType["INTERNATIONAL_STANDARD"] = "INTERNATIONAL_STANDARD";
    ShippingServiceType["PARCEL_POST_CODE_3_C03"] = "PARCEL_POST_CODE_3_C03";
    ShippingServiceType["PARCEL_POST_CODE_3_C83"] = "PARCEL_POST_CODE_3_C83";
    ShippingServiceType["PARCEL_POST_CODE_3_D03"] = "PARCEL_POST_CODE_3_D03";
    ShippingServiceType["PARCEL_POST_CODE_3_D33"] = "PARCEL_POST_CODE_3_D33";
    ShippingServiceType["PARCEL_POST_CODE_3_D53"] = "PARCEL_POST_CODE_3_D53";
    ShippingServiceType["PARCEL_POST_CODE_3_D83"] = "PARCEL_POST_CODE_3_D83";
    ShippingServiceType["PARCEL_POST_CODE_7_C33"] = "PARCEL_POST_CODE_7_C33";
    ShippingServiceType["PARCEL_POST_CODE_7_C53"] = "PARCEL_POST_CODE_7_C53";
    ShippingServiceType["PARCEL_POST_CODE_7_C83"] = "PARCEL_POST_CODE_7_C83";
    ShippingServiceType["PARCEL_POST_CODE_7_D03"] = "PARCEL_POST_CODE_7_D03";
    ShippingServiceType["PARCEL_POST_CODE_7_D33"] = "PARCEL_POST_CODE_7_D33";
    ShippingServiceType["PARCEL_POST_CODE_7_D53"] = "PARCEL_POST_CODE_7_D53";
    ShippingServiceType["PARCEL_POST_CODE_7_D83"] = "PARCEL_POST_CODE_7_D83";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_C05"] = "PARCEL_POST_SIGNATURE_CODE_3_C05";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_C53"] = "PARCEL_POST_SIGNATURE_CODE_3_C53";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_C55"] = "PARCEL_POST_SIGNATURE_CODE_3_C55";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_C85"] = "PARCEL_POST_SIGNATURE_CODE_3_C85";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_D05"] = "PARCEL_POST_SIGNATURE_CODE_3_D05";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_D35"] = "PARCEL_POST_SIGNATURE_CODE_3_D35";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_D55"] = "PARCEL_POST_SIGNATURE_CODE_3_D55";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_3_D85"] = "PARCEL_POST_SIGNATURE_CODE_3_D85";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_C05"] = "PARCEL_POST_SIGNATURE_CODE_7_C05";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_C35"] = "PARCEL_POST_SIGNATURE_CODE_7_C35";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_C55"] = "PARCEL_POST_SIGNATURE_CODE_7_C55";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_C85"] = "PARCEL_POST_SIGNATURE_CODE_7_C85";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_D05"] = "PARCEL_POST_SIGNATURE_CODE_7_D05";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_D35"] = "PARCEL_POST_SIGNATURE_CODE_7_D35";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_D55"] = "PARCEL_POST_SIGNATURE_CODE_7_D55";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_D85"] = "PARCEL_POST_SIGNATURE_CODE_7_D85";
    ShippingServiceType["PARCEL_POST_SIGNATURE_CODE_7_E55"] = "PARCEL_POST_SIGNATURE_CODE_7_E55";
    ShippingServiceType["PARCEL_POST_WINE"] = "PARCEL_POST_WINE";
    ShippingServiceType["PARCEL_POST_WINE_SIGNATURE_CODE_3_P85"] = "PARCEL_POST_WINE_SIGNATURE_CODE_3_P85";
    ShippingServiceType["PARCEL_POST_WINE_SIGNATURE_CODE_7_O35"] = "PARCEL_POST_WINE_SIGNATURE_CODE_7_O35";
    ShippingServiceType["PARCEL_POST_WINE_SIGNATURE_CODE_7_O85"] = "PARCEL_POST_WINE_SIGNATURE_CODE_7_O85";
    ShippingServiceType["INTERNATIONAL_ECONOMY_SIGNATURE"] = "INTERNATIONAL_ECONOMY_SIGNATURE";
    ShippingServiceType["E_PARCEL"] = "E_PARCEL";
    ShippingServiceType["EXPRESS_NATIONAL_FULL_RATE"] = "EXPRESS_NATIONAL_FULL_RATE";
    ShippingServiceType["EXPRESS_POST"] = "EXPRESS_POST";
    ShippingServiceType["EXPRESS_POST_E_PARCEL"] = "EXPRESS_POST_E_PARCEL";
    ShippingServiceType["EXPRESS_POST_SIGNATURE"] = "EXPRESS_POST_SIGNATURE";
    ShippingServiceType["NATIONAL_FULL_RATE"] = "NATIONAL_FULL_RATE";
    ShippingServiceType["PARCEL_POST"] = "PARCEL_POST";
    ShippingServiceType["PARCEL_POST_SIGNATURE"] = "PARCEL_POST_SIGNATURE";
    ShippingServiceType["CANADA_POST_PRIORITY"] = "CANADA_POST_PRIORITY";
    ShippingServiceType["CANADA_POST_EXPEDITED_PARCEL"] = "CANADA_POST_EXPEDITED_PARCEL";
    ShippingServiceType["PARCEL_STANDARD"] = "PARCEL_STANDARD";
    ShippingServiceType["PARCEL_DIRECT_PRIORITY"] = "PARCEL_DIRECT_PRIORITY";
    ShippingServiceType["SM_PARCEL_EXPEDITED_MAX"] = "SM_PARCEL_EXPEDITED_MAX";
    ShippingServiceType["GM_SMARTMAIL_SHIPMENTS_LESS_THAN_1_POUND"] = "GM_SMARTMAIL_SHIPMENTS_LESS_THAN_1_POUND";
    ShippingServiceType["GM_PARCEL_PLUS_1_70_POUNDS"] = "GM_PARCEL_PLUS_1_70_POUNDS";
    ShippingServiceType["GM_PARCEL_PLUS_EXPEDITED_1_15_POUNDS"] = "GM_PARCEL_PLUS_EXPEDITED_1_15_POUNDS";
    ShippingServiceType["SM_BPM_EXPEDITED"] = "SM_BPM_EXPEDITED";
    ShippingServiceType["SM_BPM_GROUND"] = "SM_BPM_GROUND";
    ShippingServiceType["GLOBAL_MAIL_SMARTMAIL_CATALOG_BOUND_PRINTED_MATTER_EXPEDITED"] = "GLOBAL_MAIL_SMARTMAIL_CATALOG_BOUND_PRINTED_MATTER_EXPEDITED";
    ShippingServiceType["GLOBAL_MAIL_SMARTMAIL_CATALOG_BOUND_PRINTED_MATTER_STANDARD"] = "GLOBAL_MAIL_SMARTMAIL_CATALOG_BOUND_PRINTED_MATTER_STANDARD";
    ShippingServiceType["SM_MEDIAMAIL_GROUND"] = "SM_MEDIAMAIL_GROUND";
    ShippingServiceType["SM_PARCELS_EXPEDITED"] = "SM_PARCELS_EXPEDITED";
    ShippingServiceType["SM_PARCELS_GROUND"] = "SM_PARCELS_GROUND";
    ShippingServiceType["SM_PARCEL_PLUS_GROUND"] = "SM_PARCEL_PLUS_GROUND";
    ShippingServiceType["SM_PARCEL_PLUS_EXPEDITED"] = "SM_PARCEL_PLUS_EXPEDITED";
    ShippingServiceType["SM_MARKETING_PARCEL_GROUND"] = "SM_MARKETING_PARCEL_GROUND";
    ShippingServiceType["SM_MARKETING_PARCEL_EXPEDITED"] = "SM_MARKETING_PARCEL_EXPEDITED";
    ShippingServiceType["GM_BUSINESS_PRIORITY_BMP"] = "GM_BUSINESS_PRIORITY_BMP";
    ShippingServiceType["GM_BUSINESS_STANDARD_BMS"] = "GM_BUSINESS_STANDARD_BMS";
    ShippingServiceType["GLOBAL_MAIL_PARCEL_COMMERCIAL"] = "GLOBAL_MAIL_PARCEL_COMMERCIAL";
    ShippingServiceType["DHL_GLOBALMAIL_PARCEL"] = "DHL_GLOBALMAIL_PARCEL";
    ShippingServiceType["GLOBAL_MAIL_PARCEL_TRACK_AND_TRACE"] = "GLOBAL_MAIL_PARCEL_TRACK_AND_TRACE";
    ShippingServiceType["GLOBAL_MAIL_PARCEL_TRACK_AND_TRACE_COMMERCIAL"] = "GLOBAL_MAIL_PARCEL_TRACK_AND_TRACE_COMMERCIAL";
    ShippingServiceType["GM_PARCEL_PRIORITY_PLP"] = "GM_PARCEL_PRIORITY_PLP";
    ShippingServiceType["GM_PARCEL_STANDARD_PLS"] = "GM_PARCEL_STANDARD_PLS";
    ShippingServiceType["GM_PACKET_IPA_PKA"] = "GM_PACKET_IPA_PKA";
    ShippingServiceType["GM_PACKET_ISAL_PKL"] = "GM_PACKET_ISAL_PKL";
    ShippingServiceType["GM_PARCEL_DIRECT_EXPRESS_PLX"] = "GM_PARCEL_DIRECT_EXPRESS_PLX";
    ShippingServiceType["GM_PACKET_PLUS_PKT"] = "GM_PACKET_PLUS_PKT";
    ShippingServiceType["GM_PARCEL_DIRECT_PLT"] = "GM_PARCEL_DIRECT_PLT";
    ShippingServiceType["GM_PACKET_PRIORITY_WS"] = "GM_PACKET_PRIORITY_WS";
    ShippingServiceType["GM_PACKET_STANDARD_WS"] = "GM_PACKET_STANDARD_WS";
    ShippingServiceType["GM_PACKET_PRIORITY_PKY"] = "GM_PACKET_PRIORITY_PKY";
    ShippingServiceType["GM_PACKET_STANDARD_PKD"] = "GM_PACKET_STANDARD_PKD";
    ShippingServiceType["GM_PARCEL_PRIORITY_PLY"] = "GM_PARCEL_PRIORITY_PLY";
    ShippingServiceType["GM_PARCEL_STANDARD_PLD"] = "GM_PARCEL_STANDARD_PLD";
    ShippingServiceType["BREAK_BULK_ECONOMY"] = "BREAK_BULK_ECONOMY";
    ShippingServiceType["CUSTOMS_SERVICES"] = "CUSTOMS_SERVICES";
    ShippingServiceType["EASY_SHOP_NONDOC"] = "EASY_SHOP_NONDOC";
    ShippingServiceType["EASY_SHOP_DOC"] = "EASY_SHOP_DOC";
    ShippingServiceType["IMPORT_EXPRESS_FLEX"] = "IMPORT_EXPRESS_FLEX";
    ShippingServiceType["SECURELINE"] = "SECURELINE";
    ShippingServiceType["GLOBALMAIL_BUSINESS_STANDARD"] = "GLOBALMAIL_BUSINESS_STANDARD";
    ShippingServiceType["DHL_PARCEL_INTERNATIONAL_PRIORITY"] = "DHL_PARCEL_INTERNATIONAL_PRIORITY";
    ShippingServiceType["DHL_GLOBALMAIL_PACKET_ISAL"] = "DHL_GLOBALMAIL_PACKET_ISAL";
    ShippingServiceType["GLOBALMAIL_BUSINESS_PRIORITY"] = "GLOBALMAIL_BUSINESS_PRIORITY";
    ShippingServiceType["DHL_GLOBALMAIL_PACKET_PLUS"] = "DHL_GLOBALMAIL_PACKET_PLUS";
    ShippingServiceType["DPD_12_00"] = "DPD_12_00";
    ShippingServiceType["DPD_10_30"] = "DPD_10_30";
    ShippingServiceType["SATURDAY_DELIVERY"] = "SATURDAY_DELIVERY";
    ShippingServiceType["SUNDAY_DELIVERY"] = "SUNDAY_DELIVERY";
    ShippingServiceType["STANDARD_MAIL"] = "STANDARD_MAIL";
    ShippingServiceType["EXPRESSMAIL_PACKAGE"] = "EXPRESSMAIL_PACKAGE";
    ShippingServiceType["PRIORITY_MAIL_CUBED"] = "PRIORITY_MAIL_CUBED";
    ShippingServiceType["EXPRESSMAIL_FLAT_RATE_ENVELOPE"] = "EXPRESSMAIL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["EXPRESSMAIL_FLAT_RATE_LEGAL_ENVELOPE"] = "EXPRESSMAIL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["EXPRESSMAIL_MEDIUM_FLATE_RATE_BOX"] = "EXPRESSMAIL_MEDIUM_FLATE_RATE_BOX";
    ShippingServiceType["FIRST_CLASS_PACKAGE_SERVICE"] = "FIRST_CLASS_PACKAGE_SERVICE";
    ShippingServiceType["PARCEL_SELECT_LIGHT_WEIGHT"] = "PARCEL_SELECT_LIGHT_WEIGHT";
    ShippingServiceType["PRIORITY_MAIL_MED_FLAT_RATE_BOX"] = "PRIORITY_MAIL_MED_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_PADDED_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_SMALL_FLAT_RATE_BOX"] = "PRIORITY_MAIL_SMALL_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_LEGAL_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_GIFT_CARD_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_GIFT_CARD_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_WINDOW_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_WINDOW_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_CARDBOARD_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_CARDBOARD_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_FLAT_RATE_SMALL_ENVELOPE"] = "PRIORITY_MAIL_FLAT_RATE_SMALL_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_REGIONAL_RATE_BOX_A"] = "PRIORITY_MAIL_REGIONAL_RATE_BOX_A";
    ShippingServiceType["PRIORITY_MAIL_REGIONAL_RATE_BOX_B"] = "PRIORITY_MAIL_REGIONAL_RATE_BOX_B";
    ShippingServiceType["PRIORITY_MAIL_REGIONAL_RATE_BOX_C"] = "PRIORITY_MAIL_REGIONAL_RATE_BOX_C";
    ShippingServiceType["PRIORITY_MAIL_COMMERCIAL_PLUS_SOFT_PACK"] = "PRIORITY_MAIL_COMMERCIAL_PLUS_SOFT_PACK";
    ShippingServiceType["EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_BOX"] = "EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_BOX";
    ShippingServiceType["EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE"] = "EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["GLOBAL_AIR_PARCEL_POST"] = "GLOBAL_AIR_PARCEL_POST";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_ENVELOPE"] = "PRIORITY_MAIL_INTL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_MED_BOX"] = "PRIORITY_MAIL_INTL_FLAT_RATE_MED_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_SMALL_BOX"] = "PRIORITY_MAIL_INTL_FLAT_RATE_SMALL_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_LARGE_BOX"] = "PRIORITY_MAIL_INTL_FLAT_RATE_LARGE_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTL_D_V_D_FLAT_RATE_BOX"] = "PRIORITY_MAIL_INTL_D_V_D_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTLLARGE_VIDEO_FLAT_RATE_BOX"] = "PRIORITY_MAIL_INTLLARGE_VIDEO_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_LEGAL_ENVELOPE"] = "PRIORITY_MAIL_INTL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["PRIORITY_MAIL_INTL_FLAT_RATE_PADDED_ENVELOPE"] = "PRIORITY_MAIL_INTL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["EXPRESSMAIL_INTL_FLAT_RATE_LEGAL_ENVELOPE"] = "EXPRESSMAIL_INTL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["FIRST_CLASSMAIL_FLATS"] = "FIRST_CLASSMAIL_FLATS";
    ShippingServiceType["FIRST_CLASSMAILLARGE_ENVELOPE_OR_FLAT"] = "FIRST_CLASSMAILLARGE_ENVELOPE_OR_FLAT";
    ShippingServiceType["FIRST_CLASSMAIL_THICK_ENVELOPE"] = "FIRST_CLASSMAIL_THICK_ENVELOPE";
    ShippingServiceType["FIRST_CLASSMAILLETTER"] = "FIRST_CLASSMAILLETTER";
    ShippingServiceType["FED_EX_SMART_POST_PARCEL_SELECT_LIGHTWEIGHT"] = "FED_EX_SMART_POST_PARCEL_SELECT_LIGHTWEIGHT";
    ShippingServiceType["FED_EX_ECONOMY_C_A"] = "FED_EX_ECONOMY_C_A";
    ShippingServiceType["SAME_DAY"] = "SAME_DAY";
    ShippingServiceType["SAME_DAY_CITY"] = "SAME_DAY_CITY";
    ShippingServiceType["SMART_POST_INTERNATIONAL"] = "SMART_POST_INTERNATIONAL";
    ShippingServiceType["INTERNATIONAL_NEXT_FLIGHT"] = "INTERNATIONAL_NEXT_FLIGHT";
    ShippingServiceType["INTERNATIONAL_PRIORITY_DIRECT_DISTRIBUTION"] = "INTERNATIONAL_PRIORITY_DIRECT_DISTRIBUTION";
    ShippingServiceType["INTERNATIONAL_DIRECT_DISTRIBUTION_SURFACE_SOLUTION"] = "INTERNATIONAL_DIRECT_DISTRIBUTION_SURFACE_SOLUTION";
    ShippingServiceType["INTERNATIONAL_DIRECT_DISTRIBUTION_AIR_SOLUTION"] = "INTERNATIONAL_DIRECT_DISTRIBUTION_AIR_SOLUTION";
    ShippingServiceType["INTERNATIONAL_MAIL_SERVICE"] = "INTERNATIONAL_MAIL_SERVICE";
    ShippingServiceType["FED_EX_NEXT_DAY_BY_10_AM"] = "FED_EX_NEXT_DAY_BY_10_AM";
    ShippingServiceType["FED_EX_NEXT_DAY_BY_12_NOON"] = "FED_EX_NEXT_DAY_BY_12_NOON";
    ShippingServiceType["FED_EX_NEXT_DAY"] = "FED_EX_NEXT_DAY";
    ShippingServiceType["GLOBALMAIL_PARCEL_DIRECT_EXPRESS"] = "GLOBALMAIL_PARCEL_DIRECT_EXPRESS";
    ShippingServiceType["GLOBAL_MAIL_PARCEL_DIRECT_DDP"] = "GLOBAL_MAIL_PARCEL_DIRECT_DDP";
    ShippingServiceType["FED_EX_SMART_POST_PARCEL_SELECT"] = "FED_EX_SMART_POST_PARCEL_SELECT";
    ShippingServiceType["FED_EX_2_DAY"] = "FED_EX_2_DAY";
    ShippingServiceType["FED_EX_INTERNATIONAL_ECONOMY"] = "FED_EX_INTERNATIONAL_ECONOMY";
    ShippingServiceType["FED_EX_PRIORITY_OVERNIGHT"] = "FED_EX_PRIORITY_OVERNIGHT";
    ShippingServiceType["X_PARCEL"] = "X_PARCEL";
    ShippingServiceType["GLOBALMAIL_PACKET_STANDARD"] = "GLOBALMAIL_PACKET_STANDARD";
    ShippingServiceType["PMOD_PARCEL_SELECT"] = "PMOD_PARCEL_SELECT";
    ShippingServiceType["GLOBALMAIL_PACKET_PRIORITY"] = "GLOBALMAIL_PACKET_PRIORITY";
    ShippingServiceType["GLOBALMAIL_PACKET_PLUS"] = "GLOBALMAIL_PACKET_PLUS";
    ShippingServiceType["SMARTMAIL_PARCEL_PLUS_GROUND"] = "SMARTMAIL_PARCEL_PLUS_GROUND";
    ShippingServiceType["GLOBALMAIL_PARCEL_STANDARD"] = "GLOBALMAIL_PARCEL_STANDARD";
    ShippingServiceType["SMARTMAIL_PARCELS_EXPEDITED"] = "SMARTMAIL_PARCELS_EXPEDITED";
    ShippingServiceType["PMOD_PARCEL_SELECT_LIGHTWEIGHT"] = "PMOD_PARCEL_SELECT_LIGHTWEIGHT";
    ShippingServiceType["USPS_FIRST_CLASS_PACKAGE"] = "USPS_FIRST_CLASS_PACKAGE";
    ShippingServiceType["FED_EX_HOME_DELIVERY"] = "FED_EX_HOME_DELIVERY";
    ShippingServiceType["FIRSTMILE_UPS_2ND_DAY_AIR"] = "FIRSTMILE_UPS_2ND_DAY_AIR";
    ShippingServiceType["FIRSTMILE_FED_EX_SMART_POST_PARCEL_SELECT_LIGHTWEIGHT"] = "FIRSTMILE_FED_EX_SMART_POST_PARCEL_SELECT_LIGHTWEIGHT";
    ShippingServiceType["FIRSTMILE_UPS_NEXT_DAY_AIR"] = "FIRSTMILE_UPS_NEXT_DAY_AIR";
    ShippingServiceType["ON_TRAC_PARCEL_SELECT_LIGHTWEIGHT"] = "ON_TRAC_PARCEL_SELECT_LIGHTWEIGHT";
    ShippingServiceType["SMARTMAIL_FLATS_GROUND"] = "SMARTMAIL_FLATS_GROUND";
    ShippingServiceType["GLOBALMAIL_PARCEL_DIRECT_DDU"] = "GLOBALMAIL_PARCEL_DIRECT_DDU";
    ShippingServiceType["SMARTMAIL_PARCELS_GROUND"] = "SMARTMAIL_PARCELS_GROUND";
    ShippingServiceType["EXPRESS_WORLDWIDE"] = "EXPRESS_WORLDWIDE";
    ShippingServiceType["ON_TRAC_PARCEL_SELECT"] = "ON_TRAC_PARCEL_SELECT";
    ShippingServiceType["SMARTMAIL_PARCEL_PLUS_EXPEDITED"] = "SMARTMAIL_PARCEL_PLUS_EXPEDITED";
    ShippingServiceType["FIRSTMILE_UPS_3_DAY_SELECT"] = "FIRSTMILE_UPS_3_DAY_SELECT";
    ShippingServiceType["FED_EX_INTERNATIONAL_PRIORITY"] = "FED_EX_INTERNATIONAL_PRIORITY";
    ShippingServiceType["GLOBALMAIL_PARCEL_PRIORITY"] = "GLOBALMAIL_PARCEL_PRIORITY";
    ShippingServiceType["FIRST_CLASS_FLATS"] = "FIRST_CLASS_FLATS";
    ShippingServiceType["FED_EX_GROUND"] = "FED_EX_GROUND";
    ShippingServiceType["SMARTMAIL_BPM_GROUND"] = "SMARTMAIL_BPM_GROUND";
    ShippingServiceType["SMARTMAIL_MARKETING_PARCEL_GROUND"] = "SMARTMAIL_MARKETING_PARCEL_GROUND";
    ShippingServiceType["FIRSTMILE_UPS_GROUND"] = "FIRSTMILE_UPS_GROUND";
    ShippingServiceType["X_P_O_IPA_SERVICE"] = "X_P_O_IPA_SERVICE";
    ShippingServiceType["SMARTMAIL_MARKETING_PARCEL_EXPEDITED"] = "SMARTMAIL_MARKETING_PARCEL_EXPEDITED";
    ShippingServiceType["X_PARCEL_GROUND"] = "X_PARCEL_GROUND";
    ShippingServiceType["FIRSTMILE_UPS_NEXT_DAY_AIR_SAVER"] = "FIRSTMILE_UPS_NEXT_DAY_AIR_SAVER";
    ShippingServiceType["PRIORITY_MAIL"] = "PRIORITY_MAIL";
    ShippingServiceType["FED_EX_STANDARD_OVERNIGHT"] = "FED_EX_STANDARD_OVERNIGHT";
    ShippingServiceType["GLOBALMAIL_PACKET_ISAL"] = "GLOBALMAIL_PACKET_ISAL";
    ShippingServiceType["SMARTMAIL_FLATS_EXPEDITED"] = "SMARTMAIL_FLATS_EXPEDITED";
    ShippingServiceType["GLOBALMAIL_PACKET_IPA"] = "GLOBALMAIL_PACKET_IPA";
    ShippingServiceType["X_PARCEL_EXPEDITED"] = "X_PARCEL_EXPEDITED";
    ShippingServiceType["SMARTMAIL_BPM_EXPEDITED"] = "SMARTMAIL_BPM_EXPEDITED";
    ShippingServiceType["FED_EX_EXPRESS_SAVER"] = "FED_EX_EXPRESS_SAVER";
    ShippingServiceType["GLOBEGISTICS_E_COM_DEL_CON_C_N22"] = "GLOBEGISTICS_E_COM_DEL_CON_C_N22";
    ShippingServiceType["GLOBEGISTICS_E_COM_DEL_CON_PAID"] = "GLOBEGISTICS_E_COM_DEL_CON_PAID";
    ShippingServiceType["GLOBEGISTICS_E_COM_PMI_P_D_S"] = "GLOBEGISTICS_E_COM_PMI_P_D_S";
    ShippingServiceType["GLOBEGISTICS_E_COM_STANDARD_C_N22"] = "GLOBEGISTICS_E_COM_STANDARD_C_N22";
    ShippingServiceType["GLOBEGISTICS_E_COM_P_M_E_I_P_D_S"] = "GLOBEGISTICS_E_COM_P_M_E_I_P_D_S";
    ShippingServiceType["LSO_MEXICO"] = "LSO_MEXICO";
    ShippingServiceType["LSO_PRIORITY_OVERNIGHT"] = "LSO_PRIORITY_OVERNIGHT";
    ShippingServiceType["LSO_ECONOMY_NEXT_DAY"] = "LSO_ECONOMY_NEXT_DAY";
    ShippingServiceType["LSO_SATURDAY"] = "LSO_SATURDAY";
    ShippingServiceType["LSO_GROUND"] = "LSO_GROUND";
    ShippingServiceType["LSO_2ND_DAY"] = "LSO_2ND_DAY";
    ShippingServiceType["FIRST_CLASSMAIL"] = "FIRST_CLASSMAIL";
    ShippingServiceType["MEDIAMAIL"] = "MEDIAMAIL";
    ShippingServiceType["BOUND_PRINTED_MATTER"] = "BOUND_PRINTED_MATTER";
    ShippingServiceType["STANDARD_POST"] = "STANDARD_POST";
    ShippingServiceType["NEWGISTICS_PARCEL_RETURN_SERVICE"] = "NEWGISTICS_PARCEL_RETURN_SERVICE";
    ShippingServiceType["NEWGISTICS_FIRST_CLASSMAIL_PACKAGES"] = "NEWGISTICS_FIRST_CLASSMAIL_PACKAGES";
    ShippingServiceType["NEWGISTICS_PRIORITY_MAIL"] = "NEWGISTICS_PRIORITY_MAIL";
    ShippingServiceType["SUNRISE_SERVICE"] = "SUNRISE_SERVICE";
    ShippingServiceType["PALLETIZED_FREIGHT_SERVICE"] = "PALLETIZED_FREIGHT_SERVICE";
    ShippingServiceType["SUNRISE_GOLD_SERVICE"] = "SUNRISE_GOLD_SERVICE";
    ShippingServiceType["ON_TRAC_GROUND_SERVICE"] = "ON_TRAC_GROUND_SERVICE";
    ShippingServiceType["PUROLATOR_EXPRESS_9_AM"] = "PUROLATOR_EXPRESS_9_AM";
    ShippingServiceType["PUROLATOR_EXPRESS_10_30_AM"] = "PUROLATOR_EXPRESS_10_30_AM";
    ShippingServiceType["PUROLATOR_EXPRESS_EVENING"] = "PUROLATOR_EXPRESS_EVENING";
    ShippingServiceType["PUROLATOR_GROUND_EVENING"] = "PUROLATOR_GROUND_EVENING";
    ShippingServiceType["PUROLATOR_EXPRESS_US"] = "PUROLATOR_EXPRESS_US";
    ShippingServiceType["PUROLATOR_EXPRESS_INTERNATIONAL"] = "PUROLATOR_EXPRESS_INTERNATIONAL";
    ShippingServiceType["PUROLATOR_GROUND_9_AM"] = "PUROLATOR_GROUND_9_AM";
    ShippingServiceType["PUROLATOR_GROUND_10_30_AM"] = "PUROLATOR_GROUND_10_30_AM";
    ShippingServiceType["PUROLATOR_GROUND_US"] = "PUROLATOR_GROUND_US";
    ShippingServiceType["PUROLATOR_EXPRESS_US_10_30_AM"] = "PUROLATOR_EXPRESS_US_10_30_AM";
    ShippingServiceType["PUROLATOR_EXPRESS_US_12_00"] = "PUROLATOR_EXPRESS_US_12_00";
    ShippingServiceType["PUROLATOR_EXPRESS_US_9_AM"] = "PUROLATOR_EXPRESS_US_9_AM";
    ShippingServiceType["FIRST_CLASS_BPL"] = "FIRST_CLASS_BPL";
    ShippingServiceType["SECOND_CLASS_BPL"] = "SECOND_CLASS_BPL";
    ShippingServiceType["FIRST_CLASS_SIGNED_FOR_BPR"] = "FIRST_CLASS_SIGNED_FOR_BPR";
    ShippingServiceType["SECOND_CLASS_SIGNED_FOR_BPR"] = "SECOND_CLASS_SIGNED_FOR_BPR";
    ShippingServiceType["FIRST_CLASS_ACCOUNT_MAIL_STL"] = "FIRST_CLASS_ACCOUNT_MAIL_STL";
    ShippingServiceType["SECOND_CLASS_ACCOUNT_MAIL_STL"] = "SECOND_CLASS_ACCOUNT_MAIL_STL";
    ShippingServiceType["TRACKED_24_LETTERBOX_T_R_N"] = "TRACKED_24_LETTERBOX_T_R_N";
    ShippingServiceType["TRACKED_48_LETTERBOX_T_R_S"] = "TRACKED_48_LETTERBOX_T_R_S";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_500_S_D1"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_500_S_D1";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_1000_S_D2"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_1000_S_D2";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_2500_S_D3"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_2500_S_D3";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_50_S_D4"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_50_S_D4";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_1000_S_D5"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_1000_S_D5";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_2500_S_D6"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_2500_S_D6";
    ShippingServiceType["ROYAL_MAIL_24_CRL"] = "ROYAL_MAIL_24_CRL";
    ShippingServiceType["ROYAL_MAIL_48_CRL"] = "ROYAL_MAIL_48_CRL";
    ShippingServiceType["ROYAL_MAIL_24_SORT8_P_FLAT_RATE_P_K1"] = "ROYAL_MAIL_24_SORT8_P_FLAT_RATE_P_K1";
    ShippingServiceType["ROYAL_MAIL_48_SORT8_P_FLAT_RATE_P_K2"] = "ROYAL_MAIL_48_SORT8_P_FLAT_RATE_P_K2";
    ShippingServiceType["ROYAL_MAIL_24_SORT8_P_DAILY_RATE_P_K3"] = "ROYAL_MAIL_24_SORT8_P_DAILY_RATE_P_K3";
    ShippingServiceType["ROYAL_MAIL_48_SORT8_P_DAILY_RATE_P_K4"] = "ROYAL_MAIL_48_SORT8_P_DAILY_RATE_P_K4";
    ShippingServiceType["ROYAL_MAIL_24_SORT8_LL_DAILY_RATE_F_S1"] = "ROYAL_MAIL_24_SORT8_LL_DAILY_RATE_F_S1";
    ShippingServiceType["ROYAL_MAIL_48_SORT8_LL_DAILY_RATE_F_S2"] = "ROYAL_MAIL_48_SORT8_LL_DAILY_RATE_F_S2";
    ShippingServiceType["ROYAL_MAIL_24_P_FLAT_RATE_PP_F"] = "ROYAL_MAIL_24_P_FLAT_RATE_PP_F";
    ShippingServiceType["ROYAL_MAIL_48_P_FLAT_RATE_PP_F"] = "ROYAL_MAIL_48_P_FLAT_RATE_PP_F";
    ShippingServiceType["ROYAL_MAIL_24_PRESORTED_LL_F_S7"] = "ROYAL_MAIL_24_PRESORTED_LL_F_S7";
    ShippingServiceType["ROYAL_MAIL_48_PRESORTED_LL_F_S8"] = "ROYAL_MAIL_48_PRESORTED_LL_F_S8";
    ShippingServiceType["ROYAL_MAIL_48_LL_FLAT_RATE_P_K0"] = "ROYAL_MAIL_48_LL_FLAT_RATE_P_K0";
    ShippingServiceType["ROYAL_MAIL_24_PRESORTED_PP_K7"] = "ROYAL_MAIL_24_PRESORTED_PP_K7";
    ShippingServiceType["ROYAL_MAIL_48_PRESORTED_PP_K8"] = "ROYAL_MAIL_48_PRESORTED_PP_K8";
    ShippingServiceType["ROYAL_MAIL_24_LL_FLAT_RATE_P_K9"] = "ROYAL_MAIL_24_LL_FLAT_RATE_P_K9";
    ShippingServiceType["ROYAL_MAIL_24_LL_ANNUAL_FLAT_RATE_PP_S"] = "ROYAL_MAIL_24_LL_ANNUAL_FLAT_RATE_PP_S";
    ShippingServiceType["ROYAL_MAIL_48_LL_ANNUAL_FLAT_RATE_PP_T"] = "ROYAL_MAIL_48_LL_ANNUAL_FLAT_RATE_PP_T";
    ShippingServiceType["ROYAL_MAIL_48_SORT8_P_ANNUAL_FLAT_RATE_R_M0"] = "ROYAL_MAIL_48_SORT8_P_ANNUAL_FLAT_RATE_R_M0";
    ShippingServiceType["ROYAL_MAIL_24_LL_DAILY_RATE_R_M1"] = "ROYAL_MAIL_24_LL_DAILY_RATE_R_M1";
    ShippingServiceType["ROYAL_MAIL_24_P_DAILY_RATE_R_M2"] = "ROYAL_MAIL_24_P_DAILY_RATE_R_M2";
    ShippingServiceType["ROYAL_MAIL_48_LL_DAILY_RATE_R_M3"] = "ROYAL_MAIL_48_LL_DAILY_RATE_R_M3";
    ShippingServiceType["ROYAL_MAIL_48_P_DAILY_RATE_R_M4"] = "ROYAL_MAIL_48_P_DAILY_RATE_R_M4";
    ShippingServiceType["ROYAL_MAIL_24_P_FLAT_RATE_R_M5"] = "ROYAL_MAIL_24_P_FLAT_RATE_R_M5";
    ShippingServiceType["ROYAL_MAIL_48_P_FLAT_RATE_R_M6"] = "ROYAL_MAIL_48_P_FLAT_RATE_R_M6";
    ShippingServiceType["ROYAL_MAIL_24_SORT8_LL_ANNUAL_FLAT_RATE_R_M7"] = "ROYAL_MAIL_24_SORT8_LL_ANNUAL_FLAT_RATE_R_M7";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_1000_L_A5"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_1000_L_A5";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_2500_L_A6"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_2500_L_A6";
    ShippingServiceType["ROYAL_MAIL_24_SORT8_P_ANNUAL_FLAT_RATE_R_M8"] = "ROYAL_MAIL_24_SORT8_P_ANNUAL_FLAT_RATE_R_M8";
    ShippingServiceType["ROYAL_MAIL_48_SORT8_LL_ANNUAL_FLAT_RATE_R_M9"] = "ROYAL_MAIL_48_SORT8_LL_ANNUAL_FLAT_RATE_R_M9";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_L_A1"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_L_A1";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_1000_L_A2"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_1000_L_A2";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_1PM_2500_L_A3"] = "SPECIAL_DELIVERY_GUARANTEED_BY_1PM_2500_L_A3";
    ShippingServiceType["SPECIAL_DELIVERY_GUARANTEED_BY_9AM_L_A4"] = "SPECIAL_DELIVERY_GUARANTEED_BY_9AM_L_A4";
    ShippingServiceType["ROYAL_MAIL_24_PRESORTED_P_ANNUAL_FLAT_RATE_P_K_B"] = "ROYAL_MAIL_24_PRESORTED_P_ANNUAL_FLAT_RATE_P_K_B";
    ShippingServiceType["ROYAL_MAIL_48_PRESORTED_P_ANNUAL_FLAT_RATE_PKD"] = "ROYAL_MAIL_48_PRESORTED_P_ANNUAL_FLAT_RATE_PKD";
    ShippingServiceType["ROYAL_MAIL_48_PRESORTED_LL_ANNUAL_FLAT_RATE_P_K_K"] = "ROYAL_MAIL_48_PRESORTED_LL_ANNUAL_FLAT_RATE_P_K_K";
    ShippingServiceType["ROYAL_MAIL24_PRESORTED_LL_ANNUAL_FLAT_RATE_P_K_M"] = "ROYAL_MAIL24_PRESORTED_LL_ANNUAL_FLAT_RATE_P_K_M";
    ShippingServiceType["ROYAL_MAIL_24_PARCELPOST_FLAT_RATE_ANNUAL_PP_J"] = "ROYAL_MAIL_24_PARCELPOST_FLAT_RATE_ANNUAL_PP_J";
    ShippingServiceType["ROYAL_MAIL_48_PARCELPOST_FLAT_RATE_ANNUAL_PP_J"] = "ROYAL_MAIL_48_PARCELPOST_FLAT_RATE_ANNUAL_PP_J";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_ZONAL_PRICINGM_T_I"] = "INTL_BUSINESSMAIL_TRACKED_ZONAL_PRICINGM_T_I";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_COUNTRY_PRICINGM_T_K"] = "INTL_BUSINESSMAIL_TRACKED_COUNTRY_PRICINGM_T_K";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_ZONAL_PRICINGM_T_J"] = "INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_ZONAL_PRICINGM_T_J";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_COUNTRY_PRICINGM_T_L"] = "INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_COUNTRY_PRICINGM_T_L";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_ZONAL_PRICINGM_P1"] = "INTL_BUSINESS_PARCELS_TRACKED_ZONAL_PRICINGM_P1";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_COUNTRY_PRICINGM_P7"] = "INTL_BUSINESS_PARCELS_TRACKED_COUNTRY_PRICINGM_P7";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_EXTRA_COMP_ZONAL_PRICINGM_P4"] = "INTL_BUSINESS_PARCELS_TRACKED_EXTRA_COMP_ZONAL_PRICINGM_P4";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_EXTRA_COMP_COUNTRY_PRICINGM_P8"] = "INTL_BUSINESS_PARCELS_TRACKED_EXTRA_COMP_COUNTRY_PRICINGM_P8";
    ShippingServiceType["INTL_TRACKED_ON_ACCOUNT_O_T_A"] = "INTL_TRACKED_ON_ACCOUNT_O_T_A";
    ShippingServiceType["INTL_TRACKED_ON_ACCOUNT_EXTRA_COMP_O_T_B"] = "INTL_TRACKED_ON_ACCOUNT_EXTRA_COMP_O_T_B";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_ZONAL_PRICINGM_T_M"] = "INTL_BUSINESSMAIL_SIGNED_ZONAL_PRICINGM_T_M";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_COUNTRY_PRICINGM_T_O"] = "INTL_BUSINESSMAIL_SIGNED_COUNTRY_PRICINGM_T_O";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_N"] = "INTL_BUSINESSMAIL_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_N";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_P"] = "INTL_BUSINESSMAIL_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_P";
    ShippingServiceType["INTL_BUSINESS_PARCELS_SIGNED_ZONAL_PRICINGM_P5"] = "INTL_BUSINESS_PARCELS_SIGNED_ZONAL_PRICINGM_P5";
    ShippingServiceType["INTL_BUSINESS_PARCELS_SIGNED_COUNTRY_PRICINGM_P9"] = "INTL_BUSINESS_PARCELS_SIGNED_COUNTRY_PRICINGM_P9";
    ShippingServiceType["INTL_BUSINESS_PARCELS_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_P6"] = "INTL_BUSINESS_PARCELS_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_P6";
    ShippingServiceType["INTL_BUSINESS_PARCELS_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_P0"] = "INTL_BUSINESS_PARCELS_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_P0";
    ShippingServiceType["INTL_SIGNED_ON_ACCOUNT_O_S_A"] = "INTL_SIGNED_ON_ACCOUNT_O_S_A";
    ShippingServiceType["INTL_SIGNED_ON_ACCOUNT_EXTRA_COMP_O_S_B"] = "INTL_SIGNED_ON_ACCOUNT_EXTRA_COMP_O_S_B";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_SIGNED_ZONAL_PRICINGM_T_C"] = "INTL_BUSINESSMAIL_TRACKED_SIGNED_ZONAL_PRICINGM_T_C";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_SIGNED_COUNTRY_PRICINGM_T_G"] = "INTL_BUSINESSMAIL_TRACKED_SIGNED_COUNTRY_PRICINGM_T_G";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_D"] = "INTL_BUSINESSMAIL_TRACKED_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_D";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_H"] = "INTL_BUSINESSMAIL_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_H";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_ZONAL_PRICINGM_T_A"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_ZONAL_PRICINGM_T_A";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_COUNTRY_PRICINGM_T_E"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_COUNTRY_PRICINGM_T_E";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_B"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_ZONAL_PRICINGM_T_B";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_F"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICINGM_T_F";
    ShippingServiceType["INTL_TRACKED_SIGNED_ON_ACCOUNT_O_T_C"] = "INTL_TRACKED_SIGNED_ON_ACCOUNT_O_T_C";
    ShippingServiceType["INTL_TRACKED_SIGNED_ON_ACCOUNT_EXTRA_COMP_O_T_D"] = "INTL_TRACKED_SIGNED_ON_ACCOUNT_EXTRA_COMP_O_T_D";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_PRIORITY_MAX_SORT_P_S7"] = "INTL_BUSINESSMAILLARGE_LETTER_PRIORITY_MAX_SORT_P_S7";
    ShippingServiceType["INTL_BUSINESS_PARCELS_PRIORITY_MAX_SORT_P_S9"] = "INTL_BUSINESS_PARCELS_PRIORITY_MAX_SORT_P_S9";
    ShippingServiceType["INTL_STANDARD_ON_ACCOUNT_O_L_A"] = "INTL_STANDARD_ON_ACCOUNT_O_L_A";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_STANDARD_MAX_SORT_P_S_B"] = "INTL_BUSINESSMAILLARGE_LETTER_STANDARD_MAX_SORT_P_S_B";
    ShippingServiceType["INTL_BUSINESS_PARCELS_STANDARD_MAX_SORT_P_S_C"] = "INTL_BUSINESS_PARCELS_STANDARD_MAX_SORT_P_S_C";
    ShippingServiceType["INTL_ECONOMY_ON_ACCOUNT_O_L_S"] = "INTL_ECONOMY_ON_ACCOUNT_O_L_S";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_HI_VOL_D_E3"] = "INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_HI_VOL_D_E3";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_MAX_SORT_P_S8"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_MAX_SORT_P_S8";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_LO_VOL_D_E6"] = "INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_LO_VOL_D_E6";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_COUNTRY_SORT_HI_VOL_D_G3"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_COUNTRY_SORT_HI_VOL_D_G3";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_MAX_SORT_P_S0"] = "INTL_BUSINESS_PARCELS_ECONOMY_MAX_SORT_P_S0";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_COUNTRY_SORT_LO_VOL_D_G6"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_COUNTRY_SORT_LO_VOL_D_G6";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_ZONE_SORT_I_E3"] = "INTL_BUSINESS_PARCELS_ECONOMY_ZONE_SORT_I_E3";
    ShippingServiceType["H_M_FORCESMAIL_B_F1"] = "H_M_FORCESMAIL_B_F1";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZONE_SORT_I_G3"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZONE_SORT_I_G3";
    ShippingServiceType["H_M_FORCES_SIGNED_FOR_B_F2"] = "H_M_FORCES_SIGNED_FOR_B_F2";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZONE_SORT_MACHINEABLE_I_G6"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZONE_SORT_MACHINEABLE_I_G6";
    ShippingServiceType["H_M_FORCES_SPECIAL_DELIVERY_B_F7"] = "H_M_FORCES_SPECIAL_DELIVERY_B_F7";
    ShippingServiceType["INTL_BUSINESS_PARCELS_STANDARD_PRINT_DIRECT_M_B2"] = "INTL_BUSINESS_PARCELS_STANDARD_PRINT_DIRECT_M_B2";
    ShippingServiceType["H_M_FORCES_SPECIAL_DELIVERY_1000_B_F8"] = "H_M_FORCES_SPECIAL_DELIVERY_1000_B_F8";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_PRINT_DIRECT_M_B3"] = "INTL_BUSINESS_PARCELS_ECONOMY_PRINT_DIRECT_M_B3";
    ShippingServiceType["H_M_FORCES_SPECIAL_DELIVERY_2500_B_F9"] = "H_M_FORCES_SPECIAL_DELIVERY_2500_B_F9";
    ShippingServiceType["INTL_BUSINESSMAIL_ECONOMY_MIXED_ZONE_SORT_O_Z3"] = "INTL_BUSINESSMAIL_ECONOMY_MIXED_ZONE_SORT_O_Z3";
    ShippingServiceType["INTL_BUSINESSMAIL_ECONOMY_MIXED_ZONE_SORT_MACHINEABLE_O_Z6"] = "INTL_BUSINESSMAIL_ECONOMY_MIXED_ZONE_SORT_MACHINEABLE_O_Z6";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_W_E3"] = "INTL_BUSINESS_PARCELS_ECONOMY_ZERO_SORT_W_E3";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZERO_SORT_W_G3"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZERO_SORT_W_G3";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZERO_SORT_MACHINEABLE_W_G6"] = "INTL_BUSINESSMAILLARGE_LETTER_ECONOMY_ZERO_SORT_MACHINEABLE_W_G6";
    ShippingServiceType["INTL_BUSINESSMAIL_ECONOMY_MIXED_ZERO_SORT_W_W3"] = "INTL_BUSINESSMAIL_ECONOMY_MIXED_ZERO_SORT_W_W3";
    ShippingServiceType["INTL_BUSINESSMAIL_ECONOMY_MIXED_ZERO_SORT_MACHINEABLE_W_W6"] = "INTL_BUSINESSMAIL_ECONOMY_MIXED_ZERO_SORT_MACHINEABLE_W_W6";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZERO_SORT_HI_VOL_PRIORITY_D_E1"] = "INTL_BUSINESS_PARCELS_ZERO_SORT_HI_VOL_PRIORITY_D_E1";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZERO_SORT_LOW_VOL_PRIORITY_D_E4"] = "INTL_BUSINESS_PARCELS_ZERO_SORT_LOW_VOL_PRIORITY_D_E4";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_COUNTRY_SORT_HI_VOL_PRIORITY_D_G1"] = "INTL_BUSINESSMAILLARGE_LETTER_COUNTRY_SORT_HI_VOL_PRIORITY_D_G1";
    ShippingServiceType["INTL_BUSINESSMAILLARGE_LETTER_COUNTRY_SORT_LO_VOL_PRIORITY_D_G4"] = "INTL_BUSINESSMAILLARGE_LETTER_COUNTRY_SORT_LO_VOL_PRIORITY_D_G4";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZONE_SORT_PRIORITY_I_E1"] = "INTL_BUSINESS_PARCELS_ZONE_SORT_PRIORITY_I_E1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZONE_SORT_I_G1"] = "INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZONE_SORT_I_G1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZONE_SORT_PRIORITY_MACHINABLE_I_G4"] = "INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZONE_SORT_PRIORITY_MACHINABLE_I_G4";
    ShippingServiceType["INTL_BUSINESS_PARCELS_PRINT_DIRECT_PRIORITY_M_B1"] = "INTL_BUSINESS_PARCELS_PRINT_DIRECT_PRIORITY_M_B1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAIL_MIXED_ZONE_SORT_PRIORITY_O_Z1"] = "INTL_BUSINESS_PARCELSMAIL_MIXED_ZONE_SORT_PRIORITY_O_Z1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAIL_MIXED_ZONE_SORT_PRIORITY_MACHINABLE_O_Z4"] = "INTL_BUSINESS_PARCELSMAIL_MIXED_ZONE_SORT_PRIORITY_MACHINABLE_O_Z4";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZERO_SORT_PRIORITY_W_E1"] = "INTL_BUSINESS_PARCELS_ZERO_SORT_PRIORITY_W_E1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZERO_SORT_PRIORITY_W_G1"] = "INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZERO_SORT_PRIORITY_W_G1";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZERO_SORT_PRIORITY_MACHINABLE_W_G4"] = "INTL_BUSINESS_PARCELSMAILLARGE_LETTER_ZERO_SORT_PRIORITY_MACHINABLE_W_G4";
    ShippingServiceType["INTL_BUSINESS_PARCELSMAIL_MIXED_ZERO_SORT_PRIORITY_W_W1"] = "INTL_BUSINESS_PARCELSMAIL_MIXED_ZERO_SORT_PRIORITY_W_W1";
    ShippingServiceType["TRACKED_RETURNS_24_T_S_N"] = "TRACKED_RETURNS_24_T_S_N";
    ShippingServiceType["INTL_BUSINESS_PARCEL_TRACKED_COUNTRY_PRICING_HI_VOL_M_P_F"] = "INTL_BUSINESS_PARCEL_TRACKED_COUNTRY_PRICING_HI_VOL_M_P_F";
    ShippingServiceType["TRACKED_RETURNS_48_T_S_S"] = "TRACKED_RETURNS_48_T_S_S";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_COUNTRY_PRICING_HI_VOL_M_P_G"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_COUNTRY_PRICING_HI_VOL_M_P_G";
    ShippingServiceType["INTL_BUSINESS_PARCEL_SIGNED_COUNTRY_PRICING_HI_VOL_M_P_H"] = "INTL_BUSINESS_PARCEL_SIGNED_COUNTRY_PRICING_HI_VOL_M_P_H";
    ShippingServiceType["INTL_BUSINESS_PARCEL_TRACKED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_I"] = "INTL_BUSINESS_PARCEL_TRACKED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_I";
    ShippingServiceType["INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_J"] = "INTL_BUSINESS_PARCELS_TRACKED_SIGNED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_J";
    ShippingServiceType["INTL_BUSINESS_PARCEL_SIGNED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_K"] = "INTL_BUSINESS_PARCEL_SIGNED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_K";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_LETTER_COUNTRY_PRICING_HI_VOL_M_P_L"] = "INTL_BUSINESSMAIL_TRACKED_LETTER_COUNTRY_PRICING_HI_VOL_M_P_L";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_SIGNED_LETTER_HI_VOL_M_P_M"] = "INTL_BUSINESSMAIL_TRACKED_SIGNED_LETTER_HI_VOL_M_P_M";
    ShippingServiceType["INTL_BUSMAIL_TRACKED_SIGNED_LETTER_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_PP"] = "INTL_BUSMAIL_TRACKED_SIGNED_LETTER_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_PP";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_LETTER_COUNTRY_PRICING_HI_VOL_M_P_N"] = "INTL_BUSINESSMAIL_SIGNED_LETTER_COUNTRY_PRICING_HI_VOL_M_P_N";
    ShippingServiceType["INTL_BUSINESSMAIL_SIGNED_LETTER_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_Q"] = "INTL_BUSINESSMAIL_SIGNED_LETTER_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_Q";
    ShippingServiceType["INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_O"] = "INTL_BUSINESSMAIL_TRACKED_EXTRA_COMP_COUNTRY_PRICING_HI_VOL_M_P_O";
    ShippingServiceType["INTL_BUSINESSMAIL_MIXED_ZERO_SORT_PRIORITY_MACHINEABLE_W_W4"] = "INTL_BUSINESSMAIL_MIXED_ZERO_SORT_PRIORITY_MACHINEABLE_W_W4";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZERO_SORT_BOX_HI_VOL_PRIORITY_M_P_X"] = "INTL_BUSINESS_PARCELS_ZERO_SORT_BOX_HI_VOL_PRIORITY_M_P_X";
    ShippingServiceType["INTL_BUSINESS_PARCELS_ZERO_SORT_BOX_LOW_VOL_ECONOMY_M_P_W"] = "INTL_BUSINESS_PARCELS_ZERO_SORT_BOX_LOW_VOL_ECONOMY_M_P_W";
    ShippingServiceType["INTL_BUSINESS_PARCELS_BOX_MAX_SORT_PRIORITY_M_U_U"] = "INTL_BUSINESS_PARCELS_BOX_MAX_SORT_PRIORITY_M_U_U";
    ShippingServiceType["INTL_BUSINESS_PARCELS_BOX_MAX_SORT_STANDARD_M_U_V"] = "INTL_BUSINESS_PARCELS_BOX_MAX_SORT_STANDARD_M_U_V";
    ShippingServiceType["INTL_BUSINESS_PARCELS_BOX_MAX_SORT_PRIORITY_M_U_W"] = "INTL_BUSINESS_PARCELS_BOX_MAX_SORT_PRIORITY_M_U_W";
    ShippingServiceType["RRD_E_PACKET_USPS_SERVICE"] = "RRD_E_PACKET_USPS_SERVICE";
    ShippingServiceType["RRD_IPA_USPS_SERVICE"] = "RRD_IPA_USPS_SERVICE";
    ShippingServiceType["RRD_ISAL_USPS_SERVICE"] = "RRD_ISAL_USPS_SERVICE";
    ShippingServiceType["RRD_PRIORITY_PARCEL_COURIER_SERVICE"] = "RRD_PRIORITY_PARCEL_COURIER_SERVICE";
    ShippingServiceType["RRD_PRIORITY_PARCEL_NON_D_C"] = "RRD_PRIORITY_PARCEL_NON_D_C";
    ShippingServiceType["RRD_IPA_SERVICE"] = "RRD_IPA_SERVICE";
    ShippingServiceType["RRD_COURIER_SERVICE"] = "RRD_COURIER_SERVICE";
    ShippingServiceType["E_COMMERCE_EXPRESS_TRACKED"] = "E_COMMERCE_EXPRESS_TRACKED";
    ShippingServiceType["E_COMMERCE_STANDARD_TRACKED"] = "E_COMMERCE_STANDARD_TRACKED";
    ShippingServiceType["DOMESTIC_STANDARD"] = "DOMESTIC_STANDARD";
    ShippingServiceType["DOMESTIC_EXPRESS"] = "DOMESTIC_EXPRESS";
    ShippingServiceType["PP_FIRST_CLASS_LARGE_ENVELOPE_OR_FLAT"] = "PP_FIRST_CLASS_LARGE_ENVELOPE_OR_FLAT";
    ShippingServiceType["PP_FIRST_CLASSMAIL_THICK_ENVELOPE"] = "PP_FIRST_CLASSMAIL_THICK_ENVELOPE";
    ShippingServiceType["PP_FIRST_CLASSMAIL_FLATS"] = "PP_FIRST_CLASSMAIL_FLATS";
    ShippingServiceType["PP_FIRST_CLASSMAILLETTER"] = "PP_FIRST_CLASSMAILLETTER";
    ShippingServiceType["PP_FIRST_CLASSMAIL_INTL"] = "PP_FIRST_CLASSMAIL_INTL";
    ShippingServiceType["PP_PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX";
    ShippingServiceType["PP_EXPRESSMAIL"] = "PP_EXPRESSMAIL";
    ShippingServiceType["PP_PRIORITY_MAIL"] = "PP_PRIORITY_MAIL";
    ShippingServiceType["PP_PARCEL_SELECT"] = "PP_PARCEL_SELECT";
    ShippingServiceType["PP_MEDIAMAIL"] = "PP_MEDIAMAIL";
    ShippingServiceType["PP_PRIORITY_MAIL_CUBED"] = "PP_PRIORITY_MAIL_CUBED";
    ShippingServiceType["PP_EXPRESSMAIL_FLAT_RATE_LEGAL_ENVELOPE"] = "PP_EXPRESSMAIL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["PP_EXPRESSMAIL_FLAT_RATE_BOX"] = "PP_EXPRESSMAIL_FLAT_RATE_BOX";
    ShippingServiceType["PP_FIRST_CLASS_PACKAGE_SERVICE"] = "PP_FIRST_CLASS_PACKAGE_SERVICE";
    ShippingServiceType["PP_PRIORITY_MAILLARGE_FLAT_RATE_BOX"] = "PP_PRIORITY_MAILLARGE_FLAT_RATE_BOX";
    ShippingServiceType["PP_PRIORITY_MAIL_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_FLAT_RATE_BOX";
    ShippingServiceType["PP_PRIORITY_MAIL_FLAT_RATE_ENVELOPE"] = "PP_PRIORITY_MAIL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PP_PRIORITY_MAIL_FLAT_RATE_PADDED_ENVELOPE"] = "PP_PRIORITY_MAIL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["PP_PRIORITY_MAIL_SMALL_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_SMALL_FLAT_RATE_BOX";
    ShippingServiceType["PP_PRIORITY_MAIL_FLAT_RATE_LEGAL_ENVELOPE"] = "PP_PRIORITY_MAIL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["PP_PRIORITY_MAIL_REGIONAL_RATE_BOX_A"] = "PP_PRIORITY_MAIL_REGIONAL_RATE_BOX_A";
    ShippingServiceType["PP_PRIORITY_MAIL_REGIONAL_RATE_BOX_B"] = "PP_PRIORITY_MAIL_REGIONAL_RATE_BOX_B";
    ShippingServiceType["PP_PRIORITY_MAIL_COMMERCIAL_PLUS"] = "PP_PRIORITY_MAIL_COMMERCIAL_PLUS";
    ShippingServiceType["PP_EXPRESSMAIL_FLAT_RATE_ENVELOPE"] = "PP_EXPRESSMAIL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PP_EXPRESSMAIL_FLAT_RATE_PADDED_ENVELOPE"] = "PP_EXPRESSMAIL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_BOX"] = "PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_BOX";
    ShippingServiceType["PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE"] = "PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_PADDED_ENVELOPE"] = "PP_EXPRESSMAIL_INTERNATIONAL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["PP_EXPRESSMAIL_INTERNATIONAL"] = "PP_EXPRESSMAIL_INTERNATIONAL";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL"] = "PP_PRIORITY_MAIL_INTERNATIONAL";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE"] = "PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_BOX";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL_SMALL_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_INTERNATIONAL_SMALL_FLAT_RATE_BOX";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONALLARGE_FLAT_RATE_BOX"] = "PP_PRIORITY_MAIL_INTERNATIONALLARGE_FLAT_RATE_BOX";
    ShippingServiceType["PP_FIRST_CLASS_INTERNATIONAL"] = "PP_FIRST_CLASS_INTERNATIONAL";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_LEGAL_ENVELOPE"] = "PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_LEGAL_ENVELOPE";
    ShippingServiceType["PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_PADDED_ENVELOPE"] = "PP_PRIORITY_MAIL_INTERNATIONAL_FLAT_RATE_PADDED_ENVELOPE";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS_ENVELOPE"] = "UPS_WORLDWIDE_EXPRESS_ENVELOPE";
    ShippingServiceType["UPS_WORLDWIDE_EXPRESS_PLUS_ENVELOPE"] = "UPS_WORLDWIDE_EXPRESS_PLUS_ENVELOPE";
    ShippingServiceType["UPS_WORLDWIDE_SAVER_ENVELOPE"] = "UPS_WORLDWIDE_SAVER_ENVELOPE";
    ShippingServiceType["MAIL_INNOVATIONS_FIRST_CLASS"] = "MAIL_INNOVATIONS_FIRST_CLASS";
    ShippingServiceType["UPSMI_P_S_LIGHT_WEIGHT"] = "UPSMI_P_S_LIGHT_WEIGHT";
    ShippingServiceType["BASIC"] = "BASIC";
    ShippingServiceType["EXPRESS_EARLY_AM"] = "EXPRESS_EARLY_AM";
    ShippingServiceType["EXPRESS_SAVER"] = "EXPRESS_SAVER";
    ShippingServiceType["UPSMI_PARCEL_SELECT"] = "UPSMI_PARCEL_SELECT";
    ShippingServiceType["UPSMI_BPM_PARCEL"] = "UPSMI_BPM_PARCEL";
    ShippingServiceType["UPSMI_BPM_FLATS"] = "UPSMI_BPM_FLATS";
    ShippingServiceType["UPSMI_MEDIAMAIL"] = "UPSMI_MEDIAMAIL";
    ShippingServiceType["UPSMI_STANDARD_FLATS"] = "UPSMI_STANDARD_FLATS";
    ShippingServiceType["UPSMI_PRIORITY_LETTERS"] = "UPSMI_PRIORITY_LETTERS";
    ShippingServiceType["UPSMI_PRIORITY_FLATS"] = "UPSMI_PRIORITY_FLATS";
    ShippingServiceType["UPSMI_PRIORITY_PACKETS"] = "UPSMI_PRIORITY_PACKETS";
    ShippingServiceType["UPSMI_PRIORITY_PARCELS"] = "UPSMI_PRIORITY_PARCELS";
    ShippingServiceType["UPSMI_ECONOMY_LETTERS"] = "UPSMI_ECONOMY_LETTERS";
    ShippingServiceType["UPSMI_ECONOMY_FLATS"] = "UPSMI_ECONOMY_FLATS";
    ShippingServiceType["UPSMI_ECONOMY_PACKETS"] = "UPSMI_ECONOMY_PACKETS";
    ShippingServiceType["UPSMI_ECONOMY_PARCELS"] = "UPSMI_ECONOMY_PARCELS";
    ShippingServiceType["PRIORITY_MAIL_WSIGNATURE_P_O_D"] = "PRIORITY_MAIL_WSIGNATURE_P_O_D";
    ShippingServiceType["PRIORITY_MAIL_W_INSURANCE"] = "PRIORITY_MAIL_W_INSURANCE";
    ShippingServiceType["FIRST_CLASS_LETTER"] = "FIRST_CLASS_LETTER";
    ShippingServiceType["FIRST_CLASS_LARGE_ENVELOPE_FLAT"] = "FIRST_CLASS_LARGE_ENVELOPE_FLAT";
    ShippingServiceType["PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX"] = "PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAILLARGE_FLAT_RATE_BOX"] = "PRIORITY_MAILLARGE_FLAT_RATE_BOX";
    ShippingServiceType["EXPRESSMAIL"] = "EXPRESSMAIL";
    ShippingServiceType["FIRST_CLASSMAIL_INTLLARGE_ENV_FLAT"] = "FIRST_CLASSMAIL_INTLLARGE_ENV_FLAT";
    ShippingServiceType["PRIORITY_MAIL_INTL_SMALL_FLAT_RATE_BOX"] = "PRIORITY_MAIL_INTL_SMALL_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTL_MEDIUM_FLAT_RATE_BOX"] = "PRIORITY_MAIL_INTL_MEDIUM_FLAT_RATE_BOX";
    ShippingServiceType["PRIORITY_MAIL_INTLLARGE_FLAT_RATE_BOX"] = "PRIORITY_MAIL_INTLLARGE_FLAT_RATE_BOX";
    ShippingServiceType["EXPRESSMAIL_INTL_FLAT_RATE_ENVELOPE"] = "EXPRESSMAIL_INTL_FLAT_RATE_ENVELOPE";
    ShippingServiceType["DYNAMEX_RUSH"] = "DYNAMEX_RUSH";
    ShippingServiceType["ONTRAC_GROUND"] = "ONTRAC_GROUND";
    ShippingServiceType["USPS_PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX"] = "USPS_PRIORITY_MAIL_MEDIUM_FLAT_RATE_BOX";
    ShippingServiceType["STANDARD"] = "STANDARD";
    ShippingServiceType["LIGHTWEIGHT_PARCELS_EXP_W_DELCON"] = "LIGHTWEIGHT_PARCELS_EXP_W_DELCON";
    ShippingServiceType["LIGHTWEIGHT_PARCELS_GRD_W_DELCON"] = "LIGHTWEIGHT_PARCELS_GRD_W_DELCON";
    ShippingServiceType["TRACKED_24_LETTERBOX_TPN"] = "TRACKED_24_LETTERBOX_TPN";
    ShippingServiceType["TRACKED_48_LETTERBOX_TPS"] = "TRACKED_48_LETTERBOX_TPS";
    ShippingServiceType["WHITE_GLOVE"] = "WHITE_GLOVE";
    ShippingServiceType["FEDEX_INTERNATIONAL_CONNECT_PLUS"] = "FEDEX_INTERNATIONAL_CONNECT_PLUS";
    ShippingServiceType["AACT_FREIGHT"] = "AACT_FREIGHT";
    ShippingServiceType["EXLA_FREIGHT"] = "EXLA_FREIGHT";
    ShippingServiceType["FedEx_FREIGHT"] = "FedEx_FREIGHT";
    ShippingServiceType["FDEG_FREIGHT"] = "FDEG_FREIGHT";
    ShippingServiceType["FDG_FREIGHT"] = "FDG_FREIGHT";
    ShippingServiceType["FDX_FREIGHT"] = "FDX_FREIGHT";
    ShippingServiceType["EMSY_FREIGHT"] = "EMSY_FREIGHT";
    ShippingServiceType["RLNO_FREIGHT"] = "RLNO_FREIGHT";
    ShippingServiceType["RNLO_FREIGHT"] = "RNLO_FREIGHT";
    ShippingServiceType["SAIA_FREIGHT"] = "SAIA_FREIGHT";
    ShippingServiceType["SEFL_FREIGHT"] = "SEFL_FREIGHT";
    ShippingServiceType["UPS_FREIGHT"] = "UPS_FREIGHT";
    ShippingServiceType["UPSG_FREIGHT"] = "UPSG_FREIGHT";
    ShippingServiceType["UPS2_FREIGHT"] = "UPS2_FREIGHT";
    ShippingServiceType["UPSEG_FREIGHT"] = "UPSEG_FREIGHT";
    ShippingServiceType["UPSN_FREIGHT"] = "UPSN_FREIGHT";
    ShippingServiceType["UPGF_FREIGHT"] = "UPGF_FREIGHT";
    ShippingServiceType["UPSF_FREIGHT"] = "UPSF_FREIGHT";
    ShippingServiceType["US10_FREIGHT"] = "US10_FREIGHT";
    ShippingServiceType["USPS_FREIGHT"] = "USPS_FREIGHT";
    ShippingServiceType["ADP_FREIGHT"] = "ADP_FREIGHT";
    ShippingServiceType["PYLE_FREIGHT"] = "PYLE_FREIGHT";
    ShippingServiceType["BTRC_FREIGHT"] = "BTRC_FREIGHT";
    ShippingServiceType["CARD_FREIGHT"] = "CARD_FREIGHT";
    ShippingServiceType["CTII_FREIGHT"] = "CTII_FREIGHT";
    ShippingServiceType["DCHA_FREIGHT"] = "DCHA_FREIGHT";
    ShippingServiceType["DHRN_FREIGHT"] = "DHRN_FREIGHT";
    ShippingServiceType["HMES_FREIGHT"] = "HMES_FREIGHT";
    ShippingServiceType["JSMA_FREIGHT"] = "JSMA_FREIGHT";
    ShippingServiceType["LAEA_FREIGHT"] = "LAEA_FREIGHT";
    ShippingServiceType["LAXU_FREIGHT"] = "LAXU_FREIGHT";
    ShippingServiceType["NPME_FREIGHT"] = "NPME_FREIGHT";
    ShippingServiceType["NOPK_FREIGHT"] = "NOPK_FREIGHT";
    ShippingServiceType["OAKH_FREIGHT"] = "OAKH_FREIGHT";
    ShippingServiceType["PITD_FREIGHT"] = "PITD_FREIGHT";
    ShippingServiceType["PITT_FREIGHT"] = "PITT_FREIGHT";
    ShippingServiceType["RETL_FREIGHT"] = "RETL_FREIGHT";
    ShippingServiceType["RDWY_FREIGHT"] = "RDWY_FREIGHT";
    ShippingServiceType["SWDS_FREIGHT"] = "SWDS_FREIGHT";
    ShippingServiceType["SVXL_FREIGHT"] = "SVXL_FREIGHT";
    ShippingServiceType["SUON_FREIGHT"] = "SUON_FREIGHT";
    ShippingServiceType["ADYW_FREIGHT"] = "ADYW_FREIGHT";
    ShippingServiceType["AEIB_FREIGHT"] = "AEIB_FREIGHT";
    ShippingServiceType["AGXP_FREIGHT"] = "AGXP_FREIGHT";
    ShippingServiceType["AMPM_FREIGHT"] = "AMPM_FREIGHT";
    ShippingServiceType["ANDO_FREIGHT"] = "ANDO_FREIGHT";
    ShippingServiceType["AVFE_FREIGHT"] = "AVFE_FREIGHT";
    ShippingServiceType["BESY_FREIGHT"] = "BESY_FREIGHT";
    ShippingServiceType["BUKC_FREIGHT"] = "BUKC_FREIGHT";
    ShippingServiceType["CCSJ_FREIGHT"] = "CCSJ_FREIGHT";
    ShippingServiceType["CCYQ_FREIGHT"] = "CCYQ_FREIGHT";
    ShippingServiceType["CENF_FREIGHT"] = "CENF_FREIGHT";
    ShippingServiceType["COMM_FREIGHT"] = "COMM_FREIGHT";
    ShippingServiceType["COUJ_FREIGHT"] = "COUJ_FREIGHT";
    ShippingServiceType["CUXG_FREIGHT"] = "CUXG_FREIGHT";
    ShippingServiceType["DEEX_FREIGHT"] = "DEEX_FREIGHT";
    ShippingServiceType["EDYS_FREIGHT"] = "EDYS_FREIGHT";
    ShippingServiceType["EPCI_FREIGHT"] = "EPCI_FREIGHT";
    ShippingServiceType["EXPN_FREIGHT"] = "EXPN_FREIGHT";
    ShippingServiceType["EXPS_FREIGHT"] = "EXPS_FREIGHT";
    ShippingServiceType["FCCD_FREIGHT"] = "FCCD_FREIGHT";
    ShippingServiceType["GEXO_FREIGHT"] = "GEXO_FREIGHT";
    ShippingServiceType["MENT_FREIGHT"] = "MENT_FREIGHT";
    ShippingServiceType["MINN_FREIGHT"] = "MINN_FREIGHT";
    ShippingServiceType["NDER_FREIGHT"] = "NDER_FREIGHT";
    ShippingServiceType["NDSN_FREIGHT"] = "NDSN_FREIGHT";
    ShippingServiceType["OKXL_FREIGHT"] = "OKXL_FREIGHT";
    ShippingServiceType["PDRQ_FREIGHT"] = "PDRQ_FREIGHT";
    ShippingServiceType["PXPK_FREIGHT"] = "PXPK_FREIGHT";
    ShippingServiceType["RRDS_FREIGHT"] = "RRDS_FREIGHT";
    ShippingServiceType["SAPL_FREIGHT"] = "SAPL_FREIGHT";
    ShippingServiceType["SDGD_FREIGHT"] = "SDGD_FREIGHT";
    ShippingServiceType["TFNM_FREIGHT"] = "TFNM_FREIGHT";
    ShippingServiceType["UCFN_FREIGHT"] = "UCFN_FREIGHT";
    ShippingServiceType["UCFS_FREIGHT"] = "UCFS_FREIGHT";
    ShippingServiceType["UFCS_FREIGHT"] = "UFCS_FREIGHT";
    ShippingServiceType["USCA_FREIGHT"] = "USCA_FREIGHT";
    ShippingServiceType["VCCO_FREIGHT"] = "VCCO_FREIGHT";
    ShippingServiceType["XSLS_FREIGHT"] = "XSLS_FREIGHT";
    ShippingServiceType["_10CC_FREIGHT"] = "_10CC_FREIGHT";
    ShippingServiceType["_11DP_FREIGHT"] = "_11DP_FREIGHT";
    ShippingServiceType["_18AC_FREIGHT"] = "_18AC_FREIGHT";
    ShippingServiceType["_36ID_FREIGHT"] = "_36ID_FREIGHT";
    ShippingServiceType["_44BR_FREIGHT"] = "_44BR_FREIGHT";
    ShippingServiceType["_44CH_FREIGHT"] = "_44CH_FREIGHT";
    ShippingServiceType["_44SB_FREIGHT"] = "_44SB_FREIGHT";
    ShippingServiceType["C23L_FREIGHT"] = "C23L_FREIGHT";
    ShippingServiceType["WARD_FREIGHT"] = "WARD_FREIGHT";
    ShippingServiceType["DYUS_FREIGHT"] = "DYUS_FREIGHT";
    ShippingServiceType["MONC_FREIGHT"] = "MONC_FREIGHT";
    ShippingServiceType["TAXA_FREIGHT"] = "TAXA_FREIGHT";
    ShippingServiceType["YRCF_FREIGHT"] = "YRCF_FREIGHT";
    ShippingServiceType["AAA_FREIGHT"] = "AAA_FREIGHT";
    ShippingServiceType["STANDARD_RATE_SHOP"] = "STANDARD_RATE_SHOP";
    ShippingServiceType["NEXT_DAY_RATE_SHOP"] = "NEXT_DAY_RATE_SHOP";
    ShippingServiceType["TWO_DAY_RATE_SHOP"] = "TWO_DAY_RATE_SHOP";
    ShippingServiceType["THREE_DAY_RATE_SHOP"] = "THREE_DAY_RATE_SHOP";
    ShippingServiceType["LTL_RATE_SHOP"] = "LTL_RATE_SHOP";
    ShippingServiceType["THRESHOLD"] = "THRESHOLD";
    ShippingServiceType["CDL"] = "CDL";
    ShippingServiceType["CDL_LAST_MILE"] = "CDL_LAST_MILE";
    ShippingServiceType["PREPAID_LABEL"] = "PREPAID_LABEL";
    ShippingServiceType["BESTALL_FEDEX_GROUND"] = "BESTALL_FEDEX_GROUND";
    ShippingServiceType["BESTALL_FEDEX_GROUND_ECONOMY"] = "BESTALL_FEDEX_GROUND_ECONOMY";
    ShippingServiceType["BESTALL_USPS_PRIORITY_MAIL"] = "BESTALL_USPS_PRIORITY_MAIL";
    ShippingServiceType["BESTALL_USPS_GROUND_RETAIL"] = "BESTALL_USPS_GROUND_RETAIL";
    ShippingServiceType["FEDEXHOM_FEDEX_HOME_DELIVERY"] = "FEDEXHOM_FEDEX_HOME_DELIVERY";
    ShippingServiceType["FEDEXHOM_USPS_PRIORITY"] = "FEDEXHOM_USPS_PRIORITY";
    ShippingServiceType["FEDEX2D_FEDEX_2DAY_SHIPPING"] = "FEDEX2D_FEDEX_2DAY_SHIPPING";
})(ShippingServiceType = exports.ShippingServiceType || (exports.ShippingServiceType = {}));
var ShippingStates;
(function (ShippingStates) {
    ShippingStates["AL"] = "AL";
    ShippingStates["AK"] = "AK";
    ShippingStates["AZ"] = "AZ";
    ShippingStates["AR"] = "AR";
    ShippingStates["CA"] = "CA";
    ShippingStates["CO"] = "CO";
    ShippingStates["CT"] = "CT";
    ShippingStates["DE"] = "DE";
    ShippingStates["DC"] = "DC";
    ShippingStates["FL"] = "FL";
    ShippingStates["GA"] = "GA";
    ShippingStates["HI"] = "HI";
    ShippingStates["ID"] = "ID";
    ShippingStates["IL"] = "IL";
    ShippingStates["IN"] = "IN";
    ShippingStates["IA"] = "IA";
    ShippingStates["KS"] = "KS";
    ShippingStates["KY"] = "KY";
    ShippingStates["LA"] = "LA";
    ShippingStates["ME"] = "ME";
    ShippingStates["MD"] = "MD";
    ShippingStates["MA"] = "MA";
    ShippingStates["MI"] = "MI";
    ShippingStates["MN"] = "MN";
    ShippingStates["MS"] = "MS";
    ShippingStates["MO"] = "MO";
    ShippingStates["MT"] = "MT";
    ShippingStates["NE"] = "NE";
    ShippingStates["NV"] = "NV";
    ShippingStates["NH"] = "NH";
    ShippingStates["NJ"] = "NJ";
    ShippingStates["NM"] = "NM";
    ShippingStates["NY"] = "NY";
    ShippingStates["NC"] = "NC";
    ShippingStates["ND"] = "ND";
    ShippingStates["OH"] = "OH";
    ShippingStates["OK"] = "OK";
    ShippingStates["OR"] = "OR";
    ShippingStates["PA"] = "PA";
    ShippingStates["RI"] = "RI";
    ShippingStates["SC"] = "SC";
    ShippingStates["SD"] = "SD";
    ShippingStates["TN"] = "TN";
    ShippingStates["TX"] = "TX";
    ShippingStates["UT"] = "UT";
    ShippingStates["VT"] = "VT";
    ShippingStates["VA"] = "VA";
    ShippingStates["WA"] = "WA";
    ShippingStates["WV"] = "WV";
    ShippingStates["WI"] = "WI";
    ShippingStates["WY"] = "WY";
    ShippingStates["AS"] = "AS";
    ShippingStates["GU"] = "GU";
    ShippingStates["MP"] = "MP";
    ShippingStates["PR"] = "PR";
    ShippingStates["VI"] = "VI";
    ShippingStates["FM"] = "FM";
    ShippingStates["MH"] = "MH";
    ShippingStates["PW"] = "PW";
    ShippingStates["AA"] = "AA";
    ShippingStates["AE"] = "AE";
    ShippingStates["AP"] = "AP";
})(ShippingStates = exports.ShippingStates || (exports.ShippingStates = {}));
var ShippingStatusId;
(function (ShippingStatusId) {
    ShippingStatusId["DEFAULT_UNINITIALIZED"] = "DEFAULT_UNINITIALIZED";
    ShippingStatusId["WORKING"] = "WORKING";
    ShippingStatusId["ERROR_ON_ESTIMATING"] = "ERROR_ON_ESTIMATING";
    ShippingStatusId["ESTIMATING"] = "ESTIMATING";
    ShippingStatusId["ESTIMATED"] = "ESTIMATED";
    ShippingStatusId["ERROR_ON_CONFIRMING"] = "ERROR_ON_CONFIRMING";
    ShippingStatusId["CONFIRMING"] = "CONFIRMING";
    ShippingStatusId["CONFIRMED"] = "CONFIRMED";
    ShippingStatusId["VOIDING"] = "VOIDING";
    ShippingStatusId["VOIDED"] = "VOIDED";
    ShippingStatusId["ERROR_IN_VOIDING"] = "ERROR_IN_VOIDING";
    ShippingStatusId["INTERNAL_SKUBANA_ERROR"] = "INTERNAL_SKUBANA_ERROR";
})(ShippingStatusId = exports.ShippingStatusId || (exports.ShippingStatusId = {}));
var SortDirection;
(function (SortDirection) {
    SortDirection["ASC"] = "ASC";
    SortDirection["DESC"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
var SortField;
(function (SortField) {
    SortField["RECEIVED_DATE"] = "RECEIVED_DATE";
    SortField["ID"] = "ID";
})(SortField = exports.SortField || (exports.SortField = {}));
var SortField2;
(function (SortField2) {
    SortField2["ORDER_DATE"] = "ORDER_DATE";
    SortField2["ID"] = "ID";
})(SortField2 = exports.SortField2 || (exports.SortField2 = {}));
var SpecialService;
(function (SpecialService) {
    SpecialService["BROKER_SELECT_OPTION"] = "BROKER_SELECT_OPTION";
    SpecialService["CALL_BEFORE_DELIVERY"] = "CALL_BEFORE_DELIVERY";
    SpecialService["COD"] = "COD";
    SpecialService["CUSTOM_DELIVERY_WINDOW"] = "CUSTOM_DELIVERY_WINDOW";
    SpecialService["CUT_FLOWERS"] = "CUT_FLOWERS";
    SpecialService["DANGEROUS_GOODS"] = "DANGEROUS_GOODS";
    SpecialService["DELIVERY_ON_INVOICE_ACCEPTANCE"] = "DELIVERY_ON_INVOICE_ACCEPTANCE";
    SpecialService["DO_NOT_BREAK_DOWN_PALLETS"] = "DO_NOT_BREAK_DOWN_PALLETS";
    SpecialService["DO_NOT_STACK_PALLETS"] = "DO_NOT_STACK_PALLETS";
    SpecialService["DRY_ICE"] = "DRY_ICE";
    SpecialService["EAST_COAST_SPECIAL"] = "EAST_COAST_SPECIAL";
    SpecialService["ELECTRONIC_TRADE_DOCUMENTS"] = "ELECTRONIC_TRADE_DOCUMENTS";
    SpecialService["EVENT_NOTIFICATION"] = "EVENT_NOTIFICATION";
    SpecialService["EXTREME_LENGTH"] = "EXTREME_LENGTH";
    SpecialService["FEDEX_ONE_RATE"] = "FEDEX_ONE_RATE";
    SpecialService["FOOD"] = "FOOD";
    SpecialService["FREIGHT_GUARANTEE"] = "FREIGHT_GUARANTEE";
    SpecialService["FREIGHT_TO_COLLECT"] = "FREIGHT_TO_COLLECT";
    SpecialService["FUTURE_DAY_SHIPMENT"] = "FUTURE_DAY_SHIPMENT";
    SpecialService["HOLD_AT_LOCATION"] = "HOLD_AT_LOCATION";
    SpecialService["HOME_DELIVERY_PREMIUM"] = "HOME_DELIVERY_PREMIUM";
    SpecialService["INSIDE_DELIVERY"] = "INSIDE_DELIVERY";
    SpecialService["INSIDE_PICKUP"] = "INSIDE_PICKUP";
    SpecialService["INTERNATIONAL_CONTROLLED_EXPORT_SERVICE"] = "INTERNATIONAL_CONTROLLED_EXPORT_SERVICE";
    SpecialService["INTERNATIONAL_TRAFFIC_IN_ARMS_REGULATIONS"] = "INTERNATIONAL_TRAFFIC_IN_ARMS_REGULATIONS";
    SpecialService["LIFTGATE_DELIVERY"] = "LIFTGATE_DELIVERY";
    SpecialService["LIFTGATE_PICKUP"] = "LIFTGATE_PICKUP";
    SpecialService["LIMITED_ACCESS_DELIVERY"] = "LIMITED_ACCESS_DELIVERY";
    SpecialService["LIMITED_ACCESS_PICKUP"] = "LIMITED_ACCESS_PICKUP";
    SpecialService["PENDING_SHIPMENT"] = "PENDING_SHIPMENT";
    SpecialService["PHARMACY_DELIVERY"] = "PHARMACY_DELIVERY";
    SpecialService["POISON"] = "POISON";
    SpecialService["PROTECTION_FROM_FREEZING"] = "PROTECTION_FROM_FREEZING";
    SpecialService["RETURNS_CLEARANCE"] = "RETURNS_CLEARANCE";
    SpecialService["RETURN_SHIPMENT"] = "RETURN_SHIPMENT";
    SpecialService["SATURDAY_DELIVERY"] = "SATURDAY_DELIVERY";
    SpecialService["SATURDAY_PICKUP"] = "SATURDAY_PICKUP";
    SpecialService["THIRD_PARTY_CONSIGNEE"] = "THIRD_PARTY_CONSIGNEE";
    SpecialService["TOP_LOAD"] = "TOP_LOAD";
})(SpecialService = exports.SpecialService || (exports.SpecialService = {}));
class StockLocation2 {
    location;
    stockLocationId;
    warehouseId;
}
exports.StockLocation2 = StockLocation2;
var StockTransferOrderDtoStatus;
(function (StockTransferOrderDtoStatus) {
    StockTransferOrderDtoStatus["AWAITING_SHIPMENT"] = "AWAITING_SHIPMENT";
    StockTransferOrderDtoStatus["PENDING_RECEIVING"] = "PENDING_RECEIVING";
    StockTransferOrderDtoStatus["PARTIALLY_DELIVERED"] = "PARTIALLY_DELIVERED";
    StockTransferOrderDtoStatus["DELIVERED"] = "DELIVERED";
    StockTransferOrderDtoStatus["CLOSED_SHORT"] = "CLOSED_SHORT";
    StockTransferOrderDtoStatus["REJECTED"] = "REJECTED";
    StockTransferOrderDtoStatus["CANCELED"] = "CANCELED";
})(StockTransferOrderDtoStatus = exports.StockTransferOrderDtoStatus || (exports.StockTransferOrderDtoStatus = {}));
var StockTransferOrderItemDtoStatus;
(function (StockTransferOrderItemDtoStatus) {
    StockTransferOrderItemDtoStatus["PENDING"] = "PENDING";
    StockTransferOrderItemDtoStatus["RECEIVED"] = "RECEIVED";
    StockTransferOrderItemDtoStatus["REJECTED"] = "REJECTED";
})(StockTransferOrderItemDtoStatus = exports.StockTransferOrderItemDtoStatus || (exports.StockTransferOrderItemDtoStatus = {}));
var SubType;
(function (SubType) {
    SubType["NO_SUBTYPE"] = "NO_SUBTYPE";
    SubType["EXPRESS_ONE"] = "EXPRESS_ONE";
    SubType["UPS_MAIL_INNOVATIONS"] = "UPS_MAIL_INNOVATIONS";
    SubType["DHL_ECOMMERCE"] = "DHL_ECOMMERCE";
})(SubType = exports.SubType || (exports.SubType = {}));
var ThirdPartyLogisticsProviderType;
(function (ThirdPartyLogisticsProviderType) {
    ThirdPartyLogisticsProviderType["THREEPL_CENTRAL"] = "THREEPL_CENTRAL";
})(ThirdPartyLogisticsProviderType = exports.ThirdPartyLogisticsProviderType || (exports.ThirdPartyLogisticsProviderType = {}));
var ThirdPartyLogisticsSettingType;
(function (ThirdPartyLogisticsSettingType) {
    ThirdPartyLogisticsSettingType["THIRD_PARTY_WAREHOUSE_ID"] = "THIRD_PARTY_WAREHOUSE_ID";
    ThirdPartyLogisticsSettingType["THIRD_PARTY_CUSTOMER_ID"] = "THIRD_PARTY_CUSTOMER_ID";
    ThirdPartyLogisticsSettingType["CLIENT_ID"] = "CLIENT_ID";
    ThirdPartyLogisticsSettingType["CLIENT_SECRET"] = "CLIENT_SECRET";
    ThirdPartyLogisticsSettingType["USER_LOGIN_ID"] = "USER_LOGIN_ID";
    ThirdPartyLogisticsSettingType["QUALIFIER_FORMAT"] = "QUALIFIER_FORMAT";
    ThirdPartyLogisticsSettingType["QUALIFIER_SKU_SEPARATOR"] = "QUALIFIER_SKU_SEPARATOR";
    ThirdPartyLogisticsSettingType["TEST_OVERRIDE_ENABLED"] = "TEST_OVERRIDE_ENABLED";
})(ThirdPartyLogisticsSettingType = exports.ThirdPartyLogisticsSettingType || (exports.ThirdPartyLogisticsSettingType = {}));
var TimeDefinition;
(function (TimeDefinition) {
    TimeDefinition["UTC"] = "UTC";
    TimeDefinition["WALL"] = "WALL";
    TimeDefinition["STANDARD"] = "STANDARD";
})(TimeDefinition = exports.TimeDefinition || (exports.TimeDefinition = {}));
var WarehouseTypeEnum;
(function (WarehouseTypeEnum) {
    WarehouseTypeEnum["DIRECT_FULFILLMENT"] = "DIRECT_FULFILLMENT";
    WarehouseTypeEnum["THIRD_PARTY_LOGISTICS"] = "THIRD_PARTY_LOGISTICS";
    WarehouseTypeEnum["SALES_CHANNEL"] = "SALES_CHANNEL";
    WarehouseTypeEnum["DROPSHIP_VENDOR"] = "DROPSHIP_VENDOR";
    WarehouseTypeEnum["RETAIL_STORE"] = "RETAIL_STORE";
})(WarehouseTypeEnum = exports.WarehouseTypeEnum || (exports.WarehouseTypeEnum = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["OZ"] = "OZ";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
var WeightUnitOfMeasure;
(function (WeightUnitOfMeasure) {
    WeightUnitOfMeasure["CENTIMETER"] = "CENTIMETER";
    WeightUnitOfMeasure["METER"] = "METER";
    WeightUnitOfMeasure["KILOMETER"] = "KILOMETER";
    WeightUnitOfMeasure["INCH"] = "INCH";
    WeightUnitOfMeasure["FEET"] = "FEET";
    WeightUnitOfMeasure["YARDS"] = "YARDS";
    WeightUnitOfMeasure["GRAM"] = "GRAM";
    WeightUnitOfMeasure["KILOGRAM"] = "KILOGRAM";
    WeightUnitOfMeasure["OUNCE"] = "OUNCE";
    WeightUnitOfMeasure["POUND"] = "POUND";
})(WeightUnitOfMeasure = exports.WeightUnitOfMeasure || (exports.WeightUnitOfMeasure = {}));
